import {
  APP_TITLE,
  LANDING_BRIEF,
  LANDING_LANGUAGE_SELECTOR,
  LANDING_COUNTRY_SELECTOR,
  LANDING_TERMS,
  LANDING_TERMS_ERROR,
  LANDING_CAPTCHA_ERROR,
  BUTTON_PREV,
  BUTTON_NEXT,
  BUTTON_SUBMIT,
  MENU_FEEDBACK_FORM,
  MENU_FEEDBACK_STATUS,
  MENU_FORM_INTAKE,
  MENU_FORM_EVENT_DETAILS,
  MENU_FORM_PRODUCT_INFO,
  SYSTEM_FEEDBACK_FORM,
  SYSTEM_FEEDBACK_STATUS,
  FORM_TITLE,
  FORM_MANDATORY_FIELDS,
  APP_DESCRIPTION,
  SUBMIT_FEEDBACK,
  CHECK_SUBMITTED_FEEDBACK,
  BTN_LAUNCH_FORM,
  BTN_CHECK_STATUS,
  SELECT_RESPONSE,
  FUNCTION_ROLE,
  CUSTOMER_ACCOUNT_NUMBER,
  ENTER_CUSTOMER_ACCOUNT,
  HELP_CUSTOMER_ACCOUNT_NUMBER,
  EVENT_REPORTED,
  REFERENCE_NUMBER,
  ENTER_REFERENCE,
  WHO_REPORTED_TO,
  WHO_WAS_NOTIFIED,
  ENTER_NAME,
  PRODUCT_SURVEILLANCE,
  YOUR_NAME,
  OCCUPATION,
  PHONE_NUMBER,
  ENTER_PHONE_NUMBER,
  ENTER_EMAIL,
  EMAIL_ADDRESS,
  ENTER_ADDRESS,
  ENTER_NA_IF_UNKNOWN,
  FACILITY_HOSPITAL,
  ENTER_FACILITY,
  ADDRESS_1,
  ADDRESS_2,
  CITY,
  STATE,
  POSTAL_CODE,
  COUNTRY,
  END_USER_CUSTOMER,
  ADDITIONAL_CONTACT_PERSON,
  ADDITIONAL_PHONE,
  ADDITIONAL_EMAIL,
  ANOTHER_FACILITY_ADDRESS,
  ANOTHER_FACILITY_HOSPITAL,
  ANOTHER_ENTER_FACILITY,
  ANOTHER_ADDRESS_1,
  ANOTHER_ADDRESS_2,
  ANOTHER_CITY,
  ANOTHER_STATE,
  ANOTHER_POSTAL_CODE,
  ANOTHER_COUNTRY,
  LOT_SERIAL_NUMBER,
  ENTER_LOT_SERIAL_NUMBER,
  HELP_LOT_SERIAL_NUMBER,
  OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_PRODUCT_CODE,
  PRODUCT_CODE,
  ENTER_PRODUCT_CODE,
  HELP_PRODUCT_CODE,
  NDC,
  ENTER_NDC,
  UDI,
  ENTER_UDI,
  PRODUCT_NAME,
  ENTER_PRODUCT_NAME,
  HELP_PRODUCT_NAME,
  BEST_DESCRIBES,
  QUANTITY_TO_SELECT,
  ENTER_QUANTITY,
  HELP_QUANTITY,
  UNIT,
  AVAILABLE_TO_RETURNED,
  PHOTOGRAPH_AVAILABLE,
  HELP_PHOTOGRAPH_AVAILABLE,
  UPLOAD_IMAGES,
  REPORTER_NAME,
  REPORTER_FACILITY,
  REPORTER_OCCUPATION,
  ENTER_NUMBER,
  REPORTER_PHONE_NUMBER,
  REPORTER_EMAIL_ADDRESS,
  EMPLOYEE_NAME,
  EMPLOYEE_PHONE_NUMBER,
  EMPLOYEE_EMAIL_ADDRESS,
  RETURNING_FOR_INVESTIGATION,
  HELP_RETURNING_FOR_INVESTIGATION,
  UNUSED_BAXTER_PRODUCT,
  YOU_INDICATED_SAMPLES,
  SAMPLE_RETURN_KIT,
  A_BOX_WITH_A_PREPAID_LABEL,
  SAME_AS_MY_ADDRESS,
  OTHER_CONTACT_NAME,
  OTHER_CONTACT_OCCUPATION,
  OTHER_CONTACT_PHONE_NUMBER,
  OTHER_CONTACT_EMAIL_ADDRESS,
  MANUFACTURED_BY_ANOTHER_COMPANY,
  CUSTOMER_EXPLICITLY_REQUEST,
  EXPLICITLY_REQUEST_CREDIT,
  PRODUCT_FROM_BAXTER,
  QUANTITY_REQUESTED_CREDIT,
  ENTER_OCCUPATION,
  LOT_QUANTITY_NUMBER,
  WHOLESALERS_NAME,
  PLACE_WHOLESALERS_NAME,
  DATE_OF_EVENT,
  DATE_OF_EVENT_MSG,
  HELP_DATE_OF_EVENT,
  DATE_BAXTER_EMPLOYEE,
  DATE_MESSAGE_BAXTER_EMPLOYEE,
  DURING_WHAT_PROCESS,
  WAS_THE_PATIENT,
  WERE_YOU_CONNECTED,
  PROVIDE_ANY_ADDITIONAL,
  HELP_YOU_IDENTIFIED_MORE,
  ENTER_DETAILS,
  PROVIDE_ANY_ATTACHMENT,
  WAS_NEGATIVE_MEDICAL,
  WAS_MEDICAL_INTERVENTION,
  PROVIDE_DETAILS,
  REQUIRED_TREATMENT,
  ENTER_TREATMENT,
  RELEVANT_TESTS,
  HELP_RELEVANT_TESTS,
  RELEVANT_MEDICAL_HISTORY,
  ENTER_HISTORY,
  PATIENT_NAME,
  PATIENT_INITIALS,
  PATIENT_PHONE_NUMBER,
  PATIENT_EMAIL_ADDRESS,
  I_DO_NOT_WISH_TO_PROVIDE,
  PATIENT_ADDRESS,
  SAME_ADDRESS,
  DRUG_BEING_USED,
  PATIENT_IDENTIFIER,
  PATIENT_AGE_OR_DOB,
  ENTER_PATIENT_AGE,
  PATIENT_GENDER,
  PATIENT_WEIGHT,
  ENTER_WEIGHT,
  PATIENT_WEIGHT_UNIT,
  MY_NAME,
  ENTER_IN_YOUR_CONTACT,
  MY_PHONE_NUMBER,
  MY_EMAIL_ADDRESS,
  MY_ADDRESS,
  NAME_OF_BAXTER_DRUG,
  ENTER_DRUG_NAME,
  PLEASE_PROVIDE_THE_NAME,
  APPLY_TO_EACH_UNIT,
  SELECT_THE_COMPONENT,
  USE_THE_DIAGRAM,
  TYPE_OF_DAMAGE,
  PLEASE_ENTER_VALUE,
  WAS_THE_PRODUCT_KINKED,
  WERE_ANY_CLEANING,
  WHAT_WAS_THE_DISINFECTANT,
  NOTE_BAXTER_LABELING,
  SELECT_ALL_THAT_APPLY,
  DID_FOLLOWING_OCCUR,
  SELECT_THE_LOCATION,
  WAS_THE_PRODUCT_EXPOSED,
  HOW_LONG_TRANSFER,
  WAS_THERE_DIFFICULTY,
  WAS_DEVICE_OR_TOOL,
  DESCRIBE_HOW_PRODUCT,
  DID_YOU_OBSERVE,
  WERE_DIFFICULTIES_PUTTING,
  WAS_THE_TRANSFER,
  SELECT_TYPE_OF_FLOW,
  WAS_ANYTHING_BLOCKING,
  WAS_ANY_ALARM,
  SELECT_BEST_DESCRIBE,
  WERE_THE_MINICAPS,
  WAS_THE_SPONGE_VISIBLE,
  WHERE_PARTICULATE_MATTERFOREIGN,
  DESCRIBE_THE_EXACT_LOCATION,
  WAS_THE_PARTICULATE_MATTER,
  DOES_THE_PARTICULATE_MATER,
  WHAT_COMPONENT_DOES,
  SELECT_CONNECTION_ISSUE,
  WERE_ASSIST_DEVICES,
  WERE_ANY_DIFFICULTIES,
  PROVIDE_PRODUCT_INFORMATION,
  WERE_THE_SPIKE_LUER,
  BAXTER_LABELING_STATES,
  WERE_PETS_OR_ANIMALS,
  BAXTER_LABELING_CONTAMINATION,
  WERE_OTHER_ISSUES,
  WAS_MINICAP_TWISTED,
  WERE_DIFFICULTIES_TRANSFER_SET,
  DID_TRANSFER_SET_CONNECTORS,
  WHAT_WAS_THE_ALARM,
  WHERE_OBSERVED_DAMAGE,
  SELECT_THE_TYPE_OBSERVED,
  DID_DAMAGE_CAUSE_LEAK,
  WAS_THE_SHIPPING_CARTON,
  SELECT_FLOW_ISSUE_OBSERVED,
  HOW_LONG_WAS_STORAGE,
  WAS_THERE_AN_ADAPTER,
  NAME_AND_MODEL,
  NAME_VAPORIZER,
  WAS_VIAL_INVERTED,
  WHAT_VIAL_USED,
  DRUG_NAME_MANUFACTURER,
  WERE_BREAK_FRANGIBLE,
  WAS_ALARM_ASSOCIATED,
  WHAT_PART_DISCOLORED,
  DESCRIBE_DISCOLORATION,
  HOW_PRODUCT_STORED,
  DOES_DISCOLORATION_APPEAR,
  WHICH_CHAMBER_DISCOLORED,
  WAS_PEEL_SEAL_INTERCHAMBER,
  WAS_DISCOLORATION_NOTICED,
  SELECT_SPECIFICALLY_DESCRIBES,
  WHAT_DEVICE_HAD_ALARM,
  WHAT_MISSING_MISASSEMBLED,
  RECONSTITUTION_ISSUE,
  WHAT_MEDICATION_SOLUTION,
  WHAT_VOLUME_MEDICATION,
  WHAT_DEVICES_RECONSTITUTION,
  WAS_PRODUCT_EXPOSED_HEAT,
  DESCRIBE_EXPOSURE,
  WHAT_USED_ACTIVATE_SOLUTION,
  WAS_DAMAGE_OBSERVED,
  DESCRIBE_THE_DAMAGE,
  APPROXIMATELY_SOLUTION_POWDER,
  WAS_LEAK_OBSERVED,
  WHAT_FEATUR_DIFFICULT_USE,
  HOW_WAS_DIFFICULT_USE,
  WHERE_MATTER_FOREIGN,
  DOES_PARTICULATE_MATTER,
  DESCRIBE_EXACT_LOCATION,
  WAS_MATTER_FOREIGN,
  WHEN_MATTER_FOREIGN,
  PROVIDE_INFORMATION_MEDICATION,
  PRODUCT_NAME_CODE_NUMBER,
  DESCRIBE_SPIKING,
  INCLUDE_NEEDLE,
  WHAT_ADMINISTRATION_RECONSTITUTION,
  INCLUDE_MANUFACTURER,
  WAS_MEDICATION_ADDITIVE,
  WHAT_MEDICATION_ADDITIVE,
  WHAT_STATE_OF_PRODUCT,
  AFTER_UNITS_SAT,
  DID_ATTEMPT_AGITATE,
  DID_PRECIPITATE_DISSOLVE,
  WHAT_STORAGE_TEMPERATURE,
  PROVIDE_TEMPERATURE_LOCATION,
  ARE_TEMPERATURE_LOGS,
  LOGS_CAN_BE_ATTACHED,
  IS_THE_STORAGE_UNIT,
  HOW_PRODUCT_THAWED,
  WHAT_STORAGE_CONDITIONS,
  WAS_ANY_DAMAGE,
  MORE_SPECIFIC_INFORMATION,
  WHAT_PURPOSE_INDICATION,
  WHAT_ROUTE_ADMINISTRATION,
  WHAT_DATE_ADMINISTRATION,
  WHAT_DOSAGE_STRENGTH,
  WAS_RECENT_PRESCRIPTION,
  WHAT_WAS_STORAGE_TEMPERATURE,
  WERE_ANY_ADJUSTMENTS,
  SELECT_APPROPRIATE_DESCRIPTION,
  SELECT_LABELING_ISSUE,
  WAS_CONNECTION_SECURE,
  WAS_EXPIRED_PRODUCT,
  WAS_COMPONENT_DAMAGED,
  WERE_ABNORMALITIES_DAMAGE,
  WHAT_PURCHASE_ORDER_NUMBER,
  WHAT_DATE_OF_ADMINISTRATION,
  WHAT_WAS_EXPIRATION_DATE,
  DESCRIBE_WAS_INCORRECT,
  WHAT_SCANNER_USED,
  WAS_OVERPOUCH_POUCH,
  WHAT_BACKGROUND_COLOR,
  DO_ALL_OF_THE_LABELS,
  PRODUCT_INFORMATION,
  IS_A_BARCODE_SCANNER,
  HOW_ARE_THESE_PRODUCTS,
  WHAT_INFORMATION_INCORRECTLY,
  WAS_THERE_LEAK,
  WHERE_LEAK_OBSERVED,
  WAS_FRANGIBLE_OBSERVED,
  IS_MOISTURE_CLEAR,
  WHO_IS_YOUR_DISTRIBUTOR,
  WHAT_MANUFACTURER_MEDICATION,
  WHAT_GAUGE_NEEDLE,
  WHAT_ADMINISTRATION_SET,
  WAS_DIFFICULTY_SPIKING,
  WERE_FOLLOWING_SCENARIOS,
  WAS_FRANGIBLE_OBSERVED_DEFECT,
  WHAT_AMOUNT_PRESSURE,
  WAS_BAG_COMPLETELY,
  WHAT_MANUFACTURER_MODEL,
  WHAT_PRESSURE_PRIOR,
  LIST_THE_VAPORIZER,
  APPROXIMATELY_HOW_MUCH,
  WAS_THE_BOTTLE_DIFFICULT,
  WERE_VISIBLE_DEFECTS,
  SELECT_THE_OPTION,
  PROVIDE_INVOLVED_CONNECTION_ISSUE,
  WHICH_PART_SEPARATED,
  WHAT_COMPONENT_DISCOLORED,
  SELECT_DESCRIBES_DISCOLORATION,
  WAS_THE_SET_DISCOLORED,
  DID_SET_CHANGE_COLOR,
  WHAT_MEDICATION_ADDED,
  WHERE_MATERIAL_LOCATED,
  DESCRIBE_APPEARANCE_COLOR_SIZE,
  WAS_EMBEDDED_PLASTIC,
  WAS_THERE_A_PRECIPITATE,
  WHAT_MEDICATIONS_SOLUTIONS,
  WHERE_DAMAGE_COMPONENT_AFFECTED,
  WHAT_DAMAGE_ISSUE,
  DID_ISSUE_RESULT,
  WAS_PATIENT_CONNECTED,
  WAS_PRODUCT_REPLACED,
  WHICH_SITUATION_BEST,
  SELECT_MOST_LABELING_ISSUE,
  WHAT_INFORMATION_DISPLAYED,
  WHAT_SCANNER_WAS_USED,
  INCLUDE_THE_MODEL_NAME,
  WAS_PRODUCT_ORDERED,
  WHERE_LEAK_COMING,
  DID_SCENARIOS_OCCURRED_LEAK,
  WAS_POWER_INJECTOR,
  WHAT_INJECTOR_USED,
  MANUFACTURER_NAME_CODE_LOT,
  DESCRIBE_INCORRECT_INCOMPLETE,
  PROVIDE_INFORMATION_SECOND_PRODUCT,
  WHICH_COMPONENTS_WERE_FOUND,
  DESCRIBE_CUT_HOLE_SLICE,
  WAS_LEAK_ORIGINATING,
  PROVIDE_DISCONNECTION_CONNECTION,
  WHICH_SPECIFIC_BONDED,
  WERE_VISIBLE_IRREGULARITIES,
  WAS_SUCCESSFUL_CONNECTION,
  WAS_TOOL_USED_ASSIST,
  WERE_LUER_CONNECTIONS,
  WAS_PRODUCT_SECURELY,
  WHICH_DESCRIBES_FLOW_ISSUE,
  WHAT_FLOWING_BACKWARDS,
  DESCRIBE_COMPONENTS_BACKFLOW,
  DO_SITUATIONS_APPLY,
  WHICH_SPECIFIC_AREA,
  WAS_FLOW_PREVIOUSLY_SEEN,
  WAS_ANY_FOLLOWING_OBSERVED,
  WHERE_SIMULTANEOUS_FLOW,
  WHAT_TYPE_HANGER,
  WHAT_WAS_HANGER_LENGTH,
  WHICH_BAG_LOWER,
  WHAT_Y_SITE_WAS,
  WHAT_COMPONENT_WITHIN,
  WAS_COMPONENT_SET_REPLACED,
  WHAT_VOLUME_FLUID_PERIOD_TIME,
  WHAT_VOLUME_FLUID_OVER_TIME,
  WAS_USED_WITH_PUMP,
  DID_CLAMP_FAIL,
  WHAT_CLAMP_FAILED,
  WAS_ISSUES_OBSERVED_CLAMP,
  DO_OTHER_SITUATIONS_DESCRIBE,
  DESCRIBE_ALARM_OBSERVED,
  INCLUDE_ANY_MESSAGES,
  WHICH_CLAMP_HAD_ISSUE,
  WHICH_TYPE_CLAMP_ISSUE,
  SELECT_BEST_DESCRIBES_ISSUE,
  PROVIDE_MORE_DETAILS,
  PROVIDE_MORE_DETAILS_INSTRUCTIONS,
  DESCRIBE_THE_SMELL,
  WAS_ISSUES_WITH_SET,
  WHERE_LEAK_LOCATED,
  DID_OCCUR_WITH_LEAK,
  PROVIDE_INVOLVED_DISCONNECTION,
  DID_OCCURRED_WITH_THE_LEAK,
  WHERE_WAS_PRODUCT_DAMAGED,
  SELECT_ALL_APPLY,
  DESCRIBE_OBSERVED_DAMAGE,
  WHAT_COMPONENT_IS_DISCOLORED,
  DESCRIBE_HUE_TINT_SHADE,
  INSIDE_OUTSIDE_OVERPOUCH,
  DESCRIBE_EXACT_LOCATION_SIZE,
  DOES_THE_PARTICULATE_MATTER,
  WAS_PARTICULATE_MATERIAL_EMBEDDED,
  DOES_APPEAR_PRODUCT_MATERIAL,
  WHERE_DID_THE_ISSUE_OCCUR,
  LIST_COMPONENTS_IF,
  WERE_THERE_VISIBLE_IRREGULARITIES,
  SELECT_OPTION_FLOW_ISSUE,
  DESCRIBE_IRREGULARITIES,

  HOW_PRODUCT_SETUP,
  SELECT_MOST_APPROPRIATE_DESCRIPTION,
  DESCRIBE_WHAT_INCORRECT_INCOMPLETE,
  WAS_SHIPPING_CARTON_DAMAGED,
  WHAT_PRODUCT_WAS_SUPPOSED,
  IF_PRODUCT_CODE_NOT,
  WAS_THE_CASE_MISSING,
  WHAT_CARRIER_DELIVERED,
  WHAT_IS_PURCHASE_ORDER_NUMBER,
  WHAT_QUANTITY_MISSING_UNITS,
  WAS_EXPIRED_PRODUCT_USE,
  ADD_PRODUCT_TO_THE_GRID,
  SAVE,
  CANCEL,
  ADD_MORE_PRODUCTS,
  REPORTER_ADDRESS,
  ATTACHMENTS,
  COPYRIGHT,
  TERMS_CONDITIONS,
  PRIVACY_POLICY,
  COOKIE_POLICY,
  FORM_SUB_TITLE,
  OPTION_REPORTEROCCUPATIONOPTIONS_ASKED_UNKNOWN,
  OPTION_FUNCTIONOPTIONS_BAXTER_EMPLOYEE,
  OPTION_FUNCTIONOPTIONS_CAREGIVER,
  OPTION_FUNCTIONOPTIONS_DISTRIBUTOR,
  OPTION_FUNCTIONOPTIONS_HEALTHCARE_PROFESSIONAL,
  OPTION_FUNCTIONOPTIONS_PATIENT,
  OPTION_FUNCTIONOPTIONS_OTHER,
  OPTION_PROCESSSTEPOPTIONS_AFTER_USE,
  OPTION_PROCESSSTEPOPTIONS_BEFORE_USE,
  OPTION_PROCESSSTEPOPTIONS_DURING_SETUP_PREPARATION,
  OPTION_PROCESSSTEPOPTIONS_DURING_THERAPY,
  OPTION_PROCESSSTEPOPTIONS_MULTIPLE_STEPS,
  OPTION_PROCESSSTEPOPTIONS_NOT_SPECIFIED,
  OPTION_OCCUPATIONOPTIONS_FAMILY_MEMBER,
  OPTION_OCCUPATIONOPTIONS_NURSE,
  OPTION_OCCUPATIONOPTIONS_NURSE_PRACTITIONER,
  OPTION_OCCUPATIONOPTIONS_OTHER_HEALTH_CARE_PROFESSIONAL,
  OPTION_OCCUPATIONOPTIONS_PHYSICIAN,
  OPTION_UNITOPTIONS_BOXES,
  OPTION_UNITOPTIONS_PALLETS,
  OPTION_UNITOPTIONS_UNITS,
  OPTION_PROBLEMOPTIONS_ALARM_CONDITION,
  OPTION_PROBLEMOPTIONS_DAMAGE,
  OPTION_PROBLEMOPTIONS_DIFFICULT_TO_USE,
  OPTION_PROBLEMOPTIONS_DISCOLORED,
  OPTION_PROBLEMOPTIONS_FLOW_ISSUES,
  OPTION_PROBLEMOPTIONS_LABELING_ISSUES,
  OPTION_PROBLEMOPTIONS_LEAK_EXCESSIVE_MOISTURE,
  OPTION_PROBLEMOPTIONS_PARTICULATE_MATTER_FOREIGN_MATERIAL,
  OPTION_PROBLEMOPTIONS_PATIENT_REACTION_ADVERSE_EVENT,
  OPTION_PROBLEMOPTIONS_PRODUCT_INQUIRY,
  OPTION_PROBLEMOPTIONS_SEPARATION_CONNECTION,
  OPTION_PROBLEMOPTIONS_SHIPPING_ISSUES_EXPIRED_PRODUCT,
  OPTION_PATIENTSEXOPTIONS_FEMALE,
  OPTION_PATIENTSEXOPTIONS_UNDIFFERENTIATE,
  OPTION_PATIENTSEXOPTIONS_MALE,
  OPTION_PATIENTSEXOPTIONS_DECLINETOANSWER,
  OPTION_REPORTEROCCUPATIONOPTIONS_ADMINISTRATOR_SUPERVISOR,
  OPTION_REPORTEROCCUPATIONOPTIONS_BIOMEDICAL_ENGINEER,
  OPTION_REPORTEROCCUPATIONOPTIONS_COMPANY_REPRESENTATIVE,
  OPTION_REPORTEROCCUPATIONOPTIONS_DENTIST,
  OPTION_REPORTEROCCUPATIONOPTIONS_DISTRIBUTOR,
  OPTION_REPORTEROCCUPATIONOPTIONS_FAMILY_MEMBER,
  OPTION_REPORTEROCCUPATIONOPTIONS_LAY_USER,
  OPTION_REPORTEROCCUPATIONOPTIONS_NURSE,
  OPTION_REPORTEROCCUPATIONOPTIONS_NURSE_PRACTITIONER,
  OPTION_REPORTEROCCUPATIONOPTIONS_OTHER_HEALTH_CARE_PROFESSIONAL,
  OPTION_REPORTEROCCUPATIONOPTIONS_PHARMACIST,
  OPTION_REPORTEROCCUPATIONOPTIONS_PHARMACY_TECHNICIAN,
  OPTION_REPORTEROCCUPATIONOPTIONS_PHYSICIAN,
  OPTION_REPORTEROCCUPATIONOPTIONS_PATIENT,
  OPTION_REPORTEROCCUPATIONOPTIONS_RISK_MANAGER,
  OPTION_REPORTEROCCUPATIONOPTIONS_OTHER,
  OPTION_PRODUCTSURVEILLANCECONTACTOPTIONS_CONTACT_ADDITIONAL_CONTACT_PERSON,
  OPTION_PRODUCTSURVEILLANCECONTACTOPTIONS_CONTACT_ME,
  OPTION_PRODUCTSURVEILLANCECONTACTOPTIONS_CONTACT_OTHER,
  OPTION_REPORTEDTOOPTIONS_BAXTER,
  OPTION_REPORTEDTOOPTIONS_CHINA_FDA,
  OPTION_REPORTEDTOOPTIONS_EMA,
  OPTION_REPORTEDTOOPTIONS_FDA,
  OPTION_REPORTEDTOOPTIONS_HEALTH_CANADA,
  OPTION_REPORTEDTOOPTIONS_PMDA_JAPAN,
  OPTION_REPORTEDTOOPTIONS_TUV,
  OPTION_REPORTEDTOOPTIONS_TGA_AUSTRALIA,
  OPTION_FOLLOWINGOCCUROPTIONS_A_PET_OR_ANIMAL,
  OPTION_FOLLOWINGOCCUROPTIONS_A_SHARP_OBJECT,
  OPTION_FOLLOWINGOCCUROPTIONS_THE_PRODUCT_PROBLEM_OCCURRED,
  OPTION_FOLLOWINGOCCUROPTIONS_THE_PRODUCT_COLD_ENVIRONMENT,
  OPTION_DAMAGEMINICAPOPTIONS_CARTON,
  OPTION_DAMAGEMINICAPOPTIONS_MINICAP,
  OPTION_DAMAGEMINICAPOPTIONS_POUCH,
  OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_TIGHT,
  OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_LOOSE,
  OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_OPEN,
  OPTION_DIFFICULTTOUSEOPTIONS_THE_TWIST_CLAMP_OPEN,
  OPTION_DIFFICULTTOUSEOPTIONS_THE_TWIST_LAMP_CLOSE,
  OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_CLOSE,
  OPTION_DIFFICULTIESMINICAPOPTIONS_YES_THERE_WAS_DAMAGE,
  OPTION_DIFFICULTIESMINICAPOPTIONS_YES_THE_MINICAP,
  OPTION_FLOWISSUEOPTIONS_COMPLETELY_STOPPED,
  OPTION_FLOWISSUEOPTIONS_RESTRICTED_OR_PARTIALLY,
  OPTION_BLOCKINGFLOWOPTIONS_CLOTTED_BLOOD,
  OPTION_BLOCKINGFLOWOPTIONS_FIBRIN,
  OPTION_BLOCKINGFLOWOPTIONS_KINK,
  OPTION_BLOCKINGFLOWOPTIONS_PARTICULATE,
  OPTION_BLOCKINGFLOWOPTIONS_PRODUCT_MATERIAL,
  OPTION_DESCRIBEISSUEOPTIONS_EXCESS_IODINE,
  OPTION_DESCRIBEISSUEOPTIONS_EXCESS_MOISTURE,
  OPTION_DESCRIBEISSUEOPTIONS_FOIL_POUCH,
  OPTION_DESCRIBEISSUEOPTIONS_PACKAGE_BOX,
  OPTION_DESCRIBEISSUEOPTIONS_SPONGE_DRIED_OUT_AND_WHITE,
  OPTION_DESCRIBEISSUEOPTIONS_SPONGE_DRIED_OUT_BROWNISH_COLOR,
  OPTION_MATERIALLOCATEDOPTIONS_IN_THE_SECONDARY,
  OPTION_MATERIALLOCATEDOPTIONS_INSIDE_THE_PRODUCT_FLUID,
  OPTION_MATERIALLOCATEDOPTIONS_INSIDE_THE_SHIPPING,
  OPTION_MATERIALLOCATEDOPTIONS_ON_THE_OUTSIDE_OF_PRODUCT,
  OPTION_MATERIALLOCATEDOPTIONS_ON_THE_OUTSIDE_OF_OVERPOUCH,
  OPTION_MATERIALLOCATEDOPTIONS_ON_THE_EXTERIOR,
  OPTION_CONNECTIONISSUEOPTIONS_DIFFICULTIES_CONNECTING,
  OPTION_CONNECTIONISSUEOPTIONS_DIFFICULTIES_DISCONNECTING,
  OPTION_CONNECTIONISSUEOPTIONS_SEPARATION_OF_COMPONENTS,
  OPTION_CONNECTIONISSUEOPTIONS_SEPARATION_DISCONNECTION,
  OPTION_RESIDUETHREADSOPTIONS_YES_RESIDUE,
  OPTION_RESIDUETHREADSOPTIONS_YES_VISIBLE,
  OPTION_RESIDUETHREADSOPTIONS_YES_OTHER,
  OPTION_OBSERVEDDAMAGEOPTIONS_FRANGIBLE,
  OPTION_OBSERVEDDAMAGEOPTIONS_HANGER_HOLE,
  OPTION_OBSERVEDDAMAGEOPTIONS_INJECTION_FILLING_PORT,
  OPTION_OBSERVEDDAMAGEOPTIONS_MEMBRANE_PORT,
  OPTION_OBSERVEDDAMAGEOPTIONS_OVERPOUCH_POUCH,
  OPTION_OBSERVEDDAMAGEOPTIONS_PATCH,
  OPTION_OBSERVEDDAMAGEOPTIONS_RUBBER_STOPPER,
  OPTION_OBSERVEDDAMAGEOPTIONS_SHIPPING_CARTON,
  OPTION_OBSERVEDDAMAGEOPTIONS_SHRINKBAND,
  OPTION_OBSERVEDDAMAGEOPTIONS_SOLUTION_CONTAINER,
  OPTION_OBSERVEDDAMAGEOPTIONS_TIP_PROTECTOR,
  OPTION_OBSERVEDDAMAGEOPTIONS_TAMPER_EVIDENT_SEAL,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_BENT,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_BROKEN,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_CRACKED,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_CUT,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_DEFORMED,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_FLAKING,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_HOLE,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_KINKED,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_MELTED,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_PATCH_LAYER_SEPARATION,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_SHATTERED_GLASS,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_SLICED,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_TORN,
  OPTION_FLOWISSUEOBSERVEDOPTIONS_SOLUTION_WOULD_NOT_FLOW,
  OPTION_FLOWISSUEOBSERVEDOPTIONS_SOLUTION_WOULD_FLOW,
  OPTION_FLOWISSUEOBSERVEDOPTIONS_SOLUTION_WOULD_COMPOUNDING,
  OPTION_PRODUCTDISCOLOREDOPTIONS_BOTTLE,
  OPTION_PRODUCTDISCOLOREDOPTIONS_CONTAINER,
  OPTION_PRODUCTDISCOLOREDOPTIONS_HANGER_HOLE,
  OPTION_PRODUCTDISCOLOREDOPTIONS_LINER,
  OPTION_PRODUCTDISCOLOREDOPTIONS_OVERPOUCH_POUCH,
  OPTION_PRODUCTDISCOLOREDOPTIONS_OXYGEN_INDICATOR,
  OPTION_PRODUCTDISCOLOREDOPTIONS_PATCH,
  OPTION_PRODUCTDISCOLOREDOPTIONS_PORTS,
  OPTION_PRODUCTDISCOLOREDOPTIONS_SOLUTION,
  OPTION_PRODUCTDISCOLOREDOPTIONS_TIP_PROTECTOR,
  OPTION_CHAMBERDISCOLOREDOPTIONS_AMINO_ACID_CHAMBER,
  OPTION_CHAMBERDISCOLOREDOPTIONS_DEXTROSE_CHAMBER,
  OPTION_CHAMBERDISCOLOREDOPTIONS_LIPID_CHAMBER,
  OPTION_CHAMBERDISCOLOREDOPTIONS_LOWER_CHAMBER,
  OPTION_CHAMBERDISCOLOREDOPTIONS_UPPER_CHAMBER,
  OPTION_SPECIFICALLYDESCRIBESOPTIONS_BURST_RUPTURED_SEAL,
  OPTION_SPECIFICALLYDESCRIBESOPTIONS_MISASSEMBLED_PRODUCT_PART,
  OPTION_SPECIFICALLYDESCRIBESOPTIONS_MISSING_COMPONENT,
  OPTION_WHATTYPEDAMAGEISSUEOPTIONS_SEPARATION_DISCONNECTION_OF,
  OPTION_SPECIFICALLYDESCRIBESOPTIONS_PRODUCT_OVER_FILLED,
  OPTION_SPECIFICALLYDESCRIBESOPTIONS_PRODUCT_UNDER_FILLED,
  OPTION_SPECIFICALLYDESCRIBESOPTIONS_RECONSTITUTION,
  OPTION_MATTERFOREIGNMATERIALOPTIONS_INSIDE_SOLUTION,
  OPTION_MATTERFOREIGNMATERIALOPTIONS_INSIDE_THE_VAPORIZER,
  OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_XTERNAL_SURFACE,
  OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_OUTSIDE,
  OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_OXYGEN,
  OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_TRANSDERMAL,
  OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_FRANGIBLE,
  OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_GLASS_PARTICLES,
  OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_PORT,
  OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_RUBBER_STOPPER,
  OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_TUBING,
  OPTION_WHENMATERIALOBSERVEDOPTIONS_AFTER_ADDING_ANOTHER,
  OPTION_WHENMATERIALOBSERVEDOPTIONS_AFTER_PRIOR_TO_SPIKING,
  OPTION_CLOUDINESSOBSERVEDOPTIONS_COLD_THAWED,
  OPTION_CLOUDINESSOBSERVEDOPTIONS_FROZEN,
  OPTION_CLOUDINESSOBSERVEDOPTIONS_PARTIALLY_THAWED,
  OPTION_CLOUDINESSOBSERVEDOPTIONS_ROOM_TEMPERATURE,
  OPTION_PRODUCTTHAWEDOPTIONS_BAXTER_THAWING,
  OPTION_PRODUCTTHAWEDOPTIONS_LEFT_ON_COUNTER,
  OPTION_PRODUCTTHAWEDOPTIONS_REFRIGERATOR,
  OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_EVIDENCE,
  OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_LEAK_OBSERVED,
  OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_HOLE_OR_INCOMPLETE,
  OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_DIFFICULTY_SPIKING,
  OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_DIFFICULTY_BREAKING,
  OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_THERE_WAS_CRYSTALLIZATION,
  OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_THERE_WAS_CLOUDINESS,
  OPTION_DAMAGESPECIFICINFOOPTIONS_PRODUCT_DID_NOT,
  OPTION_DAMAGESPECIFICINFOOPTIONS_UNINTENDED_EFFECT,
  OPTION_SCENARIOSLEAKOPTIONS_OPTION_APPROPRIATEDESCRIPTIONOPTIONS_DAMAGED_SHIPPING,
  OPTION_APPROPRIATEDESCRIPTIONOPTIONS_EXPIRED_PRODUCT_DELIVERED,
  OPTION_APPROPRIATEDESCRIPTIONOPTIONS_EXPIRED_PRODUCT_FOUND,
  OPTION_LABELINGISSUEOPTIONS_BARCODE_ISSUE,
  OPTION_LABELINGISSUEOPTIONS_DIFFICULTIES_SCANNING,
  OPTION_LABELINGISSUEOPTIONS_EXPIRED_PRODUCT_DELIVERED,
  OPTION_LABELINGISSUEOPTIONS_EXPIRED_PRODUCT_INVENTORY,
  OPTION_LABELINGISSUEOPTIONS_EXPIRED_ILLEGIBLE_LABEL,
  OPTION_LABELINGISSUEOPTIONS_INCORRECT_LABEL,
  OPTION_LABELINGISSUEOPTIONS_INCOMPLETE_LABEL,
  OPTION_LABELINGISSUEOPTIONS_ILABEL_TOO_SIMILAR,
  OPTION_LABELINGISSUEOPTIONS_LABELS_PRODUCT,
  OPTION_LABELINGISSUEOPTIONS_MISSING_BARCODE,
  OPTION_DESCOFISSUEOPTIONS_CARTON_BOX,
  OPTION_DESCOFISSUEOPTIONS_DAMAGED_SHIPPING,
  OPTION_DESCOFISSUEOPTIONS_EXTRA_UNITS_WERE_RECEIVED,
  OPTION_DESCOFISSUEOPTIONS_EXPIRED_PRODUCT_DELIVERED,
  OPTION_DESCOFISSUEOPTIONS_EXPIRED_PRODUCT_FOUND,
  OPTION_DESCOFISSUEOPTIONS_PART_OF_THE_CARTON,
  OPTION_DESCOFISSUEOPTIONS_PRODUCT_INFO_ON_THE_CARTON,
  OPTION_DESCOFISSUEOPTIONS_UNITS_WERE_MISSING,
  OPTION_DESCOFISSUEOPTIONS_OTHER,
  OPTION_LABELINGISSUEOPTIONS_MISSING_LABEL,
  OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_EXPIRATION_DATE,
  OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_LOT_NUMBER,
  OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_NDC_NUMBER,
  OPTION_MOISTUREOBSERVEDOPTIONS_DROPLETS_MOISTURE,
  OPTION_MOISTUREOBSERVEDOPTIONS_LEAK,
  OPTION_MOISTUREOBSERVEDOPTIONS_LEAK_OBSERVED,
  OPTION_MOISTUREOBSERVEDOPTIONS_SOLUTION_FLOWING,
  OPTION_MOISTUREOBSERVEDOPTIONS_SOLUTION_INSIDE,
  OPTION_COMPONENTLEAKINGOPTIONS_BETWEEN_OVERPOUCH,
  OPTION_COMPONENTLEAKINGOPTIONS_CONNECTION_BETWEEN,
  OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER_MEMBRANE,
  OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER_INJECTION,
  OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER_HANGER,
  OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER,
  OPTION_COMPONENTLEAKINGOPTIONS_FRANGIBLE,
  OPTION_COMPONENTLEAKINGOPTIONS_RUBBER_STOPPER,
  OPTION_COMPONENTLEAKINGOPTIONS_SHRINKBAND,
  OPTION_COMPONENTLEAKINGOPTIONS_TIP_PROTECTOR,
  OPTION_COMPONENTLEAKINGOPTIONS_UNKNOWN,
  OPTION_COMPONENTLEAKINGOPTIONS_VIAL_ADAPTER,
  OPTION_SCENARIOSLEAKOPTIONS_ADHERED_PORT,
  OPTION_SCENARIOSLEAKOPTIONS_DAMAGE_HOLES,
  OPTION_SCENARIOSLEAKOPTIONS_EXPOSURE_TO_EXTREME,
  OPTION_SCENARIOSLEAKOPTIONS_LEAK_AT_VAPORIZER,
  OPTION_SCENARIOSLEAKOPTIONS_OPENING_SHIPPING,
  OPTION_SCENARIOSLEAKOPTIONS_PETS_CLAWED,
  OPTION_SCENARIOSLEAKOPTIONS_SOLUTION_BAG_UNDER,
  NO_DESCRIBE_THE_COLOR,
  OPTION_LIQUIDSPILLEDOPTIONS_ML,
  OPTION_LIQUIDSPILLEDOPTIONS_GREATER_THAN_ML,
  OPTION_LIQUIDSPILLEDOPTIONS_LESS_THAN_ML,
  OPTION_VISIBLEDEFECTSOPTIONS_BOTTLE,
  OPTION_VISIBLEDEFECTSOPTIONS_CAP,
  OPTION_VISIBLEDEFECTSOPTIONS_VALVE_NECK,
  OPTION_VISIBLEDEFECTSOPTIONS_NONE,
  OPTION_OPTIONCONNECTIONISSUEOPTIONS_CONNECTING,
  OPTION_OPTIONCONNECTIONISSUEOPTIONS_DISCONNECTING,
  OPTION_OPTIONCONNECTIONISSUEOPTIONS_SEPARATION_OF_COMPONENTS,
  OPTION_OPTIONCONNECTIONISSUEOPTIONS_SEPARATION_DISCONNECTION,
  OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_DRIP_CHAMBER,
  OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_TUBING,
  OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_UNKNOWN,
  OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_OTHER_PLEASE_SPECIFY,
  OTHER_PLEASE_SPECIFY,
  OPTION_DESCRIBESDISCOLORATIONOPTIONS_WHITE_CLOUDY,
  OPTION_DESCRIBESDISCOLORATIONOPTIONS_YELLOW_BROWNISH,
  OPTION_DESCRIBESDISCOLORATIONOPTIONS_OTHER_PLEASE_SPECIFY,
  OPTION_WHEREMATTERLOCATEDOPTIONS_IN_THE_PRIMARY_PACKAGING,
  OPTION_WHEREMATTERLOCATEDOPTIONS_INSIDE_THE_IV,
  OPTION_WHEREMATTERLOCATEDOPTIONS_INSIDE_THE_SHIPPING,
  OPTION_WHEREMATTERLOCATEDOPTIONS_ON_THE_EXTERIOR,
  OPTION_WHEREMATTERLOCATEDOPTIONS_OUTSIDE_THE_IV,
  OPTION_EMBEDDEDPLASTICOPTIONS_EMBEDDED,
  OPTION_EMBEDDEDPLASTICOPTIONS_LOOSE,
  OPTION_EMBEDDEDPLASTICOPTIONS_NOT_APPLICABLE,
  OPTION_INFUSATESOLUTIONOPTIONS_DESCRIBE_COLOR,
  OPTION_INFUSATESOLUTIONOPTIONS_YES_CHANGE_IN_COLOR,
  OPTION_INFUSATESOLUTIONOPTIONS_YES_PRECIPITATE,
  OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_ACCESS_SITE,
  OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_BURRETTES,
  OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_CLAMP,
  OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_DRIP_CHAMBER,
  OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_TUBING,
  DAMAGECOMPONENTAFFECTEDOPTIONS_UNKNOWN,
  DAMAGECOMPONENTAFFECTEDOPTIONS_OTHER,
  OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_FILTERS,
  OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_LUER_CONNECTOR,
  OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_SPIKE,
  OPTION_WHATTYPEDAMAGEISSUEOPTIONS_CUT_CRACKED_BROKEN,
  OPTION_WHATTYPEDAMAGEISSUEOPTIONS_INCORRECT_COMPONENT_ASSEMBLY,
  OPTION_WHATTYPEDAMAGEISSUEOPTIONS_KINKED_COLLAPSED,
  OPTION_WHATTYPEDAMAGEISSUEOPTIONS_LOOSE_COMPONENT,
  OPTION_WHATTYPEDAMAGEISSUEOPTIONS_MALFORMED_MIS_SHAPED,
  OPTION_WHATTYPEDAMAGEISSUEOPTIONS_MISSING_COMPONENT,
  OPTION_SITUATIONDESCRIBESISSUEOPTIONS_DIFFICULTY_CONNECTING_THE,
  OPTION_SITUATIONDESCRIBESISSUEOPTIONS_DIFFICULTY_DISCONNECTING_THE,
  OPTION_SITUATIONDESCRIBESISSUEOPTIONS_LOOSE_CONNECTION,
  OPTION_SITUATIONDESCRIBESISSUEOPTIONS_SEPARATION_DISCONNECTION,
  OPTION_SITUATIONDESCRIBESISSUEOPTIONS_SEPARATION_BETWEEN_TWO,
  OPTION_SITUATIONDESCRIBESISSUEOPTIONS_UNABLE_TO_CONNECT,
  OPTION_SITUATIONDESCRIBESISSUEOPTIONS_UNABLE_TO_DISCONNECTT,
  OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_BARCODE_ISSUE,
  OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_CHANGE_IN_LABELING,
  OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_DIFFICULTIES_SCANNING,
  OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_OTHER,
  OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_EXPIRED_PRODUCT,
  OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_INCORRECT_INFORMATION_ON_LABEL,
  OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_MISSING_BARCODE_UDI,
  OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_MISSING_INFORMATION_ON_LABEL,
  OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_PRODUCT_WITH_NO_EXPIRATION,
  OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_SMUDGES_ILLEGIBLE_LABELING,
  OPTION_APPROPRIATEDESCISSUEOPTIONS_CARTON_BOX,
  OPTION_APPROPRIATEDESCISSUEOPTIONS_DAMAGED_SHIPPING,
  OPTION_APPROPRIATEDESCISSUEOPTIONS_EXPIRED_PRODUCT_DELIVERED,
  OPTION_APPROPRIATEDESCISSUEOPTIONS_EXPIRED_PRODUCT_FOUND,
  OPTION_APPROPRIATEDESCISSUEOPTIONS_OTHER,
  OPTION_ORDEREDFROMBAXTEROPTIONS_BAXTER,
  OPTION_ORDEREDFROMBAXTEROPTIONS_DISTRIBUTOR,
  OPTION_APPROPRIATEDESCISSUEOPTIONS_EXTRA_UNITS_WERE_RECEIVED,
  OPTION_APPROPRIATEDESCISSUEOPTIONS_PART_OF_THE_CARTON,
  OPTION_APPROPRIATEDESCISSUEOPTIONS_PRODUCT_INFO_ON_THE_CARTON,
  OPTION_APPROPRIATEDESCISSUEOPTIONS_UNITS_WERE_MISSING,
  OPTION_LEAKCOMINGFROMOPTIONS_ACCESS_SITE,
  OPTION_LEAKCOMINGFROMOPTIONS_AIR_VENT,
  OPTION_LEAKCOMINGFROMOPTIONS_BURETTES,
  OPTION_LEAKCOMINGFROMOPTIONS_CAP,
  OPTION_LEAKCOMINGFROMOPTIONS_CLEARLINK_INJECTION_SITES,
  OPTION_LEAKCOMINGFROMOPTIONS_CLAMP,
  OPTION_LEAKCOMINGFROMOPTIONS_DRIP_CHAMBER,
  OPTION_LEAKCOMINGFROMOPTIONS_FILTERS,
  OPTION_LEAKCOMINGFROMOPTIONS_INTERLINK_INJECTION_SITES,
  OPTION_LEAKCOMINGFROMOPTIONS_LUER_CONNECTOR,
  OPTION_LEAKCOMINGFROMOPTIONS_SPIKE,
  OPTION_LEAKCOMINGFROMOPTIONS_TUBING,
  OPTION_LEAKCOMINGFROMOPTIONS_UNKNOWN,
  OPTION_LEAKCOMINGFROMOPTIONS_OTHER,
  OPTION_LEAKCOMINGFROMOPTIONS_LEAK_BETWEEN_THE,
  OPTION_LEAKCOMINGFROMOPTIONS_NEEDLE_BASED,
  OPTION_LEAKCOMINGFROMOPTIONS_ONE_LINK_INJECTION,
  OPTION_LEAKCOMINGFROMOPTIONS_OTHER_INJECTION,
  OPTION_FOLLOWINGSCENARIOSOPTIONS_CRACK_BREAK_IN,
  OPTION_FOLLOWINGSCENARIOSOPTIONS_CUT_SLICE_IN,
  DISCONNECTION_OF_CONNECTABLE,
  OPTION_FOLLOWINGSCENARIOSOPTIONS_DISCONNECTION_OF_CONNECTABLE,
  OPTION_FOLLOWINGSCENARIOSOPTIONS_SEPARATION_OF_BONDED_COMPONENTS,
  OPTION_VISIBLEIRREGULARITIESOPTIONS_YES_DESCRIBE_IRREGULARITIES,
  YES_SPECIFY_THE_TOOL,
  OPTION_SITUATIONFLOWISSUEOPTIONS_BACKFLOW,
  OPTION_SITUATIONFLOWISSUEOPTIONS_CLAMP_FAILURE_DIFFICULT,
  OPTION_SITUATIONFLOWISSUEOPTIONS_CLAMP_FAILURE_UNABLE,
  OPTION_SITUATIONFLOWISSUEOPTIONS_CLAMP_FAILURE_DIFFICULT_UNABLE,
  OPTION_SITUATIONFLOWISSUEOPTIONS_NO_FLOW,
  OPTION_SITUATIONFLOWISSUEOPTIONS_OVER_INFUSION,
  OPTION_SITUATIONFLOWISSUEOPTIONS_RESTRICTED_SLOW,
  OPTION_SITUATIONFLOWISSUEOPTIONS_SIMULTANEOUS_FLOW,
  OPTION_SITUATIONFLOWISSUEOPTIONS_UNABLE_TO_CLEAR,
  OPTION_SITUATIONFLOWISSUEOPTIONS_UNABLE_TO_PRIME,
  OPTION_SITUATIONFLOWISSUEOPTIONS_UNDER_INFUSION,
  OPTION_FLOWINGBACKWARDSOPTIONS_PATIENTS_BLOOD,
  OPTION_FLOWINGBACKWARDSOPTIONS_SOLUTIONS_BLOOD,
  OPTION_SITUATIONSAPPLYEVENTOPTIONS_DAMAGE_HOLE,
  OPTION_SITUATIONSAPPLYEVENTOPTIONS_DISCONNECTION,
  OPTION_SITUATIONSAPPLYEVENTOPTIONS_LEAK,
  OPTION_SITUATIONSAPPLYEVENTOPTIONS_MEDICATION_WAS_BEING,
  OPTION_SITUATIONSAPPLYEVENTOPTIONS_SECONDARY_BAG_WAS_LOWER,
  OPTION_SITUATIONSAPPLYEVENTOPTIONS_SECONDARY_BAG_WAS_AT,
  OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_BLOOD_CLOTTING,
  OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_CATHETER_WAS,
  OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_KINKED_TUBING,
  OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_TUBING_INJECTION,
  OPTION_SIMULTANEOUSFLOWOPTIONS_PRIMARY_AND_SECONDARY,
  OPTION_SIMULTANEOUSFLOWOPTIONS_TWO_OR_MORE_LEADS,
  OPTION_SIMULTANEOUSFLOWOPTIONS_TWO_ADMINISTRATION,
  OPTION_HANGERUSEDOPTIONS_BAXTER_HANGER,
  OPTION_HANGERUSEDOPTIONS_NON_BAXTER_HANGER,
  OPTION_BAGLOWEROPTIONS_BAGS_WERE_AT,
  OPTION_BAGLOWEROPTIONS_PRIMARY,
  OPTION_BAGLOWEROPTIONS_SECONDARY,
  OPTION_YSITECONNECTEDOPTIONS_MIDDLE,
  OPTION_YSITECONNECTEDOPTIONS_LOWER,
  OPTION_YSITECONNECTEDOPTIONS_UPPER,
  OPTION_WITHPUMPOPTIONS_YES_PROVIDE_NAME,
  OPTION_WHATCLAMPFAILEDOPTIONS_DARK_BLUE,
  OPTION_WHATCLAMPFAILEDOPTIONS_LIGHT_BLUE,
  OPTION_WHATCLAMPFAILEDOPTIONS_NOTCH_CLAMP,
  OPTION_WHATCLAMPFAILEDOPTIONS_ROLLER_CLAMP,
  OPTION_WHATCLAMPFAILEDOPTIONS_WHITE_SLIDE_CLAMP,
  OPTION_ISSUESOBSERVEDCLAMPOPTIONS_YES_THE_CLAMP,
  OPTION_OTHERSITUATIONSPRODUCTOPTIONS_AIR_IN_LINE,
  OPTION_OTHERSITUATIONSPRODUCTOPTIONS_CLAMP_ISSUE,
  OPTION_OTHERSITUATIONSPRODUCTOPTIONS_ODOR,
  OPTION_OTHERSITUATIONSPRODUCTOPTIONS_OTHER,
  OPTION_WHICHCLAMPISSUEOPTIONS_NOTCH_PINCH,
  OPTION_WHICHCLAMPISSUEOPTIONS_ROLLER_CLAMP,
  OPTION_WHICHCLAMPISSUEOPTIONS_SLIDE_CLAMP,
  OPTION_WHICHCLAMPISSUEOPTIONS_UNKNOWN,
  OPTION_WHICHCLAMPISSUEOPTIONS_OTHER,
  OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_CRACKED_BROKEN,
  OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_DIFFICULT_TO_OPEN,
  OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_DIFFICULT_TO_CLOSE,
  OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_MISSING,
  OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNABLE_TO_OPEN,
  OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNABLE_TO_CLOSE,
  OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNABLE_TO_CONTROL,
  OPTION_CLAMPDESCRIBESISSUEOPTIONS_DIFFICULT_TO_SQUEEZE,
  OPTION_CLAMPDESCRIBESISSUEOPTIONS_INSTRUCTIONS_WERE,
  OPTION_CLAMPDESCRIBESISSUEOPTIONS_PRODUCT_WAS_DIFFICULT,
  OPTION_LEAKOCCUROPTIONS_CRACK_BREAK,
  OPTION_LEAKOCCUROPTIONS_CUT_SLICE,
  OPTION_LEAKOCCUROPTIONS_DISCONNECTION_OF_CONNECTABLE,
  OPTION_LEAKOCCUROPTIONS_HOLE_TEA,
  OPTION_LEAKOCCUROPTIONS_SEPARATION_OF_BONDED,
  OPTION_LEAKOCCUROPTIONS_OTHER,
  OPTION_LEAKSCENARIOSOPTIONS_ADHERED_PORT,
  OPTION_LEAKSCENARIOSOPTIONS_DAMAGE_HOLES,
  OPTION_LEAKSCENARIOSOPTIONS_DAMAGED_SHIPPING_CARTON,
  OPTION_LEAKSCENARIOSOPTIONS_EXPOSURE_TO_EXTREME,
  OPTION_LEAKSCENARIOSOPTIONS_OPENING_SHIPPING,
  OPTION_LEAKSCENARIOSOPTIONS_UNKNOWN,
  OPTION_LEAKSCENARIOSOPTIONS_NONE_OF_THE_ABOVE,
  OPTION_LEAKSCENARIOSOPTIONS_PRESSURE_CUFF,
  OPTION_LEAKSCENARIOSOPTIONS_PETS_CLAWED_CHEWED,
  OPTION_PRODUCTDAMAGEDOPTIONS_PRODUCT,
  OPTION_PRODUCTDAMAGEDOPTIONS_SHIPPING_CARTON_BOX,
  OPTION_MATTERFOREIGNLOCATEDOPTIONS_INSIDE_THE_PRODUCT,
  OPTION_MATTERFOREIGNLOCATEDOPTIONS_INSIDE_THE_SHIPPING,
  OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_OUTSIDE_OF_PRODUCT,
  OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_DIFFICULTIES_CONNECTING,
  OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_DIFFICULTIES_DISCONNECTING,
  OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_LOOSE_CONNECTION,
  OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_SEPARATION_OF_COMPONENTS,
  OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_SEPARATION_DISCONNECTION,
  OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_EXTERIOR,
  OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_INSIDE_OF,
  OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_OUTSIDE_OF,
  OPTION_OPTIONFLOWISSUEOPTIONS_NOT_FLOWING,
  OPTION_OPTIONFLOWISSUEOPTIONS_RESTRICTED_OR,
  OPTION_OPTIONFLOWISSUEOPTIONS_OTHER,
  OPTION_MOSTAPPROLABELINGISSUEOPTIONS_BARCODE_ISSUE,
  OPTION_MOSTAPPROLABELINGISSUEOPTIONS_DIFFICULTIES_SCANNING,
  OPTION_MOSTAPPROLABELINGISSUEOPTIONS_ILLEGIBLE_LABEL,
  OPTION_MOSTAPPROLABELINGISSUEOPTIONS_INCORRECT_LABEL,
  OPTION_MOSTAPPROLABELINGISSUEOPTIONS_INCOMPLETE_LABEL,
  OPTION_MOSTAPPROLABELINGISSUEOPTIONS_LABELS_PRODUCT,
  OPTION_MOSTAPPROLABELINGISSUEOPTIONS_LABEL_TOO_SIMILAR,
  OPTION_MOSTAPPROLABELINGISSUEOPTIONS_MISSING_LABEL,
  OPTION_MOSTAPPROLABELINGISSUEOPTIONS_MISSING_BARCODE,
  OPTION_MOSTAPPROLABELINGISSUEOPTIONS_OTHER,
  OPTION_DESCOFISSUEOPTIONS_FROZEN_PRODUCT,
  OPTION_DESCOFISSUEOPTIONS_THAWED_PRODUCT,
  OPTION_ALARMOPTIONS_YES_ALARM_NOT_KNOWN,
  OPTION_ALARMOPTIONS_YES_SPECIFY,
  OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TRANSFER_FULLY_OPEN,
  OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TRANSFER_FULLY_CLOSED,
  OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TWIST_OPEN_AT_ALL,
  OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TWIST_CLOSE_AT_ALL,
  OPTION_COMPONENTHADISSUEOPTIONS_BOX_OR_OVERPOUCH,
  OPTION_COMPONENTHADISSUEOPTIONS_BLUE_CLAMP_ON,
  OPTION_COMPONENTHADISSUEOPTIONS_CASSETT,
  OPTION_COMPONENTHADISSUEOPTIONS_DRAIN_LINE,
  OPTION_COMPONENTHADISSUEOPTIONS_EFFLUENT_SAMPLE,
  OPTION_COMPONENTHADISSUEOPTIONS_LINES,
  OPTION_COMPONENTHADISSUEOPTIONS_LUER_SPIKE,
  OPTION_COMPONENTHADISSUEOPTIONS_ORGANIZER,
  OPTION_COMPONENTHADISSUEOPTIONS_PULL_RING_PATIENT_LINE,
  OPTION_COMPONENTHADISSUEOPTIONS_PULL_RING_PROTECTORS,
  OPTION_COMPONENTHADISSUEOPTIONS_RED_CLAMP_ON,
  OPTION_COMPONENTHADISSUEOPTIONS_TACK_WELD,
  OPTION_COMPONENTHADISSUEOPTIONS_WHITE_CLAMP_ON_SUPPLY,
  OPTION_SELECTCOMPONENTHADISSUEOPTIONS_BEIGE_CATHETER,
  OPTION_SELECTCOMPONENTHADISSUEOPTIONS_CHIP_INSERT,
  OPTION_SELECTCOMPONENTHADISSUEOPTIONS_DARK_BLUE_CONNECTOR,
  OPTION_SELECTCOMPONENTHADISSUEOPTIONS_LIGHT_BLUE_MAIN,
  OPTION_SELECTCOMPONENTHADISSUEOPTIONS_LIGHT_BLUE_PULL,
  OPTION_SELECTCOMPONENTHADISSUEOPTIONS_LIGHT_BLUE_OCCLUDER,
  OPTION_SELECTCOMPONENTHADISSUEOPTIONS_SILICONE_TUBING,
  OPTION_SELECTCOMPONENTHADISSUEOPTIONS_TITANIUM_SPIKE,
  OPTION_SELECTCOMPONENTHADISSUEOPTIONS_UV_FLASH_SPIKE,
  OPTION_SELECTCOMPONENTHADISSUEOPTIONS_WHITE_TWIST_CLAMP,
  OPTION_ANYCOMPONENTDAMAGEDOPTIONS_YES_DESCRIBE_THE_DAMAGE,
  OPTION_MONTHOPTIONS_JAN,
  OPTION_MONTHOPTIONS_FEB,
  OPTION_MONTHOPTIONS_MAR,
  OPTION_MONTHOPTIONS_APR,
  OPTION_MONTHOPTIONS_MAY,
  OPTION_MONTHOPTIONS_JUN,
  OPTION_MONTHOPTIONS_JUL,
  OPTION_MONTHOPTIONS_AUG,
  OPTION_MONTHOPTIONS_SEP,
  OPTION_MONTHOPTIONS_OCT,
  OPTION_MONTHOPTIONS_NOV,
  OPTION_MONTHOPTIONS_DEC,
  OPTION_SCENARIOSWITHLEAKOPTIONS_ADHERED_PORT,
  OPTION_SCENARIOSWITHLEAKOPTIONS_DAMAGE_HOLES,
  OPTION_SCENARIOSWITHLEAKOPTIONS_DAMAGED_SHIPPING,
  OPTION_SCENARIOSWITHLEAKOPTIONS_EXPOSURE_TO_EXTREME,
  OPTION_SCENARIOSWITHLEAKOPTIONS_LEAK_AT_VAPORIZER,
  OPTION_SCENARIOSWITHLEAKOPTIONS_OPENING_SHIPPING,
  OPTION_SCENARIOSWITHLEAKOPTIONS_PETS_CLAWED,
  OPTION_SCENARIOSWITHLEAKOPTIONS_SOLUTION_BAG_UNDER,
  OPTION_SCENARIOSWITHLEAKOPTIONS_UNKNOWN,
  OPTION_SCENARIOSWITHLEAKOPTIONS_NONE_OF_THE_ABOVE,
  OPTION_MATTERFOREIGNMATERIALOPTIONS_IN_THE_SECONDARY,
  OPTION_MATTERFOREIGNMATERIALOPTIONS_INSIDE_THE_SHIPPING,
  OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_EXTERIOR,
  OPTION_MATTERFOREIGNMATERIALOPTIONS_OTHER,
  OPTION_PROBLEMOPTIONS_OTHER,
  OPTION_REPORTEDTOOPTIONS_OTHER,
  OPTION_DIFFICULTTOUSEOPTIONS_OTHER,
  OPTION_DIFFICULTIESMINICAPOPTIONS_OTHER,
  OPTION_BLOCKINGFLOWOPTIONS_OTHER,
  OPTION_DESCRIBEISSUEOPTIONS_OTHER,
  OPTION_MATERIALLOCATEDOPTIONS_OTHER,
  OPTION_OBSERVEDDAMAGEOPTIONS_OTHER,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_OTHER,
  OPTION_PRODUCTDISCOLOREDOPTIONS_OTHER,
  OPTION_SPECIFICALLYDESCRIBESOPTIONS_OTHER,
  OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_OTHER,
  OPTION_PRODUCTTHAWEDOPTIONS_OTHER,
  OPTION_DAMAGEISSUEOBSERVEDOPTIONS_OTHER,
  OPTION_DAMAGESPECIFICINFOOPTIONS_OTHER,
  OPTION_APPROPRIATEDESCRIPTIONOPTIONS_OTHER,
  OPTION_LABELINGISSUEOPTIONS_OTHER,
  OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_OTHER,
  OPTION_MOISTUREOBSERVEDOPTIONS_OTHER,
  OPTION_COMPONENTLEAKINGOPTIONS_OTHER,
  OPTION_WHATTYPEDAMAGEISSUEOPTIONS_OTHER,
  OPTION_SITUATIONDESCRIBESISSUEOPTIONS_OTHER,
  OPTION_FOLLOWINGSCENARIOSOPTIONS_OTHER,
  OPTION_SITUATIONFLOWISSUEOPTIONS_OTHER,
  OPTION_SITUATIONSAPPLYEVENTOPTIONS_OTHER,
  OPTION_SIMULTANEOUSFLOWOPTIONS_OTHER,
  OPTION_WHATCLAMPFAILEDOPTIONS_OTHER,
  OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_OTHER,
  OPTION_CLAMPDESCRIBESISSUEOPTIONS_DIFFICULT_OTHER,
  OPTION_PRODUCTDAMAGEDOPTIONS_OTHER,
  OPTION_COMPONENTHADISSUEOPTIONS_OTHER,
  OPTION_FOLLOWINGOCCUROPTIONS_NONE_OF_THE_ABOVE,
  OPTION_PREVIOUSLYREPORTEDOPTIONS_NO,
  OPTION_PREVIOUSLYREPORTEDOPTIONS_UNKNOWN,
  OPTION_PREVIOUSLYREPORTEDOPTIONS_YES,
  OPTION_ADDANOTHERFACILITYOPTIONS_NO,
  OPTION_ADDANOTHERFACILITYOPTIONS_YES,
  OPTION_PATIENINVOLVEMENTOPTIONS_NO,
  OPTION_PATIENINVOLVEMENTOPTIONS_UNKNOWN,
  OPTION_PATIENINVOLVEMENTOPTIONS_YES,
  OPTION_OTHERFACILITYREPORTOPTIONS_NO,
  OPTION_OTHERFACILITYREPORTOPTIONS_YES,
  OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_ASKED_UNKNOWN,
  OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_NO,
  OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_UNKNOWN,
  OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_YES,
  OPTION_AVAILABILITYOPTIONS_NO,
  OPTION_AVAILABILITYOPTIONS_YES,
  OPTION_MEDIAAVAILABILITYOPTIONS_NO,
  OPTION_MEDIAAVAILABILITYOPTIONS_YES,
  OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_NO,
  OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_UNKNOWN,
  OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_YES,
  OPTION_UNUSEDAVAILABILITYOPTIONS_NO,
  OPTION_UNUSEDAVAILABILITYOPTIONS_YES,
  OPTION_SELFNEGATIVEIMPACTOPTIONS_NO,
  OPTION_SELFNEGATIVEIMPACTOPTIONS_YES,
  OPTION_PATIENTNEGATIVEIMPACTOPTIONS_NO,
  OPTION_PATIENTNEGATIVEIMPACTOPTIONS_YES,
  OPTION_COUNTERACTIONOPTIONS_NO,
  OPTION_COUNTERACTIONOPTIONS_YES,
  OPTION_DRUGUSEDOPTIONS_NO,
  OPTION_DRUGUSEDOPTIONS_YES,
  OPTION_SHARECONTACTOPTIONS_NO,
  OPTION_SHARECONTACTOPTIONS_YES,
  OPTION_EXPLICITINVESTIGATIONREQUESTOPTIONS_NO,
  OPTION_EXPLICITINVESTIGATIONREQUESTOPTIONS_YES,
  OPTION_DIRECTORDEROPTIONS_NO,
  OPTION_DIRECTORDEROPTIONS_YES,
  OPTION_EXCESSIVEFORCEOPTIONS_NO,
  OPTION_EXCESSIVEFORCEOPTIONS_UNKNOWN,
  OPTION_EXCESSIVEFORCEOPTIONS_YES,
  OPTION_TWISTCLAMPOPTIONS_NO,
  OPTION_TWISTCLAMPOPTIONS_UNKNOWN,
  OPTION_TWISTCLAMPOPTIONS_YES,
  OPTION_DIFFICULTIESMINICAPOPTIONS_NO,
  OPTION_DIFFICULTIESMINICAPOPTIONS_UNKNOWN,
  OPTION_ENVIRONMENTOPTIONS_NO,
  OPTION_ENVIRONMENTOPTIONS_UNKNOWN,
  OPTION_ENVIRONMENTOPTIONS_YES,
  OPTION_SPONGEVISIBLEOPTIONS_NO,
  OPTION_SPONGEVISIBLEOPTIONS_UNKNOWN,
  OPTION_SPONGEVISIBLEOPTIONS_YES,
  OPTION_MATERIALEMBEDDEDOPTIONS_NO,
  OPTION_MATERIALEMBEDDEDOPTIONS_UNKNOWN,
  OPTION_MATERIALEMBEDDEDOPTIONS_YES,
  OPTION_PIECESMATERIALOPTIONS_NO,
  OPTION_PIECESMATERIALOPTIONS_UNKNOWN,
  OPTION_PIECESMATERIALOPTIONS_YES,
  OPTION_DISPOSABLECONNECTIONOPTIONS_NO,
  OPTION_DISPOSABLECONNECTIONOPTIONS_UNKNOWN,
  OPTION_DISPOSABLECONNECTIONOPTIONS_YES,
  OPTION_INITIALCONNECTIONOPTIONS_NO,
  OPTION_INITIALCONNECTIONOPTIONS_UNKNOWN,
  OPTION_INITIALCONNECTIONOPTIONS_YES,
  OPTION_SPIKELUERCONNECTORSOPTIONS_NO,
  OPTION_SPIKELUERCONNECTORSOPTIONS_UNKNOWN,
  OPTION_SPIKELUERCONNECTORSOPTIONS_YES,
  OPTION_PETSORANIMALSOPTIONS_NO,
  OPTION_PETSORANIMALSOPTIONS_UNKNOWN,
  OPTION_PETSORANIMALSOPTIONS_YES,
  OPTION_MINICAPTWISTEDOPTIONS_NO,
  OPTION_MINICAPTWISTEDOPTIONS_UNKNOWN,
  OPTION_MINICAPTWISTEDOPTIONS_YES,
  OPTION_TRANSFERSETOPTIONS_NO,
  OPTION_TRANSFERSETOPTIONS_UNKNOWN,
  OPTION_TRANSFERSETOPTIONS_YES,
  OPTION_RESIDUETHREADSOPTIONS_NO,
  OPTION_RESIDUETHREADSOPTIONS_UNKNOWN,
  OPTION_DAMAGECAUSELEAKOPTIONS_NO,
  OPTION_DAMAGECAUSELEAKOPTIONS_UNKNOWN,
  OPTION_DAMAGECAUSELEAKOPTIONS_YES,
  OPTION_SHIPPINGCARTONOPENOPTIONS_NO,
  OPTION_SHIPPINGCARTONOPENOPTIONS_UNKNOWN,
  OPTION_SHIPPINGCARTONOPENOPTIONS_YES,
  OPTION_ADAPTERDEVICEOPTIONS_NO,
  OPTION_ADAPTERDEVICEOPTIONS_UNKNOWN,
  OPTION_ADAPTERDEVICEOPTIONS_YES,
  OPTION_SQUEEZINGSOLUTIONOPTIONSS_NO,
  OPTION_SQUEEZINGSOLUTIONOPTIONSS_UNKNOWN,
  OPTION_SQUEEZINGSOLUTIONOPTIONSS_YES,
  OPTION_FORTHMOTIONOPTIONS_NO,
  OPTION_FORTHMOTIONOPTIONS_UNKNOWN,
  OPTION_FORTHMOTIONOPTIONS_YES,
  OPTION_ALARMNOFLOWOPTIONS_NO,
  OPTION_ALARMNOFLOWOPTIONS_UNKNOWN,
  OPTION_ALARMNOFLOWOPTIONS_YES,
  OPTION_DISCOLORATIONMARKINGSOPTIONS_NO,
  OPTION_DISCOLORATIONMARKINGSOPTIONS_UNKNOWN,
  OPTION_DISCOLORATIONMARKINGSOPTIONS_YES,
  OPTION_BROKENACTIVATEDOPTIONS_NO,
  OPTION_BROKENACTIVATEDOPTIONS_UNKNOWN,
  OPTION_BROKENACTIVATEDOPTIONS_YES,
  OPTION_vaporizerSightGlassOptions_NO,
  OPTION_vaporizerSightGlassOptions_UNKNOWN,
  OPTION_vaporizerSightGlassOptions_YES,
  OPTION_PRODUCTHEATOPTIONS_NO,
  OPTION_PRODUCTHEATOPTIONS_UNKNOWN,
  OPTION_PRODUCTHEATOPTIONS_YES,
  OPTION_DAMAGEPRIORACTIVATIONOPTIONS_NO,
  OPTION_DAMAGEPRIORACTIVATIONOPTIONS_UNKNOWN,
  OPTION_DAMAGEPRIORACTIVATIONOPTIONS_YES,
  OPTION_LEAKOBSERVEDOPTIONS_NO,
  OPTION_LEAKOBSERVEDOPTIONS_UNKNOWN,
  OPTION_LEAKOBSERVEDOPTIONS_YES,
  OPTION_EMBEDDEDINTHEPRODUCTOPTIONS_NO,
  OPTION_EMBEDDEDINTHEPRODUCTOPTIONS_UNKNOWN,
  OPTION_EMBEDDEDINTHEPRODUCTOPTIONS_YES,
  OPTION_WASSOLUTIONADDEDPRODUCTOPTIONS_NO,
  OPTION_WASSOLUTIONADDEDPRODUCTOPTIONS_UNKNOWN,
  OPTION_WASSOLUTIONADDEDPRODUCTOPTIONS_YES,
  OPTION_CLOUDINESSGOAWAYOPTIONS_NO,
  OPTION_CLOUDINESSGOAWAYOPTIONS_UNKNOWN,
  OPTION_CLOUDINESSGOAWAYOPTIONS_YES,
  OPTION_AGITATEUNITOPTIONS_NO,
  OPTION_AGITATEUNITOPTIONS_UNKNOWN,
  OPTION_AGITATEUNITOPTIONS_YES,
  OPTION_PRECIPITATEDISSOLVEOPTIONS_NO,
  OPTION_PRECIPITATEDISSOLVEOPTIONS_UNKNOWN,
  OPTION_PRECIPITATEDISSOLVEOPTIONS_YES,
  OPTION_TEMPERATURELOGSFREEZEROPTIONS_NO,
  OPTION_TEMPERATURELOGSFREEZEROPTIONS_UNKNOWN,
  OPTION_TEMPERATURELOGSFREEZEROPTIONS_YES,
  OPTION_STORAGEUNITCALIBRATEDOPTIONSS_NO,
  OPTION_STORAGEUNITCALIBRATEDOPTIONSS_UNKNOWN,
  OPTION_STORAGEUNITCALIBRATEDOPTIONSS_YES,
  OPTION_RECENTPRESCRIPTIONOPTIONS_NO,
  OPTION_RECENTPRESCRIPTIONOPTIONS_UNKNOWN,
  OPTION_RECENTPRESCRIPTIONOPTIONS_YES,
  OPTION_EXPIREDPRODUCTOPTIONS_NO,
  OPTION_EXPIREDPRODUCTOPTIONS_UNKNOWN,
  OPTION_EXPIREDPRODUCTOPTIONS_YES,
  OPTION_ABNORMALITIESDAMAGEOPTIONS_NO,
  OPTION_ABNORMALITIESDAMAGEOPTIONS_UNKNOWN,
  OPTION_ABNORMALITIESDAMAGEOPTIONS_YES,
  OPTION_OVERPOUCHPOUCHSCANNINGOPTIONS_NO,
  OPTION_OVERPOUCHPOUCHSCANNINGOPTIONS_UNKNOWN,
  OPTION_OVERPOUCHPOUCHSCANNINGOPTIONS_YES,
  OPTION_LABELSSAMEINFORMATIONOPTIONS_NO,
  OPTION_LABELSSAMEINFORMATIONOPTIONS_UNKNOWN,
  OPTION_LABELSSAMEINFORMATIONOPTIONS_YES,
  OPTION_BARCODESCANNEROPTIONS_NO,
  OPTION_BARCODESCANNEROPTIONS_UNKNOWN,
  OPTION_BARCODESCANNEROPTIONS_YES,
  OPTION_FRANGIBLEOBSERVEDOPTIONS_NO,
  OPTION_FRANGIBLEOBSERVEDOPTIONS_UNKNOWN,
  OPTION_FRANGIBLEOBSERVEDOPTIONS_YES,
  OPTION_FRANGIBLEDAMAGEDEFECTOPTIONS_NO,
  OPTION_FRANGIBLEDAMAGEDEFECTOPTIONS_UNKNOWN,
  OPTION_FRANGIBLEDAMAGEDEFECTOPTIONS_YES,
  OPTION_FRANGIBLEBROKENOPTIONS_NO,
  OPTION_FRANGIBLEBROKENOPTIONS_UNKNOWN,
  OPTION_FRANGIBLEBROKENOPTIONS_YES,
  OPTION_MOISTURECLEAROPTIONS_UNKNOWN,
  OPTION_MOISTURECLEAROPTIONS_YES,
  OPTION_DIFFICULTYSPIKINGOPTIONS_NO,
  OPTION_DIFFICULTYSPIKINGOPTIONS_UNKNOWN,
  OPTION_DIFFICULTYSPIKINGOPTIONS_YES,
  OPTION_WASFRANGIBLEDAMAGEOPTIONS_NO,
  OPTION_WASFRANGIBLEDAMAGEOPTIONS_UNKNOWN,
  OPTION_WASFRANGIBLEDAMAGEOPTIONS_YES,
  OPTION_PRESSURECUFFOPTIONS_NO,
  OPTION_PRESSURECUFFOPTIONS_UNKNOWN,
  OPTION_PRESSURECUFFOPTIONS_YES,
  OPTION_LIQUIDSPILLEDOPTIONS_UNKNOWN,
  OPTION_BOTTLEINTOVAPORIZEROPTIONS_NO,
  OPTION_BOTTLEINTOVAPORIZEROPTIONS_UNKNOWN,
  OPTION_BOTTLEINTOVAPORIZEROPTIONS_YES,
  OPTION_REMOVEDFROMPACKAGEOPTIONS_NO,
  OPTION_REMOVEDFROMPACKAGEOPTIONS_UNKNOWN,
  OPTION_REMOVEDFROMPACKAGEOPTIONS_YES,
  OPTION_ADDINGMEDICATIONOPTIONS_NO,
  OPTION_ADDINGMEDICATIONOPTIONS_UNKNOWN,
  OPTION_ADDINGMEDICATIONOPTIONS_YES,
  OPTION_PATIENTCONNECTEDPRODUCTOPTIONS_NO,
  OPTION_PATIENTCONNECTEDPRODUCTOPTIONS_UNKNOWN,
  OPTION_PATIENTCONNECTEDPRODUCTOPTIONS_YES,
  OPTION_WASPRODUCTREPLACEDOPTIONS_NO,
  OPTION_WASPRODUCTREPLACEDOPTIONS_UNKNOWN,
  OPTION_WASPRODUCTREPLACEDOPTIONS_YES,
  OPTION_WASPOWERINJECTOROPTIONS_NO,
  OPTION_WASPOWERINJECTOROPTIONS_UNKNOWN,
  OPTION_WASPOWERINJECTOROPTIONS_YES,
  OPTION_INJECTIONSITEOPENINGOPTIONS_NO,
  OPTION_INJECTIONSITEOPENINGOPTIONS_UNKNOWN,
  OPTION_INJECTIONSITEOPENINGOPTIONS_YES,
  OPTION_INJECTIONSITEOPENINGOPTIONS_OTHER,
  OPTION_VISIBLEIRREGULARITIESOPTIONS_NO,
  OPTION_VISIBLEIRREGULARITIESOPTIONS_UNKNOWN,
  OPTION_EVENTUALLYESTABLISHEDOPTIONS_NO,
  OPTION_EVENTUALLYESTABLISHEDOPTIONS_UNKNOWN,
  OPTION_EVENTUALLYESTABLISHEDOPTIONS_YES,
  OPTION_TOOLUSEDASSISTOPTIONS_NO,
  OPTION_TOOLUSEDASSISTOPTIONS_UNKNOWN,
  OPTION_SECUREPRIORUSEOPTIONS_NO,
  OPTION_SECUREPRIORUSEOPTIONS_UNKNOWN,
  OPTION_SECUREPRIORUSEOPTIONS_YES,
  OPTION_PRIORDISCONNECTINGOPTIONS_NO,
  OPTION_PRIORDISCONNECTINGOPTIONS_UNKNOWN,
  OPTION_PRIORDISCONNECTINGOPTIONS_YES,
  OPTION_FLOWPREVIOUSLYSEENOPTIONS_NO,
  OPTION_FLOWPREVIOUSLYSEENOPTIONS_UNKNOWN,
  OPTION_FLOWPREVIOUSLYSEENOPTIONS_YES,
  OPTION_YSITECONNECTEDOPTIONS_UNKNOWN,
  OPTION_COMPONENTSETREPLACEDOPTIONS_NO,
  OPTION_COMPONENTSETREPLACEDOPTIONS_UNKNOWN,
  OPTION_COMPONENTSETREPLACEDOPTIONS_YES,
  OPTION_WITHPUMPOPTIONS_NO,
  OPTION_WITHPUMPOPTIONS_UNKNOWN,
  OPTION_CLAMPFAILOPTIONS_NO,
  OPTION_CLAMPFAILOPTIONS_UNKNOWN,
  OPTION_CLAMPFAILOPTIONS_YES,
  OPTION_ISSUESOBSERVEDCLAMPOPTIONS_NO,
  OPTION_ISSUESOBSERVEDCLAMPOPTIONS_UNKNOWN,
  OPTION_WASMATERIALEMBEDDEDOPTIONS_NO,
  OPTION_WASMATERIALEMBEDDEDOPTIONS_UNKNOWN,
  OPTION_WASMATERIALEMBEDDEDOPTIONS_YES,
  OPTION_APPEARPRODUCTMATERIALOPTIONS_NO,
  OPTION_APPEARPRODUCTMATERIALOPTIONS_UNKNOWN,
  OPTION_APPEARPRODUCTMATERIALOPTIONS_YES,
  OPTION_SHIPPINGCARTONDAMAGEDOPTIONS_NO,
  OPTION_SHIPPINGCARTONDAMAGEDOPTIONS_UNKNOWN,
  OPTION_SHIPPINGCARTONDAMAGEDOPTIONS_YES,
  OPTION_GELPACKSOPTIONS_NO,
  OPTION_GELPACKSOPTIONS_YES,
  OPTION_EXPIREDPRODUCTUSEOPTIONS_NO,
  OPTION_EXPIREDPRODUCTUSEOPTIONS_UNKNOWN,
  OPTION_EXPIREDPRODUCTUSEOPTIONS_YES,
  OPTION_ALARMOPTIONS_NO,
  OPTION_ALARMOPTIONS_UNKNOWN,
  OPTION_CLEANINGSOLUTIONSOPTIONS_NO,
  OPTION_CLEANINGSOLUTIONSOPTIONS_UNKNOWN,
  OPTION_CLEANINGSOLUTIONSOPTIONS_YES,
  OPTION_DIFFICULTINTWISTCLAMPOPTIONS_NO,
  OPTION_DIFFICULTINTWISTCLAMPOPTIONS_UNKNOWN,
  OPTION_TRANSFERREPLACEDOPTIONS_NO,
  OPTION_TRANSFERREPLACEDOPTIONS_UNKNOWN,
  OPTION_TRANSFERREPLACEDOPTIONS_YES,
  OPTION_FULLYTIGHTENEDOPTIONS_NO,
  OPTION_FULLYTIGHTENEDOPTIONS_UNKNOWN,
  OPTION_FULLYTIGHTENEDOPTIONS_YES,
  OPTION_ANYCOMPONENTDAMAGEDOPTIONSS_NO,
  OPTION_ANYCOMPONENTDAMAGEDOPTIONSS_UNKNOWN,
  OPTION_ISSUERESULTLEAKOPTIONS_NO,
  OPTION_ISSUERESULTLEAKOPTIONS_UNKNOWN,
  OPTION_ISSUERESULTLEAKOPTIONS_YES,
  OPTION_ISSUERESULTLEAKOPTIONS_OTHER,
  OPTION_SAMPLESAVAILABLEFOREVALUATIONOPTIONS_NO,
  OPTION_SAMPLESAVAILABLEFOREVALUATIONOPTIONS_YES,
  OPTION_EXPLICITLYREQUESTOPTIONS_NO,
  OPTION_EXPLICITLYREQUESTOPTIONS_UNKNOWN,
  OPTION_EXPLICITLYREQUESTOPTIONS_YES,
  OPTION_WEREPATIENTUSINGPRODUCTOPTIONS_NO,
  OPTION_WEREPATIENTUSINGPRODUCTOPTIONS_UNKNOWN,
  OPTION_WEREPATIENTUSINGPRODUCTOPTIONS_YES,
  OPTION_PATIENINVOLVEMENTOPTIONS_ASKED_UNKNOWN,
  OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_ASKED_UNKNOWN,
  OPTION_CHAMBERDISCOLOREDOPTIONS_UNKNOWN,
  OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_UNKNOWN,
  OPTION_DAMAGEISSUEOBSERVEDOPTIONS_NO,
  OPTION_DAMAGEISSUEOBSERVEDOPTIONS_UNKNOWN,
  OPTION_SCENARIOSLEAKOPTIONS_UNKNOWN,
  OPTION_SCENARIOSLEAKOPTIONS_NONE_OF_THE_ABOVE,
  OPTION_MOISTURECLEAROPTIONS_NO_DESCRIBE_THE_COLOR,
  OPTION_EMBEDDEDPLASTICOPTIONS_UNKNOWN,
  OPTION_WHATTYPEDAMAGEISSUEOPTIONS_UNKNOWN,
  OPTION_TOOLUSEDASSISTOPTIONS_YES_SPECIFY_THE_TOOL,
  OPTION_SITUATIONSAPPLYEVENTOPTIONS_SEPARATION,
  OPTION_HANGERUSEDOPTIONS_UNKNOWN,
  OPTION_HANGERUSEDOPTIONS_NONE,
  OPTION_BAGLOWEROPTIONS_UNKNOWN,
  OPTION_ISSUESOBSERVEDCLAMPOPTIONS_YES_OTHER,
  OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNKNOWN,
  OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_NO,
  OPTION_WEIGHTUNITOPTIONS_KILOGRAM,
  OPTION_WEIGHTUNITOPTIONS_POUND,
  OPTION_INFUSATESOLUTIONOPTIONS_NO,
  OPTION_INFUSATESOLUTIONOPTIONS_UNKNOWN,
  PLEASE_ENTER_THE_VALUE,
  PLEASE_SELECT_THE_VALUE,
  PLEASE_SELECT_THE_DATE,
  PLEASE_CHOOSE_THE_VALUE,
  OPTION_MEDIAAVAILABILITYOPTIONS_UNKNOWN,
  OPTION_COUNTRYOPTIONS_GREAT_BRITAIN,
  OPTION_COUNTRYOPTIONS_KOSOVO,
  OPTION_COUNTRYOPTIONS_NORTHERN_IRELAND,
  OPTION_COUNTRYOPTIONS_AFGHANISTAN,
  OPTION_COUNTRYOPTIONS_ÅLAND_ISLANDS,
  OPTION_COUNTRYOPTIONS_ALBANIA,
  OPTION_COUNTRYOPTIONS_ALGERIA,
  OPTION_COUNTRYOPTIONS_AMERICAN_SAMOA,
  OPTION_COUNTRYOPTIONS_ANDORRA,
  OPTION_COUNTRYOPTIONS_ANGOLA,
  OPTION_COUNTRYOPTIONS_ANGUILLA,
  OPTION_COUNTRYOPTIONS_ANTARCTICA,
  OPTION_COUNTRYOPTIONS_ANTIGUA_AND_BARBUDA,
  OPTION_COUNTRYOPTIONS_ARGENTINA,
  OPTION_COUNTRYOPTIONS_ARMENIA,
  OPTION_COUNTRYOPTIONS_ARUBA,
  OPTION_COUNTRYOPTIONS_AUSTRALIA,
  OPTION_COUNTRYOPTIONS_AUSTRIA,
  OPTION_COUNTRYOPTIONS_AZERBAIJAN,
  OPTION_COUNTRYOPTIONS_BAHAMAS,
  OPTION_COUNTRYOPTIONS_BAHRAIN,
  OPTION_COUNTRYOPTIONS_BANGLADESH,
  OPTION_COUNTRYOPTIONS_BARBADOS,
  OPTION_COUNTRYOPTIONS_BELARUS,
  OPTION_COUNTRYOPTIONS_BELGIUM,
  OPTION_COUNTRYOPTIONS_BELIZE,
  OPTION_COUNTRYOPTIONS_BENIN,
  OPTION_COUNTRYOPTIONS_BERMUDA,
  OPTION_COUNTRYOPTIONS_BHUTAN,
  OPTION_COUNTRYOPTIONS_BOLIVIA,
  OPTION_COUNTRYOPTIONS_BOSNIA_AND_HERZEGOVINA,
  OPTION_COUNTRYOPTIONS_BOTSWANA,
  OPTION_COUNTRYOPTIONS_BOUVET_ISLAND,
  OPTION_COUNTRYOPTIONS_BRAZIL,
  OPTION_COUNTRYOPTIONS_BRITISH_INDIAN_OCEAN_TERRITORY,
  OPTION_COUNTRYOPTIONS_BRUNEI_DARUSSALAM,
  OPTION_COUNTRYOPTIONS_BULGARIA,
  OPTION_COUNTRYOPTIONS_BURKINA_FASO,
  OPTION_COUNTRYOPTIONS_BURUNDI,
  OPTION_COUNTRYOPTIONS_CAMBODIA,
  OPTION_COUNTRYOPTIONS_CAMEROON,
  OPTION_COUNTRYOPTIONS_CANADA,
  OPTION_COUNTRYOPTIONS_CAPE_VERDE,
  OPTION_COUNTRYOPTIONS_CAYMAN_ISLANDS,
  OPTION_COUNTRYOPTIONS_CENTRAL_AFRICAN_REPUBLIC,
  OPTION_COUNTRYOPTIONS_CHAD,
  OPTION_COUNTRYOPTIONS_CHILE,
  OPTION_COUNTRYOPTIONS_CHINA,
  OPTION_COUNTRYOPTIONS_CHRISTMAS_ISLAND,
  OPTION_COUNTRYOPTIONS_COCOS_KEELING_ISLANDS,
  OPTION_COUNTRYOPTIONS_COLOMBIA,
  OPTION_COUNTRYOPTIONS_COMOROS,
  OPTION_COUNTRYOPTIONS_CONGO,
  OPTION_COUNTRYOPTIONS_CONGO_THE_DEMOCRATIC_REPUBLIC_OF_THE,
  OPTION_COUNTRYOPTIONS_COOK_ISLANDS,
  OPTION_COUNTRYOPTIONS_COSTA_RICA,
  OPTION_COUNTRYOPTIONS_CÔTE_DIVOIRE_IVORY_COAST,
  OPTION_COUNTRYOPTIONS_CROATIA,
  OPTION_COUNTRYOPTIONS_CUBA,
  OPTION_COUNTRYOPTIONS_CYPRUS,
  OPTION_COUNTRYOPTIONS_CZECH_REPUBLIC,
  OPTION_COUNTRYOPTIONS_DENMARK,
  OPTION_COUNTRYOPTIONS_DJIBOUTI,
  OPTION_COUNTRYOPTIONS_DOMINICA,
  OPTION_COUNTRYOPTIONS_DOMINICAN_REPUBLIC,
  OPTION_COUNTRYOPTIONS_ECUADOR,
  OPTION_COUNTRYOPTIONS_EGYPT,
  OPTION_COUNTRYOPTIONS_EL_SALVADOR,
  OPTION_COUNTRYOPTIONS_EQUATORIAL_GUINEA,
  OPTION_COUNTRYOPTIONS_ERITREA,
  OPTION_COUNTRYOPTIONS_ESTONIA,
  OPTION_COUNTRYOPTIONS_ETHIOPIA,
  OPTION_COUNTRYOPTIONS_FALKLAND_ISLANDS_MALVINAS,
  OPTION_COUNTRYOPTIONS_FAROE_ISLANDS,
  OPTION_COUNTRYOPTIONS_FIJI,
  OPTION_COUNTRYOPTIONS_FINLAND,
  OPTION_COUNTRYOPTIONS_FRANCE,
  OPTION_COUNTRYOPTIONS_FRENCH_GUIANA,
  OPTION_COUNTRYOPTIONS_FRENCH_POLYNESIA,
  OPTION_COUNTRYOPTIONS_FRENCH_SOUTHERN_TERRITORIES,
  OPTION_COUNTRYOPTIONS_GABON,
  OPTION_COUNTRYOPTIONS_GAMBIA,
  OPTION_COUNTRYOPTIONS_GEORGIA,
  OPTION_COUNTRYOPTIONS_GERMANY,
  OPTION_COUNTRYOPTIONS_GHANA,
  OPTION_COUNTRYOPTIONS_GIBRALTAR,
  OPTION_COUNTRYOPTIONS_GREECE,
  OPTION_COUNTRYOPTIONS_GREENLAND,
  OPTION_COUNTRYOPTIONS_GRENADA,
  OPTION_COUNTRYOPTIONS_GUADELOUPE,
  OPTION_COUNTRYOPTIONS_GUAM,
  OPTION_COUNTRYOPTIONS_GUATEMALA,
  OPTION_COUNTRYOPTIONS_GUERNSEY,
  OPTION_COUNTRYOPTIONS_GUINEA,
  OPTION_COUNTRYOPTIONS_GUINEA_BISSAU,
  OPTION_COUNTRYOPTIONS_GUYANA,
  OPTION_COUNTRYOPTIONS_HAITI,
  OPTION_COUNTRYOPTIONS_HEARD_ISLAND_AND_MCDONALD_ISLANDS,
  OPTION_COUNTRYOPTIONS_HOLY_SEE_VATICAN_CITY_STATE,
  OPTION_COUNTRYOPTIONS_HONDURAS,
  OPTION_COUNTRYOPTIONS_HONG_KONG,
  OPTION_COUNTRYOPTIONS_HUNGARY,
  OPTION_COUNTRYOPTIONS_ICELAND,
  OPTION_COUNTRYOPTIONS_INDIA,
  OPTION_COUNTRYOPTIONS_INDONESIA,
  OPTION_COUNTRYOPTIONS_IRAN_ISLAMIC_REPUBLIC_OF,
  OPTION_COUNTRYOPTIONS_IRAQ,
  OPTION_COUNTRYOPTIONS_IRELAND,
  OPTION_COUNTRYOPTIONS_ISLE_OF_MAN,
  OPTION_COUNTRYOPTIONS_ISRAEL,
  OPTION_COUNTRYOPTIONS_ITALY,
  OPTION_COUNTRYOPTIONS_JAMAICA,
  OPTION_COUNTRYOPTIONS_JAPAN,
  OPTION_COUNTRYOPTIONS_JERSEY,
  OPTION_COUNTRYOPTIONS_JORDAN,
  OPTION_COUNTRYOPTIONS_KAZAKHSTAN,
  OPTION_COUNTRYOPTIONS_KENYA,
  OPTION_COUNTRYOPTIONS_KIRIBATI,
  OPTION_COUNTRYOPTIONS_KOREA_DEMOCRATIC_PEOPLES_REPUBLIC_OF,
  OPTION_COUNTRYOPTIONS_KOREA_REPUBLIC_OF,
  OPTION_COUNTRYOPTIONS_KUWAIT,
  OPTION_COUNTRYOPTIONS_KYRGYZSTAN,
  OPTION_COUNTRYOPTIONS_LAO_PEOPLES_DEMOCRATIC_REPUBLIC,
  OPTION_COUNTRYOPTIONS_LATVIA,
  OPTION_COUNTRYOPTIONS_LEBANON,
  OPTION_COUNTRYOPTIONS_LESOTHO,
  OPTION_COUNTRYOPTIONS_LIBERIA,
  OPTION_COUNTRYOPTIONS_LIBYAN_ARAB_JAMAHIRIYA,
  OPTION_COUNTRYOPTIONS_LIECHTENSTEIN,
  OPTION_COUNTRYOPTIONS_LITHUANIA,
  OPTION_COUNTRYOPTIONS_LUXEMBOURG,
  OPTION_COUNTRYOPTIONS_MACAO,
  OPTION_COUNTRYOPTIONS_MACEDONIA_THE_FORMER_YUGOSLAV_REPUBLIC_OF,
  OPTION_COUNTRYOPTIONS_MADAGASCAR,
  OPTION_COUNTRYOPTIONS_MALAWI,
  OPTION_COUNTRYOPTIONS_MALAYSIA,
  OPTION_COUNTRYOPTIONS_MALDIVES,
  OPTION_COUNTRYOPTIONS_MALI,
  OPTION_COUNTRYOPTIONS_MALTA,
  OPTION_COUNTRYOPTIONS_MARSHALL_ISLANDS,
  OPTION_COUNTRYOPTIONS_MARTINIQUE,
  OPTION_COUNTRYOPTIONS_MAURITANIA,
  OPTION_COUNTRYOPTIONS_MAURITIUS,
  OPTION_COUNTRYOPTIONS_MAYOTTE,
  OPTION_COUNTRYOPTIONS_MEXICO,
  OPTION_COUNTRYOPTIONS_MICRONESIA_FEDERATED_STATES_OF,
  OPTION_COUNTRYOPTIONS_MOLDOVA,
  OPTION_COUNTRYOPTIONS_MONACO,
  OPTION_COUNTRYOPTIONS_MONGOLIA,
  OPTION_COUNTRYOPTIONS_MONTENEGRO,
  OPTION_COUNTRYOPTIONS_MONTSERRAT,
  OPTION_COUNTRYOPTIONS_MOROCCO,
  OPTION_COUNTRYOPTIONS_MOZAMBIQUE,
  OPTION_COUNTRYOPTIONS_MYANMAR,
  OPTION_COUNTRYOPTIONS_NAMIBIA,
  OPTION_COUNTRYOPTIONS_NAURU,
  OPTION_COUNTRYOPTIONS_NEPAL,
  OPTION_COUNTRYOPTIONS_NETHERLANDS,
  OPTION_COUNTRYOPTIONS_NEW_CALEDONIA,
  OPTION_COUNTRYOPTIONS_NEW_ZEALAND,
  OPTION_COUNTRYOPTIONS_NICARAGUA,
  OPTION_COUNTRYOPTIONS_NIGER,
  OPTION_COUNTRYOPTIONS_NIGERIA,
  OPTION_COUNTRYOPTIONS_NIUE,
  OPTION_COUNTRYOPTIONS_NORFOLK_ISLAND,
  OPTION_COUNTRYOPTIONS_NORTHERN_MARIANA_ISLANDS,
  OPTION_COUNTRYOPTIONS_NORWAY,
  OPTION_COUNTRYOPTIONS_OMAN,
  OPTION_COUNTRYOPTIONS_PAKISTAN,
  OPTION_COUNTRYOPTIONS_PALAU,
  OPTION_COUNTRYOPTIONS_PALESTINIAN_TERRITORY_OCCUPIED,
  OPTION_COUNTRYOPTIONS_PANAMA,
  OPTION_COUNTRYOPTIONS_PAPUA_NEW_GUINEA,
  OPTION_COUNTRYOPTIONS_PARAGUAY,
  OPTION_COUNTRYOPTIONS_PERU,
  OPTION_COUNTRYOPTIONS_PHILIPPINES,
  OPTION_COUNTRYOPTIONS_PITCAIRN,
  OPTION_COUNTRYOPTIONS_POLAND,
  OPTION_COUNTRYOPTIONS_PORTUGAL,
  OPTION_COUNTRYOPTIONS_PUERTO_RICO,
  OPTION_COUNTRYOPTIONS_QATAR,
  OPTION_COUNTRYOPTIONS_RÉUNION,
  OPTION_COUNTRYOPTIONS_ROMANIA,
  OPTION_COUNTRYOPTIONS_RUSSIAN_FEDERATION,
  OPTION_COUNTRYOPTIONS_RWANDA,
  OPTION_COUNTRYOPTIONS_SAINT_BARTHÉLEMY,
  OPTION_COUNTRYOPTIONS_SAINT_HELENA,
  OPTION_COUNTRYOPTIONS_SAINT_KITTS_AND_NEVIS,
  OPTION_COUNTRYOPTIONS_SAINT_LUCIA,
  OPTION_COUNTRYOPTIONS_SAINT_MARTIN,
  OPTION_COUNTRYOPTIONS_SAINT_PIERRE_AND_MIQUELON,
  OPTION_COUNTRYOPTIONS_SAINT_VINCENT_AND_THE_GRENADINES,
  OPTION_COUNTRYOPTIONS_SAMOA,
  OPTION_COUNTRYOPTIONS_SAN_MARINO,
  OPTION_COUNTRYOPTIONS_SAO_TOME_AND_PRINCIPE,
  OPTION_COUNTRYOPTIONS_SAUDI_ARABIA,
  OPTION_COUNTRYOPTIONS_SENEGAL,
  OPTION_COUNTRYOPTIONS_SERBIA,
  OPTION_COUNTRYOPTIONS_SEYCHELLES,
  OPTION_COUNTRYOPTIONS_SIERRA_LEONE,
  OPTION_COUNTRYOPTIONS_SINGAPORE,
  OPTION_COUNTRYOPTIONS_SLOVAKIA,
  OPTION_COUNTRYOPTIONS_SLOVENIA,
  OPTION_COUNTRYOPTIONS_SOLOMON_ISLANDS,
  OPTION_COUNTRYOPTIONS_SOMALIA,
  OPTION_COUNTRYOPTIONS_SOUTH_AFRICA,
  OPTION_COUNTRYOPTIONS_SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS,
  OPTION_COUNTRYOPTIONS_SPAIN,
  OPTION_COUNTRYOPTIONS_SRI_LANKA,
  OPTION_COUNTRYOPTIONS_SUDAN,
  OPTION_COUNTRYOPTIONS_SURINAME,
  OPTION_COUNTRYOPTIONS_SVALBARD_AND_JAN_MAYEN,
  OPTION_COUNTRYOPTIONS_SWAZILAND,
  OPTION_COUNTRYOPTIONS_SWEDEN,
  OPTION_COUNTRYOPTIONS_SWITZERLAND,
  OPTION_COUNTRYOPTIONS_SYRIAN_ARAB_REPUBLIC,
  OPTION_COUNTRYOPTIONS_TAIWAN_ROC,
  OPTION_COUNTRYOPTIONS_TAJIKISTAN,
  OPTION_COUNTRYOPTIONS_TANZANIA_UNITED_REPUBLIC_OF,
  OPTION_COUNTRYOPTIONS_THAILAND,
  OPTION_COUNTRYOPTIONS_TIMOR_LESTE,
  OPTION_COUNTRYOPTIONS_TOGO,
  OPTION_COUNTRYOPTIONS_TOKELAU,
  OPTION_COUNTRYOPTIONS_TONGA,
  OPTION_COUNTRYOPTIONS_TRINIDAD_AND_TOBAGO,
  OPTION_COUNTRYOPTIONS_TUNISIA,
  OPTION_COUNTRYOPTIONS_TURKEY,
  OPTION_COUNTRYOPTIONS_TURKMENISTAN,
  OPTION_COUNTRYOPTIONS_TURKS_AND_CAICOS_ISLANDS,
  OPTION_COUNTRYOPTIONS_TUVALU,
  OPTION_COUNTRYOPTIONS_UGANDA,
  OPTION_COUNTRYOPTIONS_UKRAINE,
  OPTION_COUNTRYOPTIONS_UNITED_ARAB_EMIRATES,
  OPTION_COUNTRYOPTIONS_UNITED_KINGDOM,
  OPTION_COUNTRYOPTIONS_UNITED_STATES,
  OPTION_COUNTRYOPTIONS_UNITED_STATES_MINOR_OUTLYING_ISLANDS,
  OPTION_COUNTRYOPTIONS_URUGUAY,
  OPTION_COUNTRYOPTIONS_UZBEKISTAN,
  OPTION_COUNTRYOPTIONS_VANUATU,
  OPTION_COUNTRYOPTIONS_VENEZUELA,
  OPTION_COUNTRYOPTIONS_VIET_NAM,
  OPTION_COUNTRYOPTIONS_VIRGIN_ISLANDS_BRITISH,
  OPTION_COUNTRYOPTIONS_VIRGIN_ISLANDS_US,
  OPTION_COUNTRYOPTIONS_WALLIS_AND_FUTUNA,
  OPTION_COUNTRYOPTIONS_WESTERN_SAHARA,
  OPTION_COUNTRYOPTIONS_YEMEN,
  OPTION_COUNTRYOPTIONS_ZAMBIA,
  OPTION_COUNTRYOPTIONS_ZIMBABWE,
  LANDING_TERMS_I_HAVE_READ,
  LANDING_TERMS_THE_USE_DISCLOSURE,
  LANDING_TERMS_THE_TRANSFER_OF,
  LANDING_TERMS_I_UNDERSTAND_THAT,
  OPTION_DOESTHEPARTICULATEMATTER_NO,
  OPTION_DOESTHEPARTICULATEMATTER_UNKNOWN,
  OPTION_DOESTHEPARTICULATEMATTER_YES,
  I_HAVE_READ_AND_UNDERSTAND_THE_LINKED_PRIVACY_NOTICE,
  PRODUCT_LOT,
  SHIPPING_DISTRIBUTION_LABEL,
  CARTON_LABEL,
  INTERNAL_PRODUCT_LABEL,
  TITLE_PD_RENAL,
  TITLE_SOLUTIONS,
  TITLE_ACCESS,
  TITLE_ALL_OTHER_PRODUCT,
  REPORTED_PROBLEM,
  LOGIN,
  SYSTEM_MENU,
  INITIATE_PRODUCT_FEEDBACK,
  FEEDBACK_STATUS,
  OKTACALLBACK,
  VALID_EMAIL,
  VALID_NUMERIC,
  PLEASE_UPLOAD_IMAGE,
  VALID_DATE,
  QUANTITY,
  EDIT,
  DELETE,
  LOT_SERIAL_NO,
  LOT_NUMBER_NOT_FOUND,
  SEARCHING_LOT_NUMBER,
  PRODUCT_CODE_NOT_FOUND,
  SEARCHING_PRODUCT_CODE,
  FILE_OF_TYPES_ARE_NOT_ALLOWED,
  THE_FILE_YOU_ARE_ATTEMPTING,
  IMAGE_ICON,
  LOGIN_TO_ACCOUNT,
  SIGN_IN_TO_YOUR_ACCOUNT,
  BAXTER_EMAIL_ADDRESS,
  PASSWORD,
  SIGN_IN,
  UNKNOWN,
  ASKED_UNKNOWN,
  DD_MMM_YYYY,
  DD,
  MMM,
  YYYY,
  SELECT_COUNTRY,
  CHINESE_SIMPLIFIED_CHINESE,
  DUTCH,
  ENGLISH,
  FRENCH,
  GERMAN,
  ITALIAN,
  JAPANESE,
  KOREAN,
  MANDARIN_TRADITIONAL_CHINESE,
  POLISH,
  PORTUGUESE,
  SPANISH,
  THAI,
  TURKISH,
  VIETNAMESE,
  BROWSE,
  FEEDBACK_SUBMITTED,
  YOUR_PRODUCT_EXPERIENCE_FEEDBACK,
  IF_YOU_HAVE_QUESTIONS_OR_ADDITIONAL_INFORMATION,
  CLOSE,
  PATIENT_AGE,
  ENTER_AGE,
  PATIENT_DOB,
  RELEVANT_ATTACHMENTS,
  BAXTER_ACCOUNT_CREDENTIALS,
  GET_PRODUCT_DETAILS,
  USE_THE_DIAGRAM_ABOVE_FIGURE_2,
  FACILITY_ADDRESS,
  LABEL_ANOTHER_FACILITY_ADDRESS,
  CHOOSE_PRODUCT_CODE,
  PRIVACY_NOTICE,
  DECLINE,
  OPTION_COUNTRYOPTIONS_BONAIRE_SINT_EUSTATIUS_AND_SABA,
  OPTION_COUNTRYOPTIONS_CURAÇAO,
  OPTION_COUNTRYOPTIONS_SOUTH_SUDAN,
  OPTION_COUNTRYOPTIONS_ESWATINI,
  FORM_HELP_TEXT,
  YOUR_FIRST_NAME,
  YOUR_LAST_NAME,
  MY_FIRST_NAME,
  MY_LAST_NAME,
  PATIENT_FIRST_NAME,
  PATIENT_LAST_NAME,
  REPORTER_FIRST_NAME,
  REPORTER_LAST_NAME,
  EMPLOYEE_FIRST_NAME,
  EMPLOYEE_LAST_NAME,
  END_USER_CUSTOMER_FIRST_NAME,
  END_USER_CUSTOMER_LAST_NAME,
  ADDITIONAL_CONTACT_FIRST_NAME,
  ADDITIONAL_CONTACT_LAST_NAME,
  COPYRIGHT_BAXTER,
  COPYRIGHT_VERSION,
  ADD_ADDITIONAL_CONTACT,
  CONTACT_ME,
  DO_NOT_CONTACT,
  END_USER_CUSTOMER_FACILITY_NAME,
  END_USER_CUSTOMER_PHONE,
  END_USER_CUSTOMER_EMAIL,
  END_USER_CUSTOMER_FACILITY_ADDRESS,
  SAME_AS_PATIENT_ADDRESS,
  SAME_AS_REPORTER_ADDRESS,
  SAME_AS_END_USER_CUSTOMER_ADDRESS,
  USE_THE_DIAGRAM_ABOVE_FIGURE_3,
  CONTACT_US,
  LANDING_BRIEF_FOR_DEVICE,
  PATIENT_SEX,
  OPTION_PATIENTGENDEROPTIONS_CISGENDER_CISGENDER_MAN_BOY,
  OPTION_PATIENTGENDEROPTIONS_CISGENDER_CISGENDER_WOMAN_GIRL,
  OPTION_PATIENTGENDEROPTIONS_CISGENDER_TRANSGENDER_MAN_TRANS_MAN_FEMALE_TO_MALE_FTM,
  OPTION_PATIENTGENDEROPTIONS_CISGENDER_TRANSGENDER_WOMAN_TRANS_WOMAN_MALE_TO_FEMALE_MTF,
  OPTION_PATIENTGENDEROPTIONS_CISGENDER_OTHER_GENDER_CATEGORY_PLEASE_SPECIFY,
  OPTION_PATIENTGENDEROPTIONS_CISGENDER_DECLINE_TO_ANSWER,
  ATTENTION_NEEDED,
  SUBMIT_ERR_MSG,
  SUBMIT_RETRY_MSG,
  OK,
} from '@translations';

let lang: any = {};
let translations: any = {};
lang.translations = translations;

translations[APP_TITLE] = "Product Feedback Portaal";
translations[LANDING_BRIEF] = "Het online Baxter Product Feedback Portaal is bedoeld voor het indienen van vertrouwelijke informatie en feedback over de producten van Baxter.";
translations[LANDING_LANGUAGE_SELECTOR] = "Selecteer Taal Voorkeur";
translations[LANDING_COUNTRY_SELECTOR] = "Selecteer land van gebeurtenis";
translations[LANDING_TERMS] = "Ik heb de gebruiksvoorwaarden en privacyverklaring voor Baxter's productfeedbackportaal gelezen en ga ermee akkoord.";
translations[LANDING_TERMS_ERROR] = "U moet de inhoud van de Gebruiksvoorwaarden, de Privacyverklaring en de Aanvullende Gebruiksvoorwaarden en privacyverklaring van het Baxter Product Feedback Portaal voor het Baxter Product Feedback Portaal lezen en ermee akkoord gaan.";
translations[LANDING_CAPTCHA_ERROR] = "Controleer of u geen robot bent alsjeblieft ";
translations[APP_DESCRIPTION] = "De online Baxter Product Feedback Portaal is bedoeld voor het indienen van informatie over producten. Als u problemen ondervindt met een Baxter-product, raden we u aan de details van de gebeurtenis te delen. Alle feedback is essentieel voor ons om onze gedeelde doelen te bereiken om het product en de tevredenheid voortdurend te verbeteren.";
translations[LANDING_TERMS_I_HAVE_READ] = "Ik heb de gekoppelde privacyverklaring voor het Baxter Product Feedback Portal gelezen en begrijp dat Baxter Healthcare Corporation (“Baxter”) mijn toestemming vraagt ​​om mijn persoonlijke gegevens te gebruiken, openbaar te maken en te verwerken voor de doeleinden en zoals beschreven in de privacyverklaring. Hierbij geef ik toestemming voor:";
translations[LANDING_TERMS_THE_USE_DISCLOSURE] = "Het gebruik, de openbaarmaking, de opslag en de verwerking van mijn persoonlijke gegevens (inclusief alle gevoelige gegevens, zoals gezondheidsgerelateerde gegevens, die ik verkies te verstrekken) voor de doeleinden die worden beschreven in de privacyverklaring.";
translations[LANDING_TERMS_THE_TRANSFER_OF] = "De overdracht van mijn persoonlijke gegevens (inclusief gevoelige gegevens, zoals gezondheidsgerelateerde gegevens, die ik verkies te verstrekken) uit mijn land en naar een ander land dat mogelijk minder strikte of geen gegevensbeschermingswetten heeft.";
translations[LANDING_TERMS_I_UNDERSTAND_THAT] = "Ik begrijp dat deze toestemming vrijwillig is en dat ik op elk moment van gedachten kan veranderen en mijn toestemming kan intrekken door contact op te nemen met Baxter via de contactgegevens in de Privacyverklaring. Ik begrijp dat het intrekken van mijn toestemming geen invloed heeft op de rechtmatigheid van de verwerking vóór de intrekking ervan.";
translations[MENU_FEEDBACK_FORM] = "Start Product Feedback";
translations[MENU_FEEDBACK_STATUS] = "Controleer Product Feedback Status";
translations[MENU_FORM_INTAKE] = "Verslaggever / Contactinformatie";
translations[MENU_FORM_EVENT_DETAILS] = "Details van de gebeurtenis";
translations[MENU_FORM_PRODUCT_INFO] = "Product Informatie";
translations[SYSTEM_FEEDBACK_FORM] = "Start Product Feedback Formulier";
translations[SYSTEM_FEEDBACK_STATUS] = "Controleer Product Feedback Status";
translations[SUBMIT_FEEDBACK] = "Klik hier om Feedback te geven";
translations[CHECK_SUBMITTED_FEEDBACK] = "Klik hier om de eerder ingediende Feedback te controleren";
translations[BTN_LAUNCH_FORM] = "Start Formulier";
translations[BTN_CHECK_STATUS] = "Controleer Status";
translations[FORM_TITLE] = "Product Feedback forumulier";
translations[FORM_SUB_TITLE] = "Als er meerdere patiënten bij betrokken zijn, vul dan voor elke patiënt een formulier in.";
translations[FORM_MANDATORY_FIELDS] = "Alle velden met een * zijn verplicht";
translations[BUTTON_PREV] = "Vorige";
translations[BUTTON_NEXT] = "Volgende";
translations[BUTTON_SUBMIT] = "Opslaan";
translations[SELECT_RESPONSE] = "Selecteer Antwoord";
translations[FUNCTION_ROLE] = "Functie/Rol";
translations[CUSTOMER_ACCOUNT_NUMBER] = "Klant Account Nummer";
translations[ENTER_CUSTOMER_ACCOUNT] = "klantaccount";
translations[HELP_CUSTOMER_ACCOUNT_NUMBER] = "Wat is het accountnummer van de klant die betrokken is bij de gemelde gebeurtenis?";
translations[EVENT_REPORTED] = "Is deze gebeurtenis eerder gemeld (aan Baxter of een andere entiteit)?";
translations[REFERENCE_NUMBER] = "Referentienummer gekoppeld aan deze gebeurtenis";
translations[ENTER_REFERENCE] = "Referentie ";
translations[WHO_REPORTED_TO] = "Aan wie is dit gemeld?";
translations[WHO_WAS_NOTIFIED] = "Geef de naam op aan wie dit was gemeld?";
translations[ENTER_NAME] = "Naam";
translations[PRODUCT_SURVEILLANCE] = "Kan Product Surveillance/Baxter contact met u of iemand anders opnemen als we nog vragen hebben?";
translations[YOUR_NAME] = "Uw Naam";
translations[OCCUPATION] = "Beroep";
translations[PHONE_NUMBER] = "Telefoonnummer";
translations[ENTER_PHONE_NUMBER] = "Telefoonnummer";
translations[ENTER_EMAIL] = "E-mailadres";
translations[EMAIL_ADDRESS] = "E-mailadres";
translations[ENTER_ADDRESS] = "E-mailadres";
translations[ENTER_NA_IF_UNKNOWN] = "Voer NA in als dit niet bekend is";
translations[FACILITY_HOSPITAL] = "Naam van Faciliteit/Ziekenhuis of Distributeur (indien van toepassing)";
translations[ENTER_FACILITY] = "Faciliteit";
translations[ADDRESS_1] = "Adres 1";
translations[ADDRESS_2] = "Adres 2";
translations[CITY] = "Stad";
translations[STATE] = "Staat";
translations[POSTAL_CODE] = "Postcode";
translations[COUNTRY] = "Land";
translations[END_USER_CUSTOMER] = "Is dit probleem ontdekt door een eindgebruiker/klant?";
translations[ADDITIONAL_CONTACT_PERSON] = "Extra contactpersoon";
translations[ADDITIONAL_PHONE] = "Extra telefoonnummer voor contact";
translations[ADDITIONAL_EMAIL] = "Extra contact e-mailadres";
translations[ANOTHER_FACILITY_ADDRESS] = "Een andere faciliteit/adres toevoegen";
translations[ANOTHER_FACILITY_HOSPITAL] = "Een andere faciliteit/ziekenhuis- of distributeurnaam (indien van toepassing)";
translations[ANOTHER_ENTER_FACILITY] = "Faciliteit";
translations[ANOTHER_ADDRESS_1] = "Adres 1";
translations[ANOTHER_ADDRESS_2] = "Adres 2";
translations[ANOTHER_CITY] = "Stad";
translations[ANOTHER_STATE] = "Staat";
translations[ANOTHER_POSTAL_CODE] = "Postcode";
translations[ANOTHER_COUNTRY] = "Land";
translations[LOT_SERIAL_NUMBER] = "Lotnummer / Serienummer";
translations[ENTER_LOT_SERIAL_NUMBER] = "lotnummer / serienummer";
translations[HELP_LOT_SERIAL_NUMBER] = "Selecteer Onbekend als u het Lot / Serienummer niet weet, of als u het de melder gevraagd heeft en deze het niet wist.";
translations[OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_PRODUCT_CODE] = "Productcode";
translations[PRODUCT_CODE] = "Productcode";
translations[ENTER_PRODUCT_CODE] = "Productcode";
translations[HELP_PRODUCT_CODE] = "Selecteer Onbekend als u de Productcode niet weet, of als u het de melder gevraagd heeft en deze het niet wist.";
translations[NDC] = "National Drug Code (NDC) Nummer";
translations[ENTER_NDC] = "Voer NDC in";
translations[UDI] = "Unieke Product Identificatie / Unique Device Identifier (UDI)";
translations[ENTER_UDI] = "Voer UDI in";
translations[PRODUCT_NAME] = "Productnaam";
translations[ENTER_PRODUCT_NAME] = "Productnaam";
translations[HELP_PRODUCT_NAME] = "Geef de naam of beschrijving van het product";
translations[BEST_DESCRIBES] = "Maak een selectie die het gemelde probleem het beste beschrijft";
translations[QUANTITY_TO_SELECT] = "Selecteer Aantal";
translations[ENTER_QUANTITY] = "Aantal";
translations[HELP_QUANTITY] = "Aantal producten met het gemelde probleem";
translations[UNIT] = "Eenheid";
translations[AVAILABLE_TO_RETURNED] = "Is het daadwerkelijke product met het gemelde probleem beschikbaar om te worden teruggestuurd naar Baxter voor evaluatie?";
translations[PHOTOGRAPH_AVAILABLE] = "Is er een foto of video van het product beschikbaar?";
translations[HELP_PHOTOGRAPH_AVAILABLE] = "Zorg ervoor dat het gemelde probleem zichtbaar is op de foto of video.";
translations[UPLOAD_IMAGES] = "Afbeeldingen uploaden";
translations[REPORTER_NAME] = "Naam klant";
translations[REPORTER_FACILITY] = "Faciliteit Klant";
translations[REPORTER_OCCUPATION] = "Beroep van klant";
translations[ENTER_NUMBER] = "Product nummer";
translations[REPORTER_PHONE_NUMBER] = "Telefoonnummer Klant";
translations[REPORTER_EMAIL_ADDRESS] = "E-mailadres van Klant";
translations[EMPLOYEE_NAME] = "Naam medewerker";
translations[EMPLOYEE_PHONE_NUMBER] = "Telefoonnummer medewerker";
translations[EMPLOYEE_EMAIL_ADDRESS] = "E-mailadres medewerker";
translations[RETURNING_FOR_INVESTIGATION] = "Hoeveel producten (in eenheden) met het gemelde probleem keert u terug voor onderzoek?";
translations[HELP_RETURNING_FOR_INVESTIGATION] = "Deze producten moeten het product zijn met het gemelde probleem.";
translations[UNUSED_BAXTER_PRODUCT] = "Is er ÉÉN ongebruikt Baxter-product van dezelfde partij beschikbaar om naar Baxter te worden teruggestuurd voor evaluatie?";
translations[YOU_INDICATED_SAMPLES] = "U gaf aan dat er producten beschikbaar waren voor evaluatie, kunt u deze naar uw zorgverlener brengen?";
translations[SAMPLE_RETURN_KIT] = "U hebt aangegeven dat producten beschikbaar waren voor evaluatie, bevestig het opgegeven adres om de product retourkit te verzenden:";
translations[A_BOX_WITH_A_PREPAID_LABEL] = "Een doos met een prepaid label wordt naar dit adres gestuurd om het product terug te sturen";
translations[SAME_AS_MY_ADDRESS] = "Hetzelfde als Mijn Adres";
translations[OTHER_CONTACT_NAME] = "Naam van andere contactpersoon";
translations[OTHER_CONTACT_OCCUPATION] = "Beroep van andere contactpersoon";
translations[OTHER_CONTACT_PHONE_NUMBER] = "Telefoonnummer van andere contactpersonen";
translations[OTHER_CONTACT_EMAIL_ADDRESS] = "E-mailadres van andere contactpersoon";
translations[MANUFACTURED_BY_ANOTHER_COMPANY] = "Het product dat u hebt geselecteerd, is vervaardigd door een ander bedrijf, kunnen we uw contactgegevens aan hen verstrekken als ze aanvullende vragen hebben over uw rapport?";
translations[CUSTOMER_EXPLICITLY_REQUEST] = "Heeft de klant expliciet om onderzoeksresultaten gevraagd?";
translations[EXPLICITLY_REQUEST_CREDIT] = "Heeft de klant expliciet krediet aangevraagd?";
translations[PRODUCT_FROM_BAXTER] = "Bestelt de klant het product rechtstreeks bij Baxter?";
translations[QUANTITY_REQUESTED_CREDIT] = "Partijnummer(s) en hoeveelheid die ter creditering worden aangevraagd:";
translations[ENTER_OCCUPATION] = "Beroep";
translations[LOT_QUANTITY_NUMBER] = "Lotnummer en aantal";
translations[WHOLESALERS_NAME] = "Wat is de naam en locatie van de groothandel (stad, staat)";
translations[PLACE_WHOLESALERS_NAME] = "Wat is de naam en locatie van de groothandel (stad, staat)";
translations[ADD_PRODUCT_TO_THE_GRID] = "Product toevoegen aan het raster";
translations[SAVE] = "Opslaan";
translations[CANCEL] = "Annuleren";
translations[ADD_MORE_PRODUCTS] = "VOEG meer producten toe";
translations[REPORTER_ADDRESS] = "Adres van de Klant";
translations[ATTACHMENTS] = "Bijlagen";
translations[DATE_OF_EVENT] = "Datum van de gebeurtenis";
translations[DATE_OF_EVENT_MSG] = "Datum van gebeurtenis kan niet zijn nadat de datum waarop Baxter Employee voor het eerst op de hoogte is gesteld. Voer een geldige datum in.";
translations[HELP_DATE_OF_EVENT] = "Als er meerdere gekende datums zijn waarop de gebeurtenis heeft plaatsgevonden, vul dan voor elke datum een formulier in.";
translations[DATE_BAXTER_EMPLOYEE] = "Datum waarop Baxter werknemer voor het eerst op de hoogte werd gesteld";
translations[DATE_MESSAGE_BAXTER_EMPLOYEE] = "(De opgegeven datum hoeft niet dezelfde te zijn als de datum waarop de informatie is ingevoerd.)";
translations[DURING_WHAT_PROCESS] = "Tijdens welke processtap(s) heeft de gebeurtenis plaatsgevonden?";
translations[WAS_THE_PATIENT] = "Was de patiënt verbonden (behandeling aan de gang) op het moment van de gebeurtenis?";
translations[WERE_YOU_CONNECTED] = "Was u verbonden (behandeling aan de gang) op het moment van het probleem?";
translations[PROVIDE_ANY_ADDITIONAL] = "Geef eventuele aanvullende details met betrekking tot de gebeurtenis/het probleem";
translations[HELP_YOU_IDENTIFIED_MORE] = "U hebt meer dan één product en probleem geïdentificeerd, gelieve te verduidelijken welke producten welke problemen hadden vertoond. ";
translations[ENTER_DETAILS] = "Gegevens";
translations[PROVIDE_ANY_ATTACHMENT] = "Geef een bijlage indien van toepassing";
translations[WAS_NEGATIVE_MEDICAL] = "Was er een negatieve medische impact, symptoom (en) of letsel als gevolg van de gebeurtenis? ";
translations[WAS_MEDICAL_INTERVENTION] = "Werd behandeling, medische interventie of escalatie van zorg verleend om de gemelde gebeurtenis tegen te gaan?";
translations[PROVIDE_DETAILS] = "Geef details";
translations[REQUIRED_TREATMENT] = "Vereiste behandeling/medische interventie";
translations[ENTER_TREATMENT] = "Behandeling";
translations[RELEVANT_TESTS] = "Relevante tests, inclusief laboratoriumgegevens:";
translations[HELP_RELEVANT_TESTS] = "Relevante tests";
translations[RELEVANT_MEDICAL_HISTORY] = "Relevante medische geschiedenis, inclusief reeds bestaande medische aandoeningen:";
translations[ENTER_HISTORY] = "Geschiedenis";
translations[PATIENT_NAME] = "Naam van de patiënt";
translations[PATIENT_INITIALS] = "De initialen van de patiënt of de volledige naam. Als er meerdere patiënten bij betrokken zijn, vul dan voor elke patiënt een formulier in.";
translations[PATIENT_PHONE_NUMBER] = "Telefoonnummer patiënt";
translations[I_DO_NOT_WISH_TO_PROVIDE] = "Ik wil deze informatie niet geven";
translations[PATIENT_EMAIL_ADDRESS] = "E-mailadres patiënt";
translations[PATIENT_ADDRESS] = "Adres patiënt";
translations[SAME_ADDRESS] = "Hetzelfde adres";
translations[DRUG_BEING_USED] = "Werd er een Baxter medicijn gebruikt op het moment van de gebeurtenis?";
translations[PATIENT_IDENTIFIER] = "Patiënt identificatie";
translations[PATIENT_AGE_OR_DOB] = "Patiëntleeftijd of DOB";
translations[ENTER_PATIENT_AGE] = "mm/dd/jjjj, leeftijd van de patiënt";
translations[PATIENT_GENDER] = "Geslacht patiënt";
translations[PATIENT_WEIGHT] = "Gewicht van de patiënt";
translations[ENTER_WEIGHT] = "Gewicht";
translations[PATIENT_WEIGHT_UNIT] = "Gewichtseenheid voor patiënt";
translations[MY_NAME] = "Mijn naam";
translations[ENTER_IN_YOUR_CONTACT] = "Voer uw contactgegevens in ";
translations[MY_PHONE_NUMBER] = "Mijn telefoonnummer";
translations[MY_EMAIL_ADDRESS] = "Mijn e-mailadres";
translations[MY_ADDRESS] = "Mijn adres";
translations[NAME_OF_BAXTER_DRUG] = "Naam van Baxter Medicijn";
translations[ENTER_DRUG_NAME] = "Medicijnnaam";
translations[PLEASE_PROVIDE_THE_NAME] = "Geef de naam of productcode van het Baxter-geneesmiddel op.Geef de naam op van alle Baxter-geneesmiddelen die werden gebruikt op het moment van het gemelde probleem";
translations[SELECT_THE_COMPONENT] = "Selecteer het onderdeel met het probleem";
translations[USE_THE_DIAGRAM] = "Gebruik de bovenstaande diagram (figuur 1) om de locatie van het beschadigde product te bepalen.";
translations[TYPE_OF_DAMAGE] = "Beschrijf de opgelopen schade";
translations[PLEASE_ENTER_VALUE] = "Voer de waarde in";
translations[WAS_THE_PRODUCT_KINKED] = "Was het product geknikt, gebarsten, gebogen, gesneden, etc?";
translations[WERE_ANY_CLEANING] = "Zijn er reinigingsoplossingen, oplosmiddelen of ontsmettingsmiddelen op het Product gebruikt?";
translations[WHAT_WAS_THE_DISINFECTANT] = "Wat was de naam/het merk van het desinfectiemiddel en hoe werd het gebruikt?";
translations[NOTE_BAXTER_LABELING] = "Baxter label geeft aan om geen bleekmiddel, waterstofperoxide, alcohol of antiseptische alcohol te gebruiken op de set/product. Het gebruik van deze producten kan ervoor zorgen dat het product scheuren ontwikkelt.";
translations[SELECT_ALL_THAT_APPLY] = "Selecteer alles wat van toepassing is";
translations[DID_FOLLOWING_OCCUR] = "Is een van de volgende dingen gebeurd?";
translations[SELECT_THE_LOCATION] = "Selecteer de locatie met de schade op de Minicap";
translations[WAS_THE_PRODUCT_EXPOSED] = "Was het product blootgesteld aan overmatige kracht (d.w.z. gebonkt, gestoten, geraakt, enz.) voordat het probleem zich voordeed?";
translations[HOW_LONG_TRANSFER] = "Hoe lang is de mini set / transfer set al in gebruik?";
translations[WAS_THERE_DIFFICULTY] = "Was er een probleem bij het openen of sluiten van de draaiklem?  ";
translations[WAS_DEVICE_OR_TOOL] = "Werd een apparaat of gereedschap gebruikt om de draaiklem te openen of te sluiten?";
translations[DESCRIBE_HOW_PRODUCT] = "Beschrijf hoe het product moeilijk te gebruiken was (Selecteer alles wat van toepassing is)";
translations[DID_YOU_OBSERVE] = "Heeft u schade (bijv. snede, gat, barst) waargenomen met het product?";
translations[WERE_DIFFICULTIES_PUTTING] = "Waren er problemen om de Minicap op de mini set/Transfer Set te zetten en met de klok mee te draaien totdat deze stevig vastzit? ";
translations[WAS_THE_TRANSFER] = "Is de mini set/transferset vervangen vanwege deze gebeurtenis?";
translations[SELECT_TYPE_OF_FLOW] = "Selecteer het type flowprobleem";
translations[WAS_ANYTHING_BLOCKING] = "Was er iets dat de doorstroming blokkeerde?";
translations[WAS_ANY_ALARM] = "Was er een alarm?";
translations[SELECT_BEST_DESCRIBE] = "Selecteer de optie die het probleem het beste beschrijft";
translations[WERE_THE_MINICAPS] = "Werden de Minicaps blootgesteld of opgeslagen in een warme/koude omgeving? ";
translations[WAS_THE_SPONGE_VISIBLE] = "Was de spons zichtbaar in de Minicap?  ";
translations[WHERE_PARTICULATE_MATTERFOREIGN] = "Waar bevinden de fijne deeltjes/ vreemd materiaal zich?";
translations[DESCRIBE_THE_EXACT_LOCATION] = "Beschrijf de exacte locatie, grootte, vorm en kleur van de fijne deeltjes/ vreemd materiaal:";
translations[WAS_THE_PARTICULATE_MATTER] = "Waren de fijne deeltjes/ vreemd materiaal ingebed in het product?";
translations[DOES_THE_PARTICULATE_MATER] = "Lijken de fijne deeltjes / vreemd materiaal stukjes van het productmateriaal te zijn?";
translations[WHAT_COMPONENT_DOES] = "Van welke component lijken de fijne deeltjes te zijn?";
translations[SELECT_CONNECTION_ISSUE] = "Selecteer de optie die het verbindingsprobleem het beste beschrijft";
translations[WERE_ASSIST_DEVICES] = "Zijn er hulpmiddelen of hulpmiddelen gebruikt om de wegwerpset verbinding te maken?";
translations[WERE_ANY_DIFFICULTIES] = "Zijn er problemen opgemerkt tijdens de eerste verbinding of loskoppeling?";
translations[PROVIDE_PRODUCT_INFORMATION] = "Geef de productinformatie op van het tweede product dat betrokken was bij het verbindingsprobleem";
translations[WERE_THE_SPIKE_LUER] = "Werden de spike/luer connectoren met de klok mee gedraaid totdat ze stevig vastzaten?";
translations[BAXTER_LABELING_STATES] = "Baxter label geeft aan om ervoor te zorgen dat alle wegwerpset verbindingen veilig en fit zijn voordat de therapie wordt gestart.";
translations[WERE_PETS_OR_ANIMALS] = "Waren er huisdieren of dieren die schade hadden kunnen oplopen aan de wegwerpset? ";
translations[BAXTER_LABELING_CONTAMINATION] = "Baxter label geeft aan dat verontreiniging van de vloeistofroutes kan optreden als een huisdier of dier de wegwerp benodigdheden bijt. Om dit risico te verminderen, moet u geen dialyse uitvoeren in dezelfde kamer als huisdieren of dieren.";
translations[WERE_OTHER_ISSUES] = "Waren er andere problemen of moeilijkheden in verband met de spike / luer (d.w.z. gebarsten, vervormd, gebogen enz.)? ";
translations[WAS_MINICAP_TWISTED] = "Was de Minicap met de klok mee gedraaid op de connector van de transferset totdat deze stevig was bevestigd? ";
translations[WERE_DIFFICULTIES_TRANSFER_SET] = "Waren er problemen met het plaatsen van de Minicap op de mini set/Transfer Set? ";
translations[DID_TRANSFER_SET_CONNECTORS] = "Hadden de connectoren van de mini set/transferset zichtbare schade of residu op de schroefdraad? ";
translations[WHAT_WAS_THE_ALARM] = "Wat was het alarm?";
translations[WHERE_OBSERVED_DAMAGE] = "Waar was de waargenomen schade (selecteer alles wat van toepassing is)?";
translations[SELECT_THE_TYPE_OBSERVED] = "Selecteer het type van de waargenomen schade (selecteer alles wat van toepassing is):";
translations[DID_DAMAGE_CAUSE_LEAK] = "Heeft de schade een lek veroorzaakt?";
translations[WAS_THE_SHIPPING_CARTON] = "Werd de verzenddoos geopend met een scherp voorwerp?";
translations[SELECT_FLOW_ISSUE_OBSERVED] = "Selecteer type vn het waargenomen flow probleem";
translations[HOW_LONG_WAS_STORAGE] = "Hoe lang was het in opslag voordat het vervallen product werd gevonden?";
translations[WAS_THERE_AN_ADAPTER] = "Is er een adapter of andere apparaten gebruikt bij het product?";
translations[NAME_AND_MODEL] = "Wat is de naam en het model van de adapter of het ander gebruikt apparaat ?";
translations[NAME_VAPORIZER] = "Wat is de naam en het model van de Vaporizer?";
translations[WAS_VIAL_INVERTED] = "Was de bijgevoegde injectieflacon omgekeerd voordat de oplossing in de injectieflacon werd geperst?          ";
translations[WHAT_VIAL_USED] = "Wat is de productinformatie voor de gebruikte injectieflacon?";
translations[DRUG_NAME_MANUFACTURER] = "Naam van het geneesmiddel, fabrikant, grootte van de medicijn fles";
translations[WERE_BREAK_FRANGIBLE] = "Was je in staat om de frangible goed te breken met een heen en weer beweging?  ";
translations[WAS_ALARM_ASSOCIATED] = "Was er een alarm in verband met de no flow?";
translations[WHAT_PART_DISCOLORED] = "Welk deel van het product is verkleurd? (selecteer alles wat van toepassing is)";
translations[DESCRIBE_DISCOLORATION] = "Beschrijf de verkleuring (beschrijf kleur, tint, tint, schaduw, enz.):";
translations[HOW_PRODUCT_STORED] = "Hoe werd het product opgeslagen?";
translations[DOES_DISCOLORATION_APPEAR] = "Lijkt de verkleuring ondoorzichtig, wazig, troebel en/of heeft cirkelvormige/honingraatmarkeringen?";
translations[WHICH_CHAMBER_DISCOLORED] = "Welke kamer was verkleurd op de zak?";
translations[WAS_PEEL_SEAL_INTERCHAMBER] = "Was de schilzegel of tussenkamerfrangible al verbroken/geactiveerd?";
translations[WAS_DISCOLORATION_NOTICED] = "Werd de verkleuring opgemerkt door het kijkglas van de vaporizer?";
translations[SELECT_SPECIFICALLY_DESCRIBES] = "Selecteer een optie die het probleem specifieker beschrijft:";
translations[WHAT_DEVICE_HAD_ALARM] = "Welk apparaat had het alarm?";
translations[WHAT_MISSING_MISASSEMBLED] = "Welk onderdeel ontbrak of was verkeerd gemonteerd?";
translations[RECONSTITUTION_ISSUE] = "Geef een meer specifieke beschrijving van het reconstitutie probleem";
translations[WHAT_MEDICATION_SOLUTION] = "Met welke medicatie/oplossing werd het product gereconstitueerd?";
translations[WHAT_VOLUME_MEDICATION] = "Wat was het volume van de medicatie/oplossing die werd gebruikt om te reconstitueren?";
translations[WHAT_DEVICES_RECONSTITUTION] = " Welke andere apparaten werden gebruikt tijdens reconstitutie (naam/fabrikant, naaldgrootte/meter, enz.)";
translations[WAS_PRODUCT_EXPOSED_HEAT] = "Werd het product blootgesteld aan hitte?     ";
translations[DESCRIBE_EXPOSURE] = "Beschrijf de blootstelling (temperatuur, hoe lang, enz.)";
translations[WHAT_USED_ACTIVATE_SOLUTION] = "Welke techniek werd gebruikt om de oplossing te activeren? ";
translations[WAS_DAMAGE_OBSERVED] = "Is er voorafgaand aan de activering schade aan het product geconstateerd?";
translations[DESCRIBE_THE_DAMAGE] = "Beschrijf de schade:";
translations[APPROXIMATELY_SOLUTION_POWDER] = "Hoeveel oplossing of poeder was ongeveer onder- of overgevuld?";
translations[WAS_LEAK_OBSERVED] = "Is er een lek waargenomen?";
translations[WHAT_FEATUR_DIFFICULT_USE] = "Welk onderdeel of kenmerk van het product is moeilijk te gebruiken?";
translations[HOW_WAS_DIFFICULT_USE] = "Hoe was het product moeilijk te gebruiken?";
translations[WHERE_MATTER_FOREIGN] = "Waar bevonden de fijne deeltjes/vreemd materiaal zich?";
translations[DOES_PARTICULATE_MATTER] = "Blijken de fijne deeltjes/vreemde stoffen stukjes productmateriaal te zijn?";
translations[DESCRIBE_EXACT_LOCATION] = "Beschrijf de exacte locatie, kleur, grootte, vorm en textuur van de fijne deeltjes/vreemd materiaal:";
translations[WAS_MATTER_FOREIGN] = "Waren de fijne deeltjes/vreemd materiaal in het product ingebed (niet vrij bewegend)?";
translations[WHEN_MATTER_FOREIGN] = "Wanneer werden de fijne deeltjes/vreemd materiaal waargenomen?";
translations[PROVIDE_INFORMATION_MEDICATION] = "Geef productinformatie voor de toegevoegde medicatie:";
translations[PRODUCT_NAME_CODE_NUMBER] = "Productnaam, productcode, productpartijnummer, merknaam";
translations[DESCRIBE_SPIKING] = "Beschrijf de spiking- of reconstitutietechniek die werd gebruikt: ";
translations[INCLUDE_NEEDLE] = "Inclusief naaldgrootte / meter, hoek van spiking / piercing, aantal pogingen";
translations[WHAT_ADMINISTRATION_RECONSTITUTION] = "Welke toedieningsset of reconstitutieapparaat werd gebruikt?   ";
translations[INCLUDE_MANUFACTURER] = "Inclusief fabrikant, productnaam, productcode, productpartij";
translations[WAS_MEDICATION_ADDITIVE] = "Is er een medicijn, additief of reconstitutieoplossing aan het product toegevoegd?";
translations[WHAT_MEDICATION_ADDITIVE] = "Welke medicatie, additief of reconstitutieoplossing werd toegevoegd?";
translations[WHAT_STATE_OF_PRODUCT] = "Wat was de toestand van het product toen de troebelheid/bezinking werd waargenomen?";
translations[AFTER_UNITS_SAT] = "Nadat de eenheden uit de doos waren en kamertemperatuur bereikten, verdween de bewolking / bezinking?";
translations[DID_ATTEMPT_AGITATE] = "Heb je geprobeerd de eenheid op te winden?";
translations[DID_PRECIPITATE_DISSOLVE] = "Loste het bezinking op?";
translations[WHAT_STORAGE_TEMPERATURE] = "Wat waren de opslagtemperatuur en -omstandigheden van het product?";
translations[PROVIDE_TEMPERATURE_LOCATION] = "Geef de temperatuur, locatie, opgeslagen binnen of buiten de beschermende verpakking / doos, in VSC / Intermediate Carton, Individuele eenheden";
translations[ARE_TEMPERATURE_LOGS] = "Zijn temperatuurlogboeken voor de vriezer(s) waarin het product is opgeslagen beschikbaar?  ";
translations[LOGS_CAN_BE_ATTACHED] = "Logboeken kunnen rechtstreeks aan dit formulier worden toegevoegd, indien beschikbaar op het moment van indiening";
translations[IS_THE_STORAGE_UNIT] = "Is de opslagruimte (vriezer of koelkast) gekalibreerd en temperatuur gecontroleerd?";
translations[HOW_PRODUCT_THAWED] = "Hoe is het product ontdooid?";
translations[WHAT_STORAGE_CONDITIONS] = "Wat waren de bewaarcondities van het product? (temperatuur, locatie, opgeslagen binnen of buiten de beschermende verpakking/doos)";
translations[WAS_ANY_DAMAGE] = "Is er schade aan het product of probleem geconstateerd?";
translations[MORE_SPECIFIC_INFORMATION] = "Geef meer specifieke informatie:";
translations[WHAT_PURPOSE_INDICATION] = "Wat was het doel/de indicatie van de behandeling voor de patiënt? ";
translations[WHAT_ROUTE_ADMINISTRATION] = "Wat was de administratieve route? ";
translations[WHAT_DATE_ADMINISTRATION] = "Wat was de datum van toediening en de duur?";
translations[WHAT_DOSAGE_STRENGTH] = "Wat was de dosering/sterkte toegediend aan de patiënt? ";
translations[WAS_RECENT_PRESCRIPTION] = "Was er een recente voorschriftwijziging?";
translations[WHAT_WAS_STORAGE_TEMPERATURE] = "Wat waren de opslag-/temperatuurgegevens van het product (locatie van opslag/koelkast/vriezer, enz.)?";
translations[WERE_ANY_ADJUSTMENTS] = "Waren er aanpassingen aan de oplossing of additieven voorafgaand aan de toediening? ";
translations[SELECT_APPROPRIATE_DESCRIPTION] = "Selecteer de meest geschikte beschrijving van het probleem:";
translations[SELECT_LABELING_ISSUE] = "Selecteer de meest geschikte beschrijving van het label probleem:";
translations[WAS_CONNECTION_SECURE] = "Was de verbinding veilig en volledig aangespannen?";
translations[WAS_EXPIRED_PRODUCT] = "Werd het vervallen product toegediend aan een patiënt?";
translations[WAS_COMPONENT_DAMAGED] = "Is er een onderdeel beschadigd?";
translations[WERE_ABNORMALITIES_DAMAGE] = "Zijn er afwijkingen/beschadigingen waargenomen aan het product?";
translations[WHAT_PURCHASE_ORDER_NUMBER] = "Wat is uw inkoopordernummer?";
translations[WHAT_DATE_OF_ADMINISTRATION] = "Wat was de datum van toediening? ";
translations[WHAT_WAS_EXPIRATION_DATE] = "Wat was de vervaldatum op het product? ";
translations[DESCRIBE_WAS_INCORRECT] = "Beschrijf wat onjuist, onvolledig, ontbrekend, onleesbaar was op het label of wat te veel leek (op een ander product) op het label:";
translations[WHAT_SCANNER_USED] = "Welk type van scanner werd gebruikt? ";
translations[WAS_OVERPOUCH_POUCH] = "Zat het product nog in de beschermende verpakking/verpakking tijdens het scannen?";
translations[WHAT_BACKGROUND_COLOR] = "Wat was de achtergrondkleur bij het scannen?";
translations[DO_ALL_OF_THE_LABELS] = "Hebben alle labels (product, doos/doos, verzending/distributie) dezelfde productinformatie?";
translations[PRODUCT_INFORMATION] = "Product Informatie";
translations[IS_A_BARCODE_SCANNER] = "Wordt er een streepjescode scanner gebruikt bij u op locatie? ";
translations[HOW_ARE_THESE_PRODUCTS] = "Hoe worden deze producten opgeslagen in de faciliteit?";
translations[WHAT_INFORMATION_INCORRECTLY] = " Welke informatie werd onjuist weergegeven bij het scannen?";
translations[WAS_THERE_LEAK] = "Is er een lek of vocht waargenomen?";
translations[WHERE_LEAK_OBSERVED] = "Waar werd het lek waargenomen, welk onderdeel lekte?";
translations[WAS_FRANGIBLE_OBSERVED] = "Was de frangible gebroken?";
translations[IS_MOISTURE_CLEAR] = "Is het vocht helder?    ";
translations[WHO_IS_YOUR_DISTRIBUTOR] = "Wie is uw distributeur?";
translations[WHAT_MANUFACTURER_MEDICATION] = "Wat is de fabrikant, de naam van het medicijn en de grootte van de gebruikte injectieflacon?  ";
translations[WHAT_GAUGE_NEEDLE] = "Wat is de diameter van de gebruikte naald, de fabrikant en het aantal keren dat de locatie is doorboord? ";
translations[WHAT_ADMINISTRATION_SET] = "Welke administratieset is gebruikt? ";
translations[WAS_DIFFICULTY_SPIKING] = "Was het moeilijk te spiken?";
translations[WERE_FOLLOWING_SCENARIOS] = "Deden zich een van de volgende scenario's voor bij het lek? ";
translations[WAS_FRANGIBLE_OBSERVED_DEFECT] = "Bleek de frangible schade of een defect te hebben?";
translations[WHAT_AMOUNT_PRESSURE] = "Hoeveel druk werd uitgeoefend en voor welke duur?";
translations[WAS_BAG_COMPLETELY] = "Was de zak volledig en correct in de drukmanchet gestoken (was één uiteinde buiten de drukmanchet)?";
translations[WHAT_MANUFACTURER_MODEL] = "Wat is de fabrikant, het model en de grootte van de drukmanchet?      ";
translations[WHAT_PRESSURE_PRIOR] = "Wat was de druk voordat het lek werd gedetecteerd?      ";
translations[LIST_THE_VAPORIZER] = "Vermeld de fabrikant van de vaporizer en de naam/het model";
translations[APPROXIMATELY_HOW_MUCH] = "Hoeveel vloeistof is er ongeveer gemorst?  ";
translations[WAS_THE_BOTTLE_DIFFICULT] = "Was de fles moeilijk in de vaporizer te steken?";
translations[WERE_VISIBLE_DEFECTS] = "Waren er zichtbare gebreken/defects?";
translations[SELECT_THE_OPTION] = "Selecteer de optie die het verbindingsprobleem het beste beschrijft";
translations[PROVIDE_INVOLVED_CONNECTION_ISSUE] = "Geef de productinformatie op van het tweede product dat betrokken was bij het verbindingsprobleem";
translations[WHICH_PART_SEPARATED] = "Welk(e) deel(en) van het product waren gescheiden?";
translations[WHAT_COMPONENT_DISCOLORED] = "Welk onderdeel is verkleurd?";
translations[SELECT_DESCRIBES_DISCOLORATION] = "Selecteer de optie die de verkleuring het beste beschrijft:";
translations[WAS_THE_SET_DISCOLORED] = "Was de set verkleurd toen deze uit de verpakking werd gehaald?";
translations[DID_SET_CHANGE_COLOR] = "Veranderde de set van kleur na het toevoegen van medicatie?";
translations[WHAT_MEDICATION_ADDED] = "Welke medicatie werd toegevoegd voorafgaand aan de kleurverandering?";
translations[WHERE_MATERIAL_LOCATED] = "Waar bevonden de fijne deeltjes / vreemd materiaal zich?";
translations[DESCRIBE_APPEARANCE_COLOR_SIZE] = "Beschrijf de fijne deeltjes / vreemd materiaal (uiterlijk / kleur / grootte): ";
translations[WAS_EMBEDDED_PLASTIC] = "Zaten de fijne deeltjes/vreemd materiaal los of ingebed in het plastic?";
translations[WAS_THERE_A_PRECIPITATE] = "Was er een bezinking of verandering in kleur van het infundaat /oplossing die niet werd verwacht?";
translations[WHAT_MEDICATIONS_SOLUTIONS] = "Welke medicijnen/oplossingen zijn door de set gebruikt? ";
translations[WHERE_DAMAGE_COMPONENT_AFFECTED] = "Waar was de schade of welk onderdeel (en) werd beïnvloed (selecteer alles wat van toepassing is)?";
translations[WHAT_DAMAGE_ISSUE] = "Welk type schade / probleem werd waargenomen (selecteer alles wat van toepassing is)? ";
translations[DID_ISSUE_RESULT] = "Heeft dit probleem geleid tot een lek?";
translations[WAS_PATIENT_CONNECTED] = "Was de patiënt verbonden met het product?";
translations[WAS_PRODUCT_REPLACED] = "Is het product vervangen door een nieuw product?";
translations[WHICH_SITUATION_BEST] = "Welke situatie beschrijft het scheiding / verbinding probleem het beste";
translations[SELECT_MOST_LABELING_ISSUE] = "Selecteer de meest geschikte beschrijving van het label probleem:";
translations[WHAT_INFORMATION_DISPLAYED] = " Welke informatie werd weergegeven?";
translations[WHAT_SCANNER_WAS_USED] = "Welk type van scanner werd gebruikt? ";
translations[INCLUDE_THE_MODEL_NAME] = "Geef de modelnaam";
translations[WAS_PRODUCT_ORDERED] = "Is het product rechtstreeks bij Baxter of een andere distributeur besteld?";
translations[WHERE_LEAK_COMING] = "Waar komt het lek vandaan (selecteer alles wat van toepassing is)?";
translations[DID_SCENARIOS_OCCURRED_LEAK] = "Heeft zich een van de volgende scenario's voorgedaan met het lek? ";
translations[WAS_POWER_INJECTOR] = "Werd het product gebruikt met een powerinjector?";
translations[WHAT_INJECTOR_USED] = "Welke powerinjector werd gebruikt?";
translations[MANUFACTURER_NAME_CODE_LOT] = "Fabrikant, productnaam, productcode, productpartij";
translations[DESCRIBE_INCORRECT_INCOMPLETE] = "Beschrijf wat onjuist, onvolledig, ontbrekend, onleesbaar of gewijzigd was op het label:";
translations[PROVIDE_INFORMATION_SECOND_PRODUCT] = "Geef de productinformatie op van het tweede product dat betrokken was bij het loskoppelen";
translations[WHICH_COMPONENTS_WERE_FOUND] = "Welke onderdelen bleken een barst of breuk te hebben?";
translations[DESCRIBE_CUT_HOLE_SLICE] = "Beschrijf de exacte locatie op de buis/slang met de snede, het gat of de plak:";
translations[WAS_LEAK_ORIGINATING] = "Was het lek afkomstig van de opening van de injectieplaats?";
translations[PROVIDE_DISCONNECTION_CONNECTION] = "Geef de productinformatie op van het tweede product dat betrokken was bij het verbreken van de verbinding/het probleem met de verbinding";
translations[WHICH_SPECIFIC_BONDED] = "Welke specifieke gebonden componenten bleken gescheiden te zijn?";
translations[WERE_VISIBLE_IRREGULARITIES] = "Waren er zichtbare onregelmatigheden/beschadigingen aan het betrokken product/de betrokken componenten ";
translations[WAS_SUCCESSFUL_CONNECTION] = "Is er uiteindelijk een succesvolle verbinding of ontkoppeling tot stand gekomen (zonder het product te hoeven vervangen)? ";
translations[WAS_TOOL_USED_ASSIST] = "Werd er een hulpmiddel gebruikt om te helpen bij het aansluiten/verbreken?";
translations[WERE_LUER_CONNECTIONS] = "Werden alle Luer-verbindingen gecontroleerd om er zeker van te zijn dat ze veilig waren voor gebruik (per labelkopie)";
translations[WAS_PRODUCT_SECURELY] = "Was het product veilig verbonden met een ander product voordat het werd losgekoppeld?";
translations[WHICH_DESCRIBES_FLOW_ISSUE] = "Welke situatie beschrijft het flowprobleem het beste?";
translations[WHAT_FLOWING_BACKWARDS] = "Wat stroomde er achteruit?";
translations[DESCRIBE_COMPONENTS_BACKFLOW] = "Beschrijf de componenten van waaruit de terugstroom/flow begon tot waar deze stopte:";
translations[DO_SITUATIONS_APPLY] = "Is een van deze situaties van toepassing op deze gebeurtenis?";
translations[WHICH_SPECIFIC_AREA] = "Welk specifiek gebied van de set of component was geassocieerd met de flowproblemen?";
translations[WAS_FLOW_PREVIOUSLY_SEEN] = "Was er eerder stroming/flow te zien door de set of component?";
translations[WAS_ANY_FOLLOWING_OBSERVED] = "Werd een van de volgende waargenomen:";
translations[WHERE_SIMULTANEOUS_FLOW] = "Waar was de Simultane Stroom/flow tussen?";
translations[WHAT_TYPE_HANGER] = "Welk type hanger werd gebruikt?";
translations[WHAT_WAS_HANGER_LENGTH] = "Wat was de lengte van de hanger en/of fabrikant?";
translations[WHICH_BAG_LOWER] = "Welke tzak was lager?";
translations[WHAT_Y_SITE_WAS] = "Op welke y-site was de secundaire set aangesloten?";
translations[WHAT_COMPONENT_WITHIN] = "Welk onderdeel in de set kan niet worden gezuiverd van oplossing of bloed?";
translations[WAS_COMPONENT_SET_REPLACED] = "Is het onderdeel/de set vervangen nadat deze niet meer kan worden gezuiverd?";
translations[WHAT_VOLUME_FLUID_PERIOD_TIME] = "Wat was het volume van vloeistof dat aan de patiënt moest worden toegediend en de voorgeschreven periode?";
translations[WHAT_VOLUME_FLUID_OVER_TIME] = "Wat was het volume van vloeistof dat daadwerkelijk in de patiënt werd toegediend gedurende welke periode?";
translations[WAS_USED_WITH_PUMP] = "Werd de set gebruikt met een pomp?";
translations[DID_CLAMP_FAIL] = "Heeft een klem de stroom/flow niet kunnen stoppen of regelen?";
translations[WHAT_CLAMP_FAILED] = "Welke klem faalde?";
translations[WAS_ISSUES_OBSERVED_CLAMP] = "Zijn er problemen waargenomen met de klem?";
translations[DO_OTHER_SITUATIONS_DESCRIBE] = "Beschrijft een van deze andere situaties het productprobleem (selecteer alles wat van toepassing is)?";
translations[DESCRIBE_ALARM_OBSERVED] = "Beschrijf het waargenomen alarm:";
translations[INCLUDE_ANY_MESSAGES] = "Voeg eventuele berichten en fout codes toe die aan het alarm zijn gekoppeld";
translations[WHICH_CLAMP_HAD_ISSUE] = "Welke klem had het probleem?";
translations[WHICH_TYPE_CLAMP_ISSUE] = "Welk type van klemprobleem is er ondervonden (selecteer alles wat van toepassing is)?";
translations[SELECT_BEST_DESCRIBES_ISSUE] = "Selecteer het scenario dat het probleem het beste beschrijft:";
translations[PROVIDE_MORE_DETAILS] = "Geef meer details over hoe het product moeilijk te gebruiken was:";
translations[PROVIDE_MORE_DETAILS_INSTRUCTIONS] = "Geef meer details over de instructies die moeilijk te volgen/te begrijpen waren:";
translations[DESCRIBE_THE_SMELL] = "Beschrijf de geur en waar deze vandaan kwam:";
translations[WAS_ISSUES_WITH_SET] = "Zijn er problemen waargenomen met de set?";
translations[WHERE_LEAK_LOCATED] = "Waar op het product bevond zich het lek?";
translations[DID_OCCUR_WITH_LEAK] = "Is er iets van het volgende gebeurd met het lek? ";
translations[PROVIDE_INVOLVED_DISCONNECTION] = "Geef de productinformatie op van het tweede product dat betrokken was bij het loskoppelen";
translations[DID_OCCURRED_WITH_THE_LEAK] = "Heeft zich een van de volgende scenario's voorgedaan met het lek? ";
translations[WHERE_WAS_PRODUCT_DAMAGED] = "Waar is het product beschadigd? ";
translations[SELECT_ALL_APPLY] = "Selecteer alles wat van toepassing is";
translations[DESCRIBE_OBSERVED_DAMAGE] = "Beschrijf de waargenomen schade";
translations[WHAT_COMPONENT_IS_DISCOLORED] = "Welk onderdeel van het product was verkleurd?";
translations[DESCRIBE_HUE_TINT_SHADE] = "Beschrijf de waargenomen kleur (tint, tint, schaduw, enz.):";
translations[INSIDE_OUTSIDE_OVERPOUCH] = "Binnen of buiten beschermende verpakking, temperatuur, blootstelling aan licht, etc.";
translations[DESCRIBE_EXACT_LOCATION_SIZE] = "Beschrijf de exacte locatie, grootte, vorm en kleur van de fijne deeltjes/ vreemd materiaal:";
translations[DOES_THE_PARTICULATE_MATTER] = "Lijken de fijne deeltjes/vreemd materiaal productmateriaal te zijn?";
translations[WAS_PARTICULATE_MATERIAL_EMBEDDED] = "Was de fijne deeltjes / vreemd materiaal ingebed?";
translations[DOES_APPEAR_PRODUCT_MATERIAL] = "Lijken de fijne deeltjes / vreemd materiaal stukjes van het productmateriaal te zijn?";
translations[WHERE_DID_THE_ISSUE_OCCUR] = "Waar op het product deed het probleem zich voor?";
translations[LIST_COMPONENTS_IF] = "Componenten weergeven. Als het om een tweede product ging, geef dan fabrikant, productnaam, productcode, productpartij op";
translations[WERE_THERE_VISIBLE_IRREGULARITIES] = "Zijn er zichtbare onregelmatigheden/beschadigingen geconstateerd?";
translations[SELECT_OPTION_FLOW_ISSUE] = "Selecteer de optie die het stroomprobleem het beste beschrijft";
translations[DESCRIBE_IRREGULARITIES] = "Beschrijf onregelmatigheden/schade en of er schade is geconstateerd voorafgaand aan de verbinding/ontkoppeling of indien deze is opgetreden tijdens de verbinding/ontkoppeling";
translations[HOW_PRODUCT_SETUP] = "Hoe was het product ingesteld?";
translations[SELECT_MOST_APPROPRIATE_DESCRIPTION] = "Selecteer de meest geschikte beschrijving van het label probleem:";
translations[DESCRIBE_WHAT_INCORRECT_INCOMPLETE] = "Beschrijf wat onjuist, onvolledig, ontbrekend, onleesbaar was op het label of wat te veel leek (op een ander product) op het label:";
translations[WAS_SHIPPING_CARTON_DAMAGED] = "Was het product in de verzenddoos beschadigd?";
translations[WHAT_PRODUCT_WAS_SUPPOSED] = "Welk product moest worden ontvangen?";
translations[IF_PRODUCT_CODE_NOT] = "Als de productcode niet beschikbaar is, geef dan een productbeschrijving op";
translations[WAS_THE_CASE_MISSING] = "Bevatte de verpakking geen droog ijs of gekoelde gel packs?";
translations[WHAT_CARRIER_DELIVERED] = "Welke courier heeft uw product geleverd?";
translations[WHAT_IS_PURCHASE_ORDER_NUMBER] = "Wat is het inkoopordernummer?";
translations[WHAT_QUANTITY_MISSING_UNITS] = "Wat was de hoeveelheid ontbrekende eenheden?";
translations[WAS_EXPIRED_PRODUCT_USE] = "Is het vervallen product gebruikt?";
translations[APPLY_TO_EACH_UNIT] = "Als dit probleem zich in meer dan één eenheid heeft voorgedaan, zijn de onderstaande vragen van toepassing op elke eenheid.";
translations[TERMS_CONDITIONS] = "Algemene voorwaarden ";
translations[PRIVACY_POLICY] = "Privacybeleid";
translations[PRIVACY_NOTICE] = "Privacyverklaring";
translations[COOKIE_POLICY] = "Cookiebeleid";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_ASKED_UNKNOWN] = "Gevraagd maar Onbekend";
translations[OPTION_FUNCTIONOPTIONS_BAXTER_EMPLOYEE] = "Baxter Werknemer";
translations[OPTION_FUNCTIONOPTIONS_CAREGIVER] = "Zorgverlener";
translations[OPTION_FUNCTIONOPTIONS_DISTRIBUTOR] = "Distributeur";
translations[OPTION_FUNCTIONOPTIONS_HEALTHCARE_PROFESSIONAL] = "Verzorgend Personeel";
translations[OPTION_FUNCTIONOPTIONS_PATIENT] = "Patiënt";
translations[OPTION_FUNCTIONOPTIONS_OTHER] = "Andere";
translations[OPTION_PROCESSSTEPOPTIONS_AFTER_USE] = "Na Gebruik";
translations[OPTION_PROCESSSTEPOPTIONS_BEFORE_USE] = "Voor gebruik";
translations[OPTION_PROCESSSTEPOPTIONS_DURING_SETUP_PREPARATION] = "Tijdens Opstellen/Voorbereiden/Samenstellen";
translations[OPTION_PROCESSSTEPOPTIONS_DURING_THERAPY] = "Na Gebruik";
translations[OPTION_PROCESSSTEPOPTIONS_MULTIPLE_STEPS] = "Meerdere stappen";
translations[OPTION_PROCESSSTEPOPTIONS_NOT_SPECIFIED] = "Niet gespecificeerd";
translations[OPTION_OCCUPATIONOPTIONS_FAMILY_MEMBER] = "Familielid";
translations[OPTION_OCCUPATIONOPTIONS_NURSE] = "Verpleegster";
translations[OPTION_OCCUPATIONOPTIONS_NURSE_PRACTITIONER] = "Verpleegkundige";
translations[OPTION_OCCUPATIONOPTIONS_OTHER_HEALTH_CARE_PROFESSIONAL] = "Andere Gezondheidszorg beoefenaar";
translations[OPTION_OCCUPATIONOPTIONS_PHYSICIAN] = "Dokter";
translations[OPTION_UNITOPTIONS_BOXES] = "Doxen";
translations[OPTION_UNITOPTIONS_PALLETS] = "Palletten";
translations[OPTION_UNITOPTIONS_UNITS] = "Eenheid";
translations[OPTION_PROBLEMOPTIONS_ALARM_CONDITION] = "Alarm gerelateerd";
translations[OPTION_PROBLEMOPTIONS_DAMAGE] = "Schade";
translations[OPTION_PROBLEMOPTIONS_DIFFICULT_TO_USE] = "Moeilijk te gebruiken";
translations[OPTION_PROBLEMOPTIONS_DISCOLORED] = "Verkleurd";
translations[OPTION_PROBLEMOPTIONS_FLOW_ISSUES] = "Doorstroom problemen";
translations[OPTION_PROBLEMOPTIONS_LABELING_ISSUES] = "Labelling probleem";
translations[OPTION_PROBLEMOPTIONS_LEAK_EXCESSIVE_MOISTURE] = "Lek / overmatig vochtig";
translations[OPTION_PROBLEMOPTIONS_PARTICULATE_MATTER_FOREIGN_MATERIAL] = "Zwevende deeltjes / Vreemd Materiaal";
translations[OPTION_PROBLEMOPTIONS_PATIENT_REACTION_ADVERSE_EVENT] = "Patient reactie / Ongewenste bijwerking";
translations[OPTION_PROBLEMOPTIONS_PRODUCT_INQUIRY] = "Product vraag";
translations[OPTION_PROBLEMOPTIONS_SEPARATION_CONNECTION] = "Scheiding / Verbinding";
translations[OPTION_PROBLEMOPTIONS_SHIPPING_ISSUES_EXPIRED_PRODUCT] = "Verzending problemem / vevallen Product";
translations[OPTION_PATIENTSEXOPTIONS_FEMALE] = "Vrouw";
translations[OPTION_PATIENTSEXOPTIONS_UNDIFFERENTIATE] = "Ongedifferentieerd";
translations[OPTION_PATIENTSEXOPTIONS_MALE] = "Man";
translations[OPTION_PATIENTSEXOPTIONS_DECLINETOANSWER] = "Weigeren te antwoorden";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_ADMINISTRATOR_SUPERVISOR] = "Beheerder/Supervisor";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_BIOMEDICAL_ENGINEER] = "Biomedisch Ingenieur";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_COMPANY_REPRESENTATIVE] = "Bedrijfvertegenwoordiger";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_DENTIST] = "Tandarts";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_DISTRIBUTOR] = "Distributeur";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_FAMILY_MEMBER] = "Familielid";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_LAY_USER] = "Lay User";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_NURSE] = "Verpleegster";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_NURSE_PRACTITIONER] = "Verpleegkundige";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_OTHER_HEALTH_CARE_PROFESSIONAL] = "Andere Gezondheidszorg beoefenaar";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_PHARMACIST] = "Apotheker";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_PHARMACY_TECHNICIAN] = "Apotheker Technicus";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_PHYSICIAN] = "Dokter";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_PATIENT] = "Patient";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_RISK_MANAGER] = "Risico Manager";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_OTHER] = "Andere";
translations[OPTION_PRODUCTSURVEILLANCECONTACTOPTIONS_CONTACT_ADDITIONAL_CONTACT_PERSON] = "Contacteer extra contact persoon";
translations[OPTION_PRODUCTSURVEILLANCECONTACTOPTIONS_CONTACT_ME] = "Contacteer me";
translations[OPTION_PRODUCTSURVEILLANCECONTACTOPTIONS_CONTACT_OTHER] = "Contacteer Andere";
translations[OPTION_REPORTEDTOOPTIONS_BAXTER] = "Baxter";
translations[OPTION_REPORTEDTOOPTIONS_CHINA_FDA] = "China FDA";
translations[OPTION_REPORTEDTOOPTIONS_EMA] = "EMA";
translations[OPTION_REPORTEDTOOPTIONS_FDA] = "FDA";
translations[OPTION_REPORTEDTOOPTIONS_HEALTH_CANADA] = "Gezondheid Canada";
translations[OPTION_REPORTEDTOOPTIONS_PMDA_JAPAN] = "PMDA (Japan)";
translations[OPTION_REPORTEDTOOPTIONS_TUV] = "TUV";
translations[OPTION_REPORTEDTOOPTIONS_TGA_AUSTRALIA] = "TGA (Australië)";
translations[OPTION_FOLLOWINGOCCUROPTIONS_A_PET_OR_ANIMAL] = "Een huisdier of dier heeft het probleem kunnen veroorzaken";
translations[OPTION_FOLLOWINGOCCUROPTIONS_A_SHARP_OBJECT] = "Een scherp voorwerp of gereedschap werd gebruikt om de doos te openen of de beschermende verpakking";
translations[OPTION_FOLLOWINGOCCUROPTIONS_THE_PRODUCT_PROBLEM_OCCURRED] = "Het product werd blootgesteld aan overmatige kracht (d.w.z. gebonkt, gestoten, geraakt, enz.) voordat het probleem zich voordeed";
translations[OPTION_FOLLOWINGOCCUROPTIONS_THE_PRODUCT_COLD_ENVIRONMENT] = "Het product werd blootgesteld of opgeslagen in een warme / koude omgeving";
translations[OPTION_DAMAGEMINICAPOPTIONS_CARTON] = "Doos";
translations[OPTION_DAMAGEMINICAPOPTIONS_MINICAP] = "Minicap";
translations[OPTION_DAMAGEMINICAPOPTIONS_POUCH] = "Verpakking";
translations[OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_TIGHT] = "De miniset was te strak";
translations[OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_LOOSE] = "De miniset was te los";
translations[OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_CLOSE] = "De miniset kon niet volledig sluiten";
translations[OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_OPEN] = "De miniset kon niet volledig openen";
translations[OPTION_DIFFICULTTOUSEOPTIONS_THE_TWIST_CLAMP_OPEN] = "De draai klem was zo strak dat de miniset helemaal niet kon openen";
translations[OPTION_DIFFICULTTOUSEOPTIONS_THE_TWIST_LAMP_CLOSE] = "De draai klem was zo strak dat de miniset helemaal niet kon sluiten";
translations[OPTION_DIFFICULTIESMINICAPOPTIONS_YES_THERE_WAS_DAMAGE] = "Ja - er was schade aan / iets mis met de schroefdraad van de miniset waardoor deze niet goed kon sluiten";
translations[OPTION_DIFFICULTIESMINICAPOPTIONS_YES_THE_MINICAP] = "Ja - de Minicap was met de hand of met een gereedschap/hulpapparaat te strak aan de miniset bevestigd";
translations[OPTION_FLOWISSUEOPTIONS_COMPLETELY_STOPPED] = "Volledig gestopt zonder vloeistofstroom";
translations[OPTION_FLOWISSUEOPTIONS_RESTRICTED_OR_PARTIALLY] = "Beperkt of gedeeltelijk stromend (langzame stroom)";
translations[OPTION_BLOCKINGFLOWOPTIONS_CLOTTED_BLOOD] = "geklot bloed";
translations[OPTION_BLOCKINGFLOWOPTIONS_FIBRIN] = "Fibrine";
translations[OPTION_BLOCKINGFLOWOPTIONS_KINK] = "Knik";
translations[OPTION_BLOCKINGFLOWOPTIONS_PARTICULATE] = "Particulate";
translations[OPTION_BLOCKINGFLOWOPTIONS_PRODUCT_MATERIAL] = "Productmateriaal";
translations[OPTION_DESCRIBEISSUEOPTIONS_EXCESS_IODINE] = "Overtollig jodium (bruin) geïdentificeerd bij aansluiting of in de verpakking";
translations[OPTION_DESCRIBEISSUEOPTIONS_EXCESS_MOISTURE] = "Overtollig vocht (heldere druppels) geïdentificeerd in de verpakking";
translations[OPTION_DESCRIBEISSUEOPTIONS_FOIL_POUCH] = "Foilzakje beschadigd voor opening";
translations[OPTION_DESCRIBEISSUEOPTIONS_PACKAGE_BOX] = "Verpakking / doos open of beschadigd voor gebruik";
translations[OPTION_DESCRIBEISSUEOPTIONS_SPONGE_DRIED_OUT_AND_WHITE] = "Spons uitgedroogd en wit";
translations[OPTION_DESCRIBEISSUEOPTIONS_SPONGE_DRIED_OUT_BROWNISH_COLOR] = "Spons uitgedroogd met een bruinachtige kleur";
translations[OPTION_MATERIALLOCATEDOPTIONS_IN_THE_SECONDARY] = "In de secundaire verpakking/beschermende verpakking";
translations[OPTION_MATERIALLOCATEDOPTIONS_INSIDE_THE_PRODUCT_FLUID] = "Binnen het product/vloeistofpad";
translations[OPTION_MATERIALLOCATEDOPTIONS_INSIDE_THE_SHIPPING] = "binnenin de verzenddoos";
translations[OPTION_MATERIALLOCATEDOPTIONS_ON_THE_OUTSIDE_OF_PRODUCT] = "Aan de buitenkant van het product";
translations[OPTION_MATERIALLOCATEDOPTIONS_ON_THE_OUTSIDE_OF_OVERPOUCH] = "Aan de buitenkant van de secundaire verpakking/beschermende verpakking";
translations[OPTION_MATERIALLOCATEDOPTIONS_ON_THE_EXTERIOR] = "Aan de buitenkant van de verzenddoos";
translations[OPTION_CONNECTIONISSUEOPTIONS_DIFFICULTIES_CONNECTING] = "Moeilijkheden bij het verbinden van het product met een ander product";
translations[OPTION_CONNECTIONISSUEOPTIONS_DIFFICULTIES_DISCONNECTING] = "Moeilijkheden bij het loskoppelen van het product van een ander product";
translations[OPTION_CONNECTIONISSUEOPTIONS_SEPARATION_OF_COMPONENTS] = "Scheiding van componenten in een enkel product";
translations[OPTION_CONNECTIONISSUEOPTIONS_SEPARATION_DISCONNECTION] = "Scheiding/ontkoppeling van het product van een ander product";
translations[OPTION_RESIDUETHREADSOPTIONS_YES_RESIDUE] = "JA - residu op de draden";
translations[OPTION_RESIDUETHREADSOPTIONS_YES_VISIBLE] = "JA - zichtbare schade";
translations[OPTION_RESIDUETHREADSOPTIONS_YES_OTHER] = "Ja - Overig (Vrije Tekst)";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_FRANGIBLE] = "Frangible";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_HANGER_HOLE] = "Hanger Gat";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_INJECTION_FILLING_PORT] = "Injectie/Vulpoort";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_MEMBRANE_PORT] = "Membraan poort";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_OVERPOUCH_POUCH] = "Beschermende verpakking/verpakking";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_PATCH] = "Pleister";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_RUBBER_STOPPER] = "Rubber Stopper";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_SHIPPING_CARTON] = "Verzending doos";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_SHRINKBAND] = "Shrinkband";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_SOLUTION_CONTAINER] = "Oplossing container";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_TIP_PROTECTOR] = "Tip Protector";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_TAMPER_EVIDENT_SEAL] = "Tamper-evident zegel(shrink wrap)";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_BENT] = "Gebogen";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_BROKEN] = "Gebroken";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_CRACKED] = "Gebarsten";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_CUT] = "Gesneden";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_DEFORMED] = "Vervormd";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_FLAKING] = "Schilferen";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_HOLE] = "Gat";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_KINKED] = "Gekinkt";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_MELTED] = "Gesmolten";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_PATCH_LAYER_SEPARATION] = "Pleister laagjes gescheiden";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_SHATTERED_GLASS] = "Verbrijzeld (glas)";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_SLICED] = "Gesneden";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_TORN] = "Gescheurd";
translations[OPTION_FLOWISSUEOBSERVEDOPTIONS_SOLUTION_WOULD_NOT_FLOW] = "Oplossing/vloeistof zou helemaal niet stromen";
translations[OPTION_FLOWISSUEOBSERVEDOPTIONS_SOLUTION_WOULD_FLOW] = "Oplossing/vloeistof  zou heel langzaam stromen";
translations[OPTION_FLOWISSUEOBSERVEDOPTIONS_SOLUTION_WOULD_COMPOUNDING] = "Oplossing/vloeistof  zou niet stromen (of langzaam stromen) tijdens reconstitutie of compounding";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_BOTTLE] = "Fles";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_CONTAINER] = "Container";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_HANGER_HOLE] = "Hanger gat";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_LINER] = "Voering";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_OVERPOUCH_POUCH] = "Beschermende verpakking/verpakking";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_OXYGEN_INDICATOR] = "Zuurstof indicator";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_PATCH] = "Pleister";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_PORTS] = "Poorten";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_SOLUTION] = "Oplossing/vloeistof";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_TIP_PROTECTOR] = "Tip Protector";
translations[OPTION_CHAMBERDISCOLOREDOPTIONS_AMINO_ACID_CHAMBER] = "Amino Acid Kamer";
translations[OPTION_CHAMBERDISCOLOREDOPTIONS_DEXTROSE_CHAMBER] = "Dextrose Kamer";
translations[OPTION_CHAMBERDISCOLOREDOPTIONS_LIPID_CHAMBER] = "Lipid Kamer";
translations[OPTION_CHAMBERDISCOLOREDOPTIONS_LOWER_CHAMBER] = "Lage Kamer";
translations[OPTION_CHAMBERDISCOLOREDOPTIONS_UPPER_CHAMBER] = "Hoge Kamer";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_BURST_RUPTURED_SEAL] = "Gebarsten/gescheurd verzegeling";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_MISASSEMBLED_PRODUCT_PART] = "Verkeerd gemonteerd product/onderdeel";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_MISSING_COMPONENT] = "Ontbrekend component";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_SEPARATION_DISCONNECTION_OF] = "Scheiding/ontkoppeling van gebonden component(en)";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_PRODUCT_OVER_FILLED] = "Product Overgevuld";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_PRODUCT_UNDER_FILLED] = "Product Onder gevuld";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_RECONSTITUTION] = "Reconstitutie probleem";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_IN_THE_SECONDARY] = "In de secundaire verpakking/beschermende verpakking";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_INSIDE_THE_SHIPPING] = "Binnin de verzenddoos";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_EXTERIOR] = "Aan de buitenkant van de verzenddoos";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_OTHER] = "Overig (Vrije Tekst)";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_INSIDE_SOLUTION] = "Binnen de oplossing/vloeistofpad";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_INSIDE_THE_VAPORIZER] = "Binnenin de vaporizer (kijkglas)";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_XTERNAL_SURFACE] = "Op het buitenoppervlak van het product";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_OUTSIDE] = "Aan de buitenkant van de secundaire verpakking/Beschermende verpakking ";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_OXYGEN] = "Op de zuurstofabsorber";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_TRANSDERMAL] = "Op de Transdermal pleister";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_FRANGIBLE] = "Frangible";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_GLASS_PARTICLES] = "Glas deeltjes";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_PORT] = "Poort";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_RUBBER_STOPPER] = "Rubber stopper";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_TUBING] = "Slangen";
translations[OPTION_WHENMATERIALOBSERVEDOPTIONS_AFTER_ADDING_ANOTHER] = "Na het toevoegen van een ander medicijn of na reconstitutie (injectieflacons)";
translations[OPTION_WHENMATERIALOBSERVEDOPTIONS_AFTER_PRIOR_TO_SPIKING] = "Voorafgaand aan spiking of reconstitutie";
translations[OPTION_CLOUDINESSOBSERVEDOPTIONS_COLD_THAWED] = "Koud(ontdooid maar nog niet op kamertemperatuur) ";
translations[OPTION_CLOUDINESSOBSERVEDOPTIONS_FROZEN] = "Bevroren ";
translations[OPTION_CLOUDINESSOBSERVEDOPTIONS_PARTIALLY_THAWED] = "Gedeeltelijk ontdooid (ijskristallen in oplossing)";
translations[OPTION_CLOUDINESSOBSERVEDOPTIONS_ROOM_TEMPERATURE] = "Kamertemperatuur";
translations[OPTION_PRODUCTTHAWEDOPTIONS_BAXTER_THAWING] = "Baxter Thawing Unit (BTU)";
translations[OPTION_PRODUCTTHAWEDOPTIONS_LEFT_ON_COUNTER] = "Op het aanrecht bij kamertemperatuur achtergelaten";
translations[OPTION_PRODUCTTHAWEDOPTIONS_REFRIGERATOR] = "Koelkast";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_EVIDENCE] = "Ja - er was bewijs van schade tijdens verzending";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_LEAK_OBSERVED] = "Ja - er was een lek waargenomen";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_HOLE_OR_INCOMPLETE] = "Ja - er was een gat of onvolledige afsluiting in de beschermende verpakking";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_DIFFICULTY_SPIKING] = "Ja - er was problemen met spiking of reconstitutie";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_DIFFICULTY_BREAKING] = "Ja - er was moeite met het breken van de frangible";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_THERE_WAS_CRYSTALLIZATION] = "Ja - er was kristallisatie of neerslag van de oplossing/vloeistof";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_THERE_WAS_CLOUDINESS] = "Ja - er was troebelheid / verzinking in Frozen Galaxy product";
translations[OPTION_DAMAGESPECIFICINFOOPTIONS_PRODUCT_DID_NOT] = "Het product gaf niet het beoogd effect of was niet effectief (gebrek aan effect)";
translations[OPTION_DAMAGESPECIFICINFOOPTIONS_UNINTENDED_EFFECT] = "Onbedoeld effect / reactie. Gelieve te specificeren: (vrije tekst)";
translations[OPTION_SCENARIOSLEAKOPTIONS_OPTION_APPROPRIATEDESCRIPTIONOPTIONS_DAMAGED_SHIPPING] = "Beschadigde verzenddoos tijdens levering";
translations[OPTION_APPROPRIATEDESCRIPTIONOPTIONS_EXPIRED_PRODUCT_DELIVERED] = "Vervallen product geleverd";
translations[OPTION_APPROPRIATEDESCRIPTIONOPTIONS_EXPIRED_PRODUCT_FOUND] = "Vervallen product gevonden";
translations[OPTION_LABELINGISSUEOPTIONS_BARCODE_ISSUE] = "Barcodeprobleem - Onjuiste informatie weergegeven bij het scannen";
translations[OPTION_LABELINGISSUEOPTIONS_DIFFICULTIES_SCANNING] = "Difficulties scanning/unscannable Barcode";
translations[OPTION_LABELINGISSUEOPTIONS_EXPIRED_PRODUCT_DELIVERED] = "Vervallen product gelevered";
translations[OPTION_LABELINGISSUEOPTIONS_EXPIRED_PRODUCT_INVENTORY] = "Vervallen product gevonden in voorraad";
translations[OPTION_LABELINGISSUEOPTIONS_EXPIRED_ILLEGIBLE_LABEL] = "Illegible Label";
translations[OPTION_LABELINGISSUEOPTIONS_INCORRECT_LABEL] = "Incorrect label";
translations[OPTION_LABELINGISSUEOPTIONS_INCOMPLETE_LABEL] = "Incomplete Label";
translations[OPTION_LABELINGISSUEOPTIONS_ILABEL_TOO_SIMILAR] = "Label too similar to another product";
translations[OPTION_LABELINGISSUEOPTIONS_LABELS_PRODUCT] = "Labels (product, doos / doos, verzendlijst) hebben niet dezelfde productinformatie";
translations[OPTION_LABELINGISSUEOPTIONS_MISSING_BARCODE] = "Missing Barcode";
translations[OPTION_DESCOFISSUEOPTIONS_CARTON_BOX] = "Pak / doos bevat verkeerd product of gemengd product";
translations[OPTION_DESCOFISSUEOPTIONS_DAMAGED_SHIPPING] = "Beschadigde verzenddoos tijdens levering";
translations[OPTION_DESCOFISSUEOPTIONS_EXTRA_UNITS_WERE_RECEIVED] = "Extra eenheden werden ontvangen";
translations[OPTION_DESCOFISSUEOPTIONS_EXPIRED_PRODUCT_DELIVERED] = "Vervallen product geleverd";
translations[OPTION_DESCOFISSUEOPTIONS_EXPIRED_PRODUCT_FOUND] = "Vervallen product gevonden";
translations[OPTION_DESCOFISSUEOPTIONS_PART_OF_THE_CARTON] = "Deel van de doos was geopend of niet verzegeld";
translations[OPTION_DESCOFISSUEOPTIONS_PRODUCT_INFO_ON_THE_CARTON] = "Productinformatie op de doos en het distributielabel kwam niet overeen met het product in de doos";
translations[OPTION_DESCOFISSUEOPTIONS_UNITS_WERE_MISSING] = "Ontbrekende eenheden";
translations[OPTION_DESCOFISSUEOPTIONS_OTHER] = "Overig (Vrije Tekst)";
translations[OPTION_LABELINGISSUEOPTIONS_MISSING_LABEL] = "Missing Label";
translations[OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_EXPIRATION_DATE] = "Verval datum";
translations[OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_LOT_NUMBER] = "Lotnummer";
translations[OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_NDC_NUMBER] = "NDC-nummer";
translations[OPTION_MOISTUREOBSERVEDOPTIONS_DROPLETS_MOISTURE] = "Droplets / vocht binnenin beschermende verpakking zonder lek waargenomen";
translations[OPTION_MOISTUREOBSERVEDOPTIONS_LEAK] = "Lek";
translations[OPTION_MOISTUREOBSERVEDOPTIONS_LEAK_OBSERVED] = "Lek waargenomen wanneer de zak wordt geknepen";
translations[OPTION_MOISTUREOBSERVEDOPTIONS_SOLUTION_FLOWING] = "Oplossing stroomt langs de frangible";
translations[OPTION_MOISTUREOBSERVEDOPTIONS_SOLUTION_INSIDE] = "Oplossing binnen beschermende verpakking met geen lek waargenomen";
translations[OPTION_COMPONENTLEAKINGOPTIONS_BETWEEN_OVERPOUCH] = "Tussen verpakking en primaire container";
translations[OPTION_COMPONENTLEAKINGOPTIONS_CONNECTION_BETWEEN] = "Verbinding tussen twee producten";
translations[OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER_MEMBRANE] = "Container - Membraanpoort/slang";
translations[OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER_INJECTION] = "Container - Injectie-/vulpoort";
translations[OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER_HANGER] = "Container - Hangergat";
translations[OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER] = "Container";
translations[OPTION_COMPONENTLEAKINGOPTIONS_FRANGIBLE] = "Frangible";
translations[OPTION_COMPONENTLEAKINGOPTIONS_RUBBER_STOPPER] = "Rubber Stopper";
translations[OPTION_COMPONENTLEAKINGOPTIONS_SHRINKBAND] = "Shrinkband";
translations[OPTION_COMPONENTLEAKINGOPTIONS_TIP_PROTECTOR] = "Tip Protector";
translations[OPTION_COMPONENTLEAKINGOPTIONS_UNKNOWN] = "Onbekend";
translations[OPTION_COMPONENTLEAKINGOPTIONS_VIAL_ADAPTER] = "Vial Adapter";
translations[OPTION_SCENARIOSLEAKOPTIONS_ADHERED_PORT] = "Aangeraakte port";
translations[OPTION_SCENARIOSLEAKOPTIONS_DAMAGE_HOLES] = "Schade (gaten, scheuren) aan de secundaire verpakking of tussenverpakking";
translations[OPTION_SCENARIOSLEAKOPTIONS_EXPOSURE_TO_EXTREME] = "Blootstelling aan extreem warm/koud";
translations[OPTION_SCENARIOSLEAKOPTIONS_LEAK_AT_VAPORIZER] = "Lek op vaporizer interface";
translations[OPTION_SCENARIOSLEAKOPTIONS_OPENING_SHIPPING] = "Opening verzenddoos met een stanleymes/scherp voorwerp";
translations[OPTION_SCENARIOSLEAKOPTIONS_PETS_CLAWED] = "Huisdieren (klauw/gekauwd)";
translations[OPTION_SCENARIOSLEAKOPTIONS_SOLUTION_BAG_UNDER] = "Oplossingszak onder druk met een drukmanchet of ander apparaat";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_ADHERED_PORT] = "Aanhangende poort";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_DAMAGE_HOLES] = "Schade (gaten, scheuren) aan de secundaire verpakking of tussenverpakking";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_DAMAGED_SHIPPING] = "Beschadigde verzenddoos tijdens levering";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_EXPOSURE_TO_EXTREME] = "Blootstelling aan extreem warm/koud";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_LEAK_AT_VAPORIZER] = "Lek op vaporizer interface";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_OPENING_SHIPPING] = "Opening verzenddoos met een stanleymes / scherp voorwerp";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_PETS_CLAWED] = "Huisdieren (klauw/gekauwd)";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_SOLUTION_BAG_UNDER] = "Oplossingszak onder druk met een drukmanchet of ander apparaat";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_UNKNOWN] = "Onbekend ";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_NONE_OF_THE_ABOVE] = "Geen van de bovenstaande";
translations[NO_DESCRIBE_THE_COLOR] = "Nee - beschrijf de kleur (vrije tekst)";
translations[OPTION_LIQUIDSPILLEDOPTIONS_ML] = "1-10mL";
translations[OPTION_LIQUIDSPILLEDOPTIONS_GREATER_THAN_ML] = "Groter dan 10mL";
translations[OPTION_LIQUIDSPILLEDOPTIONS_LESS_THAN_ML] = "Minder dan 1mL";
translations[OPTION_VISIBLEDEFECTSOPTIONS_BOTTLE] = "Fles";
translations[OPTION_VISIBLEDEFECTSOPTIONS_CAP] = "Dop";
translations[OPTION_VISIBLEDEFECTSOPTIONS_VALVE_NECK] = "klep/hals";
translations[OPTION_VISIBLEDEFECTSOPTIONS_NONE] = "Geen";
translations[OPTION_OPTIONCONNECTIONISSUEOPTIONS_CONNECTING] = "Moeilijkheden bij het verbinden van het product met een ander product";
translations[OPTION_OPTIONCONNECTIONISSUEOPTIONS_DISCONNECTING] = "Moeilijkheden bij het loskoppelen van het product van een ander product";
translations[OPTION_OPTIONCONNECTIONISSUEOPTIONS_SEPARATION_OF_COMPONENTS] = "Scheiding van componenten in een enkel product";
translations[OPTION_OPTIONCONNECTIONISSUEOPTIONS_SEPARATION_DISCONNECTION] = "Scheiding/ontkoppeling van het product van een ander product";
translations[OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_DRIP_CHAMBER] = "Drip kamer";
translations[OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_TUBING] = "Slangen";
translations[OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_UNKNOWN] = "Onbekend";
translations[OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_OTHER_PLEASE_SPECIFY] = "Overig - Gelieve te specificeren (Vrije tekst)";
translations[OTHER_PLEASE_SPECIFY] = "Overig - Gelieve te specificeren (Vrije tekst)";
translations[OPTION_DESCRIBESDISCOLORATIONOPTIONS_WHITE_CLOUDY] = "Wit/Troebel";
translations[OPTION_DESCRIBESDISCOLORATIONOPTIONS_YELLOW_BROWNISH] = "Geel/Bruinachtig ";
translations[OPTION_DESCRIBESDISCOLORATIONOPTIONS_OTHER_PLEASE_SPECIFY] = "Overig - Gelieve te specificeren (Vrije tekst)";
translations[OPTION_WHEREMATTERLOCATEDOPTIONS_IN_THE_PRIMARY_PACKAGING] = "In de primaire verpakking/blisterverpakking";
translations[OPTION_WHEREMATTERLOCATEDOPTIONS_INSIDE_THE_IV] = "Binnen het IV-vloeistofpad (in de slang)";
translations[OPTION_WHEREMATTERLOCATEDOPTIONS_INSIDE_THE_SHIPPING] = "In de verzenddoos";
translations[OPTION_WHEREMATTERLOCATEDOPTIONS_ON_THE_EXTERIOR] = "Aan de buitenkant van de verzenddoos";
translations[OPTION_WHEREMATTERLOCATEDOPTIONS_OUTSIDE_THE_IV] = "Buiten het IV-vloeistofpad (buitenkant van de slang)";
translations[OPTION_EMBEDDEDPLASTICOPTIONS_EMBEDDED] = "Ingesloten";
translations[OPTION_EMBEDDEDPLASTICOPTIONS_LOOSE] = "Los";
translations[OPTION_EMBEDDEDPLASTICOPTIONS_NOT_APPLICABLE] = "Niet van toepassing";
translations[OPTION_INFUSATESOLUTIONOPTIONS_DESCRIBE_COLOR] = "Beschrijf Kleur (vrije tekst)";
translations[OPTION_INFUSATESOLUTIONOPTIONS_YES_CHANGE_IN_COLOR] = "Ja - Kleurwijziging ";
translations[OPTION_INFUSATESOLUTIONOPTIONS_YES_PRECIPITATE] = "Ja - Bezinking";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_ACCESS_SITE] = "Toegang site";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_BURRETTES] = "Burrettes";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_CLAMP] = "Klem";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_DRIP_CHAMBER] = "Drip Kamer";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_TUBING] = "Slangen";
translations[DAMAGECOMPONENTAFFECTEDOPTIONS_UNKNOWN] = "Onbekend";
translations[DAMAGECOMPONENTAFFECTEDOPTIONS_OTHER] = "Overig (Vrije Tekst)";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_FILTERS] = "Filters";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_LUER_CONNECTOR] = "Luer Connector";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_SPIKE] = "Spike";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_CUT_CRACKED_BROKEN] = "Gesneden/gebarsten/gebroken component(en)";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_INCORRECT_COMPONENT_ASSEMBLY] = "Onjuiste componentassemblage - Gelieve (vrije tekst) ";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_KINKED_COLLAPSED] = "Geknikt/ingeklapt component(en)";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_LOOSE_COMPONENT] = "Losse component(en) in verpakking";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_MALFORMED_MIS_SHAPED] = "Misgevormd/verkeerd gevormde component(en)";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_MISSING_COMPONENT] = "Ontbrekend component";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_DIFFICULTY_CONNECTING_THE] = "Moeilijkheid om het product met een ander product te verbinden";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_DIFFICULTY_DISCONNECTING_THE] = "Probleem met het loskoppelen van het product van een ander product";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_LOOSE_CONNECTION] = "Losse Connectie";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_SEPARATION_DISCONNECTION] = "Scheiding/ontkoppeling van het product van een ander product";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_SEPARATION_BETWEEN_TWO] = "Scheiding tussen twee verlijmde componenten in één product";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_UNABLE_TO_CONNECT] = "Kan twee producten niet met elkaar verbinden";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_UNABLE_TO_DISCONNECTT] = "Kan het product niet loskoppelen van een ander product";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_BARCODE_ISSUE] = "Barcodeprobleem - Onjuiste informatie weergegeven bij het scannen";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_CHANGE_IN_LABELING] = "Verandering in label";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_DIFFICULTIES_SCANNING] = "Moeilijkheden bij het scannen / niet-scanbare streepjescode";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_OTHER] = "Overig (Vrije Tekst)";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_EXPIRED_PRODUCT] = "Vervallen Product";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_INCORRECT_INFORMATION_ON_LABEL] = "Onjuiste informatie op de labeling";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_MISSING_BARCODE_UDI] = "Ontbrekende streepjescode /UDI";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_MISSING_INFORMATION_ON_LABEL] = "Missingsinformatie op de labeling";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_PRODUCT_WITH_NO_EXPIRATION] = "Product zonder vervaldatum";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_SMUDGES_ILLEGIBLE_LABELING] = "Vlekken / onleesbaar Label";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_CARTON_BOX] = "Karton / doos bevat verkeerd product of gemengd product";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_DAMAGED_SHIPPING] = "Beschadigde verzenddoos tijdens levering";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_EXPIRED_PRODUCT_DELIVERED] = "Vervallen product geleverd";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_EXPIRED_PRODUCT_FOUND] = "Vervallen product gevonden";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_OTHER] = "Overig (Vrije Tekst)";
translations[OPTION_ORDEREDFROMBAXTEROPTIONS_BAXTER] = "Baxter";
translations[OPTION_ORDEREDFROMBAXTEROPTIONS_DISTRIBUTOR] = "Distributeur";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_EXTRA_UNITS_WERE_RECEIVED] = "Extra-eenheden werden ontvangen";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_PART_OF_THE_CARTON] = "Deel van de doos is geopend of niet verzegeld";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_PRODUCT_INFO_ON_THE_CARTON] = "Productinformatie op de doos en het distributielabel kwam niet overeen met het product in de doos";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_UNITS_WERE_MISSING] = "Ontbrekende eenheden";
translations[OPTION_LEAKCOMINGFROMOPTIONS_ACCESS_SITE] = "Toegang Site";
translations[OPTION_LEAKCOMINGFROMOPTIONS_AIR_VENT] = "Lucht rooster";
translations[OPTION_LEAKCOMINGFROMOPTIONS_BURETTES] = "Burettes";
translations[OPTION_LEAKCOMINGFROMOPTIONS_CAP] = "Dop";
translations[OPTION_LEAKCOMINGFROMOPTIONS_CLEARLINK_INJECTION_SITES] = "Clearlink injectieplaatsen";
translations[OPTION_LEAKCOMINGFROMOPTIONS_CLAMP] = "Klem";
translations[OPTION_LEAKCOMINGFROMOPTIONS_DRIP_CHAMBER] = "Drip Kamer";
translations[OPTION_LEAKCOMINGFROMOPTIONS_FILTERS] = "Filters";
translations[OPTION_LEAKCOMINGFROMOPTIONS_INTERLINK_INJECTION_SITES] = "Interlink injectieplaatsen";
translations[OPTION_LEAKCOMINGFROMOPTIONS_LUER_CONNECTOR] = "Luer connector";
translations[OPTION_LEAKCOMINGFROMOPTIONS_SPIKE] = "Spike";
translations[OPTION_LEAKCOMINGFROMOPTIONS_TUBING] = "Slangen";
translations[OPTION_LEAKCOMINGFROMOPTIONS_UNKNOWN] = "Onbekend";
translations[OPTION_LEAKCOMINGFROMOPTIONS_OTHER] = "Overig (Vrije Tekst)";
translations[OPTION_LEAKCOMINGFROMOPTIONS_LEAK_BETWEEN_THE] = "Lek tussen de injectieplaats en slangen";
translations[OPTION_LEAKCOMINGFROMOPTIONS_NEEDLE_BASED] = "Naald afhankelijke  Injectie Plaats";
translations[OPTION_LEAKCOMINGFROMOPTIONS_ONE_LINK_INJECTION] = "One-Link injectieplaatsen";
translations[OPTION_LEAKCOMINGFROMOPTIONS_OTHER_INJECTION] = "Andere injectieplaatsen (Free Text)";
translations[OPTION_FOLLOWINGSCENARIOSOPTIONS_CRACK_BREAK_IN] = "Barst/breuk in stijve set componenten";
translations[OPTION_FOLLOWINGSCENARIOSOPTIONS_CUT_SLICE_IN] = "Cut/snijden in de zachte buis";
translations[DISCONNECTION_OF_CONNECTABLE] = "Ontkoppeling van aansluitbare componenten/aangesloten producten";
translations[OPTION_FOLLOWINGSCENARIOSOPTIONS_DISCONNECTION_OF_CONNECTABLE] = "Ontkoppeling van aansluitbare componenten/aangesloten producten";
translations[OPTION_FOLLOWINGSCENARIOSOPTIONS_SEPARATION_OF_BONDED_COMPONENTS] = "Scheiding van verlijmde componenten";
translations[OPTION_VISIBLEIRREGULARITIESOPTIONS_YES_DESCRIBE_IRREGULARITIES] = "Ja - Beschrijf onregelmatigheden/schade (vrije tekst)";
translations[YES_SPECIFY_THE_TOOL] = "Ja - Geef het gebruikte gereedschap op (Vrije tekst)";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_BACKFLOW] = "Terugflow";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_CLAMP_FAILURE_DIFFICULT] = "Klem falen - Moeilijk te klemmen (maar in staat om uiteindelijk te sluiten)";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_CLAMP_FAILURE_UNABLE] = "Klem falen - Onmogelijk om volledig af te sluiten";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_CLAMP_FAILURE_DIFFICULT_UNABLE] = "Klem Falen - Moeilijk/onmogelijk om te openen";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_NO_FLOW] = "Geen flow";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_OVER_INFUSION] = "Over infusie";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_RESTRICTED_SLOW] = "Beperkte/langzame flow";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_SIMULTANEOUS_FLOW] = "Gelijktijdige Flow ";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_UNABLE_TO_CLEAR] = "Niet in staat om component te kuisen";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_UNABLE_TO_PRIME] = "Niet in staat om te primen";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_UNDER_INFUSION] = "Onder infusie ";
translations[OPTION_FLOWINGBACKWARDSOPTIONS_PATIENTS_BLOOD] = "Patientsbloed (geen bloedproducten die worden toegediend)";
translations[OPTION_FLOWINGBACKWARDSOPTIONS_SOLUTIONS_BLOOD] = "Oplossingen/Bloedproducten";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_DAMAGE_HOLE] = "Lek schade/gat";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_DISCONNECTION] = "Onderbreking";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_LEAK] = "Lek";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_MEDICATION_WAS_BEING] = "Medicatie werd toegediend via infusies onder druk spuit, of IV-pomp";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_SECONDARY_BAG_WAS_LOWER] = "Secundaire zak was lager dan de primaire zak";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_SECONDARY_BAG_WAS_AT] = "Secundaire zak was op dezelfde hoogte met primaire zak";
translations[OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_BLOOD_CLOTTING] = "Bloedstolling";
translations[OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_CATHETER_WAS] = "Katheter kon niet worden gespoeld voordat de set werd bevestigd";
translations[OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_KINKED_TUBING] = "Gekinkte slang";
translations[OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_TUBING_INJECTION] = "Verstopping/verstopping op de injectieplaats";
translations[OPTION_SIMULTANEOUSFLOWOPTIONS_PRIMARY_AND_SECONDARY] = "Primaire en secundaire container (piggyback)";
translations[OPTION_SIMULTANEOUSFLOWOPTIONS_TWO_OR_MORE_LEADS] = "Twee of meer kabels stromen in een multi-lead set";
translations[OPTION_SIMULTANEOUSFLOWOPTIONS_TWO_ADMINISTRATION] = "Twee toedieningssets met elk een eigen infusiepomp";
translations[OPTION_HANGERUSEDOPTIONS_BAXTER_HANGER] = "Baxter Hanger";
translations[OPTION_HANGERUSEDOPTIONS_NON_BAXTER_HANGER] = "Non-Baxter Hanger";
translations[OPTION_BAGLOWEROPTIONS_BAGS_WERE_AT] = "Bags bevonden zich op dezelfde hoogte";
translations[OPTION_BAGLOWEROPTIONS_PRIMARY] = "Primair";
translations[OPTION_BAGLOWEROPTIONS_SECONDARY] = "Secundair";
translations[OPTION_YSITECONNECTEDOPTIONS_MIDDLE] = "Midden";
translations[OPTION_YSITECONNECTEDOPTIONS_LOWER] = "Laag";
translations[OPTION_YSITECONNECTEDOPTIONS_UPPER] = "Hoog";
translations[OPTION_WITHPUMPOPTIONS_YES_PROVIDE_NAME] = "Ja - Geef naam en productcode van de pomp op (vrije tekst)";
translations[OPTION_WHATCLAMPFAILEDOPTIONS_DARK_BLUE] = "Donkerblauwe schuifklem";
translations[OPTION_WHATCLAMPFAILEDOPTIONS_LIGHT_BLUE] = "Lichtblauwe schuifklem";
translations[OPTION_WHATCLAMPFAILEDOPTIONS_NOTCH_CLAMP] = "Notchklem";
translations[OPTION_WHATCLAMPFAILEDOPTIONS_ROLLER_CLAMP] = "Rolklem";
translations[OPTION_WHATCLAMPFAILEDOPTIONS_WHITE_SLIDE_CLAMP] = "Witte schuifklem";
translations[OPTION_ISSUESOBSERVEDCLAMPOPTIONS_YES_THE_CLAMP] = "Ja - de klem was kapot of gebarsten";
translations[OPTION_OTHERSITUATIONSPRODUCTOPTIONS_AIR_IN_LINE] = "Lucht in de lijn";
translations[OPTION_OTHERSITUATIONSPRODUCTOPTIONS_CLAMP_ISSUE] = "Klem probleem";
translations[OPTION_OTHERSITUATIONSPRODUCTOPTIONS_ODOR] = "Geur";
translations[OPTION_OTHERSITUATIONSPRODUCTOPTIONS_OTHER] = "Overig (Vrije Tekst)";
translations[OPTION_WHICHCLAMPISSUEOPTIONS_NOTCH_PINCH] = "Notch/Knijpklem";
translations[OPTION_WHICHCLAMPISSUEOPTIONS_ROLLER_CLAMP] = "Rolklem";
translations[OPTION_WHICHCLAMPISSUEOPTIONS_SLIDE_CLAMP] = "Schuifklem";
translations[OPTION_WHICHCLAMPISSUEOPTIONS_UNKNOWN] = "Onbekend";
translations[OPTION_WHICHCLAMPISSUEOPTIONS_OTHER] = "Overig (Vrije Tekst)";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_CRACKED_BROKEN] = "Gebarsten/gebroken";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_DIFFICULT_TO_OPEN] = "Moeilijk om te openen";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_DIFFICULT_TO_CLOSE] = "Moeilijk om te sluiten";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_MISSING] = "Ontbrekend";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNABLE_TO_OPEN] = "Kan niet openen ";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNABLE_TO_CLOSE] = "Kan niet sluiten";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNABLE_TO_CONTROL] = "Onmogelijk om te flow te reguleren";
translations[OPTION_CLAMPDESCRIBESISSUEOPTIONS_DIFFICULT_TO_SQUEEZE] = "Moeilijk om drip kamer te knijpen";
translations[OPTION_CLAMPDESCRIBESISSUEOPTIONS_INSTRUCTIONS_WERE] = "Instructies waren moeilijk te volgen /begrijpen";
translations[OPTION_CLAMPDESCRIBESISSUEOPTIONS_PRODUCT_WAS_DIFFICULT] = "Product was moeilijk te gebruiken";
translations[OPTION_LEAKOCCUROPTIONS_CRACK_BREAK] = "Barst/gebroken";
translations[OPTION_LEAKOCCUROPTIONS_CUT_SLICE] = "Cut/sneed";
translations[OPTION_LEAKOCCUROPTIONS_DISCONNECTION_OF_CONNECTABLE] = "Ontkoppeling van aansluitbare componenten/aangesloten producten";
translations[DISCONNECTION_OF_CONNECTABLE] = "Ontkoppeling van aansluitbare componenten/aangesloten producten";
translations[OPTION_LEAKOCCUROPTIONS_HOLE_TEA] = "gaatje/scheur";
translations[OPTION_LEAKOCCUROPTIONS_SEPARATION_OF_BONDED] = "Scheiding van verlijmde componenten";
translations[OPTION_LEAKOCCUROPTIONS_OTHER] = "Overig (Vrije Tekst)";
translations[OPTION_LEAKSCENARIOSOPTIONS_ADHERED_PORT] = "Aanhangende poort";
translations[OPTION_LEAKSCENARIOSOPTIONS_DAMAGE_HOLES] = "Schade (gaten, scheuren) aan de secundaire verpakking of tussenverpakking";
translations[OPTION_LEAKSCENARIOSOPTIONS_DAMAGED_SHIPPING_CARTON] = "Beschadigde verzenddoos tijdens levering";
translations[OPTION_LEAKSCENARIOSOPTIONS_EXPOSURE_TO_EXTREME] = "Blootstelling aan extreem warm/koud";
translations[OPTION_LEAKSCENARIOSOPTIONS_OPENING_SHIPPING] = "Opening verzenddoos met een stanleymes / scherp voorwerp";
translations[OPTION_LEAKSCENARIOSOPTIONS_UNKNOWN] = "Onbekend";
translations[OPTION_LEAKSCENARIOSOPTIONS_NONE_OF_THE_ABOVE] = "Geen van de bovenstaande";
translations[OPTION_LEAKSCENARIOSOPTIONS_PRESSURE_CUFF] = "Pressuurmanchet of drukinjector gebruikt";
translations[OPTION_SCENARIOSLEAKOPTIONS_ADHERED_PORT] = "Aangeraakte port";
translations[OPTION_LEAKSCENARIOSOPTIONS_PETS_CLAWED_CHEWED] = "Huisdieren (klauw/gekauwd)";
translations[OPTION_PRODUCTDAMAGEDOPTIONS_PRODUCT] = "Product";
translations[OPTION_PRODUCTDAMAGEDOPTIONS_SHIPPING_CARTON_BOX] = "Verzendingsdoos/doos";
translations[OPTION_MATTERFOREIGNLOCATEDOPTIONS_INSIDE_THE_PRODUCT] = "Binnenin het product";
translations[OPTION_MATTERFOREIGNLOCATEDOPTIONS_INSIDE_THE_SHIPPING] = "In de verzenddoos";
translations[OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_OUTSIDE_OF_PRODUCT] = "Aan de buitenkant van het product";
translations[OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_DIFFICULTIES_CONNECTING] = "Moeilijkheden bij het verbinden van het product met een ander product";
translations[OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_DIFFICULTIES_DISCONNECTING] = "Moeilijkheden bij  het loskoppelen van het product van een ander product";
translations[OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_LOOSE_CONNECTION] = "Scheiding/ontkoppeling van het product van een ander productLoose verbinding";
translations[OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_SEPARATION_OF_COMPONENTS] = "Scheiding van componenten in een enkel product";
translations[OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_SEPARATION_DISCONNECTION] = "Losse verbinding";
translations[OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_EXTERIOR] = "Aan de buitenkant van de verzenddoos";
translations[OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_INSIDE_OF] = "Aan de innenseite van de secundaire verpakking/beschermende verpakking";
translations[OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_OUTSIDE_OF] = "Aan de buitenkant van de secundaire verpakking/beschermende verpakking";
translations[OPTION_OPTIONFLOWISSUEOPTIONS_NOT_FLOWING] = "Geen flow/doorstroom";
translations[OPTION_OPTIONFLOWISSUEOPTIONS_RESTRICTED_OR] = "geen of beperkte flow/doorstroom";
translations[OPTION_OPTIONFLOWISSUEOPTIONS_OTHER] = "Overig (Vrije Tekst)";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_BARCODE_ISSUE] = "Barcodeprobleem - Onjuiste informatie weergegeven bij het scannen";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_DIFFICULTIES_SCANNING] = "Moeilijkheden bij het scannen / niet-scanbare streepjescode";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_ILLEGIBLE_LABEL] = "Onleesbaar Label";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_INCORRECT_LABEL] = "Onjuist Label";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_INCOMPLETE_LABEL] = "Onvolledig Label";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_LABELS_PRODUCT] = "Labels (product, doos / doos, verzendlijst) hebben niet dezelfde productinformatie";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_LABEL_TOO_SIMILAR] = "Label te veel vergelijkbaar met een ander product";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_MISSING_LABEL] = "Ontbrekend Label";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_MISSING_BARCODE] = "Ontbrekende streepjescode";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_OTHER] = "Overig (Vrije Tekst)";
translations[OPTION_DESCOFISSUEOPTIONS_FROZEN_PRODUCT] = "Bevroren product ontvangen";
translations[OPTION_DESCOFISSUEOPTIONS_THAWED_PRODUCT] = "Ontdooid product ontvangen";
translations[OPTION_ALARMOPTIONS_YES_ALARM_NOT_KNOWN] = "Ja, Alarm niet bekend";
translations[OPTION_ALARMOPTIONS_YES_SPECIFY] = "Ja, Specificeer";
translations[OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TRANSFER_FULLY_OPEN] = "Ja - De miniset kon niet volledig geopened worden";
translations[OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TRANSFER_FULLY_CLOSED] = "Ja - De miniset kon niet volledig gesloten worden";
translations[OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TWIST_OPEN_AT_ALL] = "De draai klem was zo strak dat de miniset helemaal niet kon openen";
translations[OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TWIST_CLOSE_AT_ALL] = "De draai klem was zo strak dat de miniset helemaal niet kon sluiten";
translations[OPTION_COMPONENTHADISSUEOPTIONS_BOX_OR_OVERPOUCH] = "Box of beschermende verpakking";
translations[OPTION_COMPONENTHADISSUEOPTIONS_BLUE_CLAMP_ON] = "Andere";
translations[OPTION_COMPONENTHADISSUEOPTIONS_CASSETT] = "Cassette";
translations[OPTION_COMPONENTHADISSUEOPTIONS_DRAIN_LINE] = "Afvoerlijnconnector en Trek Ringdop";
translations[OPTION_COMPONENTHADISSUEOPTIONS_EFFLUENT_SAMPLE] = "Tack Weld";
translations[OPTION_COMPONENTHADISSUEOPTIONS_LINES] = "Blauwe klem op Laatste lijn/Lijn voor laatste inloop";
translations[OPTION_COMPONENTHADISSUEOPTIONS_LUER_SPIKE] = "Luer/Spike connectoren";
translations[OPTION_COMPONENTHADISSUEOPTIONS_ORGANIZER] = "Lijnen";
translations[OPTION_COMPONENTHADISSUEOPTIONS_PULL_RING_PATIENT_LINE] = "Trek Ringdop / Tipbeschermer op de patientlijn";
translations[OPTION_COMPONENTHADISSUEOPTIONS_PULL_RING_PROTECTORS] = "Trek Ringdop / Tipbeschermer";
translations[OPTION_COMPONENTHADISSUEOPTIONS_RED_CLAMP_ON] = "Rode Klem op de verwarmingslijn";
translations[OPTION_COMPONENTHADISSUEOPTIONS_TACK_WELD] = "Houder";
translations[OPTION_COMPONENTHADISSUEOPTIONS_WHITE_CLAMP_ON_SUPPLY] = "Bemonsteringslocatie voor uitloopvloeistofmonsters";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_BEIGE_CATHETER] = "Beige Katheter Adapter Connector";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_CHIP_INSERT] = "Plaats Chip";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_DARK_BLUE_CONNECTOR] = "Donkerblauw Connector";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_LIGHT_BLUE_MAIN] = "Lichtblauw centraal gedeelte";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_LIGHT_BLUE_PULL] = "Lichtblauw Trek Ringdop";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_LIGHT_BLUE_OCCLUDER] = "Lichtblauw afsluiter";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_SILICONE_TUBING] = "Silicoon slang";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_TITANIUM_SPIKE] = "Titanium Spike";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_UV_FLASH_SPIKE] = "UV flash Spike";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_WHITE_TWIST_CLAMP] = "Witte Draai Klem/koppelstuk";
translations[OPTION_ANYCOMPONENTDAMAGEDOPTIONS_YES_DESCRIBE_THE_DAMAGE] = "Ja: Beschrijf de schade (vrije tekst)";
translations[OPTION_MONTHOPTIONS_JAN] = "Jan";
translations[OPTION_MONTHOPTIONS_FEB] = "Feb";
translations[OPTION_MONTHOPTIONS_MAR] = "Ma";
translations[OPTION_MONTHOPTIONS_APR] = "Apr";
translations[OPTION_MONTHOPTIONS_MAY] = "Mei";
translations[OPTION_MONTHOPTIONS_JUN] = "Jun";
translations[OPTION_MONTHOPTIONS_JUL] = "Jul";
translations[OPTION_MONTHOPTIONS_AUG] = "Aug";
translations[OPTION_MONTHOPTIONS_SEP] = "Sep";
translations[OPTION_MONTHOPTIONS_OCT] = "Okt";
translations[OPTION_MONTHOPTIONS_NOV] = "Nov";
translations[OPTION_MONTHOPTIONS_DEC] = "Dec";
translations[OPTION_PROBLEMOPTIONS_OTHER] = "Andere";
translations[OPTION_REPORTEDTOOPTIONS_OTHER] = "Witte klem op toevoerlijn";
translations[OPTION_DIFFICULTTOUSEOPTIONS_OTHER] = "Overig (Vrije Tekst)";
translations[OPTION_DIFFICULTIESMINICAPOPTIONS_OTHER] = "Overig (Vrije Tekst)";
translations[OPTION_BLOCKINGFLOWOPTIONS_OTHER] = "Overig (Vrije Tekst)";
translations[OPTION_DESCRIBEISSUEOPTIONS_OTHER] = "Overig (Vrije Tekst)";
translations[OPTION_MATERIALLOCATEDOPTIONS_OTHER] = "Overig (Vrije Tekst)";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_OTHER] = "Overig (Vrije Tekst)";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_OTHER] = "Overig (Vrije Tekst)";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_OTHER] = "Overig (Vrije Tekst)";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_OTHER] = "Overig (Vrije Tekst)";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_OTHER] = "Overig (Vrije Tekst)";
translations[OPTION_PRODUCTTHAWEDOPTIONS_OTHER] = "Overig (Vrije Tekst)";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_OTHER] = "Overig (Vrije Tekst)";
translations[OPTION_DAMAGESPECIFICINFOOPTIONS_OTHER] = "Overig (Vrije Tekst)";
translations[OPTION_APPROPRIATEDESCRIPTIONOPTIONS_OTHER] = "Overig (Vrije Tekst)";
translations[OPTION_LABELINGISSUEOPTIONS_OTHER] = "Overig (Vrije Tekst)";
translations[OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_OTHER] = "Overig (Vrije Tekst)";
translations[OPTION_MOISTUREOBSERVEDOPTIONS_OTHER] = "Overig (Vrije Tekst)";
translations[OPTION_COMPONENTLEAKINGOPTIONS_OTHER] = "Overig (Vrije Tekst)";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_OTHER] = "Overig (Vrije Tekst)";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_OTHER] = "Overig (Vrije Tekst)";
translations[OPTION_FOLLOWINGSCENARIOSOPTIONS_OTHER] = "Overig (Vrije Tekst)";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_OTHER] = "Overig (Vrije Tekst)";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_OTHER] = "Overig (Vrije Tekst)";
translations[OPTION_SIMULTANEOUSFLOWOPTIONS_OTHER] = "Overig (Vrije Tekst)";
translations[OPTION_WHATCLAMPFAILEDOPTIONS_OTHER] = "Overig (Vrije Tekst)";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_OTHER] = "Overig (Vrije Tekst)";
translations[OPTION_CLAMPDESCRIBESISSUEOPTIONS_DIFFICULT_OTHER] = "Overig (Vrije Tekst)";
translations[OPTION_PRODUCTDAMAGEDOPTIONS_OTHER] = "Overig (Vrije Tekst)";
translations[OPTION_COMPONENTHADISSUEOPTIONS_OTHER] = "Overig (Vrije Tekst)";
translations[OPTION_FOLLOWINGOCCUROPTIONS_NONE_OF_THE_ABOVE] = "Geen van de bovenstaande";
translations[OPTION_PREVIOUSLYREPORTEDOPTIONS_NO] = "Nee";
translations[OPTION_PREVIOUSLYREPORTEDOPTIONS_UNKNOWN] = "Onbekend";
translations[OPTION_PREVIOUSLYREPORTEDOPTIONS_YES] = "Ja";
translations[OPTION_ADDANOTHERFACILITYOPTIONS_NO] = "Nee";
translations[OPTION_ADDANOTHERFACILITYOPTIONS_YES] = "Ja";
translations[OPTION_PATIENINVOLVEMENTOPTIONS_NO] = "Nee";
translations[OPTION_PATIENINVOLVEMENTOPTIONS_UNKNOWN] = "Onbekend";
translations[OPTION_PATIENINVOLVEMENTOPTIONS_YES] = "Ja";
translations[OPTION_OTHERFACILITYREPORTOPTIONS_NO] = "Nee";
translations[OPTION_OTHERFACILITYREPORTOPTIONS_YES] = "Ja";
translations[OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_ASKED_UNKNOWN] = "Gevraagd maar Onbekend";
translations[OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_NO] = "Nee";
translations[OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_UNKNOWN] = "Onbekend";
translations[OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_YES] = "Ja";
translations[OPTION_AVAILABILITYOPTIONS_NO] = "Nee";
translations[OPTION_AVAILABILITYOPTIONS_YES] = "Ja";
translations[OPTION_MEDIAAVAILABILITYOPTIONS_NO] = "Nee";
translations[OPTION_MEDIAAVAILABILITYOPTIONS_YES] = "Ja";
translations[OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_NO] = "Nee";
translations[OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_UNKNOWN] = "Onbekend";
translations[OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_YES] = "Ja";
translations[OPTION_UNUSEDAVAILABILITYOPTIONS_NO] = "Nee";
translations[OPTION_UNUSEDAVAILABILITYOPTIONS_YES] = "Ja";
translations[OPTION_SELFNEGATIVEIMPACTOPTIONS_NO] = "Nee";
translations[OPTION_SELFNEGATIVEIMPACTOPTIONS_YES] = "Ja";
translations[OPTION_PATIENTNEGATIVEIMPACTOPTIONS_NO] = "Nee";
translations[OPTION_PATIENTNEGATIVEIMPACTOPTIONS_YES] = "Ja";
translations[OPTION_COUNTERACTIONOPTIONS_NO] = "Nee";
translations[OPTION_COUNTERACTIONOPTIONS_YES] = "Ja";
translations[OPTION_DRUGUSEDOPTIONS_NO] = "Nee";
translations[OPTION_DRUGUSEDOPTIONS_YES] = "Ja";
translations[OPTION_SHARECONTACTOPTIONS_NO] = "Nee";
translations[OPTION_SHARECONTACTOPTIONS_YES] = "Ja";
translations[OPTION_EXPLICITINVESTIGATIONREQUESTOPTIONS_NO] = "Nee";
translations[OPTION_EXPLICITINVESTIGATIONREQUESTOPTIONS_YES] = "Ja";
translations[OPTION_DIRECTORDEROPTIONS_NO] = "Nee";
translations[OPTION_DIRECTORDEROPTIONS_YES] = "Ja";
translations[OPTION_EXCESSIVEFORCEOPTIONS_NO] = "Nee";
translations[OPTION_EXCESSIVEFORCEOPTIONS_UNKNOWN] = "Onbekend";
translations[OPTION_EXCESSIVEFORCEOPTIONS_YES] = "Ja";
translations[OPTION_TWISTCLAMPOPTIONS_NO] = "Nee";
translations[OPTION_TWISTCLAMPOPTIONS_UNKNOWN] = "Onbekend";
translations[OPTION_TWISTCLAMPOPTIONS_YES] = "Ja";
translations[OPTION_DIFFICULTIESMINICAPOPTIONS_NO] = "Nee";
translations[OPTION_DIFFICULTIESMINICAPOPTIONS_UNKNOWN] = "Onbekend";
translations[OPTION_ENVIRONMENTOPTIONS_NO] = "Nee";
translations[OPTION_ENVIRONMENTOPTIONS_UNKNOWN] = "Onbekend";
translations[OPTION_ENVIRONMENTOPTIONS_YES] = "Ja";
translations[OPTION_SPONGEVISIBLEOPTIONS_NO] = "Nee";
translations[OPTION_SPONGEVISIBLEOPTIONS_UNKNOWN] = "Onbekend";
translations[OPTION_SPONGEVISIBLEOPTIONS_YES] = "Ja";
translations[OPTION_MATERIALEMBEDDEDOPTIONS_NO] = "Nee";
translations[OPTION_MATERIALEMBEDDEDOPTIONS_UNKNOWN] = "Onbekend";
translations[OPTION_MATERIALEMBEDDEDOPTIONS_YES] = "Ja";
translations[OPTION_PIECESMATERIALOPTIONS_NO] = "Nee";
translations[OPTION_PIECESMATERIALOPTIONS_UNKNOWN] = "Onbekend";
translations[OPTION_PIECESMATERIALOPTIONS_YES] = "Ja";
translations[OPTION_DISPOSABLECONNECTIONOPTIONS_NO] = "Nee";
translations[OPTION_DISPOSABLECONNECTIONOPTIONS_UNKNOWN] = "Onbekend";
translations[OPTION_DISPOSABLECONNECTIONOPTIONS_YES] = "Ja";
translations[OPTION_INITIALCONNECTIONOPTIONS_NO] = "Nee";
translations[OPTION_INITIALCONNECTIONOPTIONS_UNKNOWN] = "Onbekend";
translations[OPTION_INITIALCONNECTIONOPTIONS_YES] = "Ja";
translations[OPTION_SPIKELUERCONNECTORSOPTIONS_NO] = "Nee";
translations[OPTION_SPIKELUERCONNECTORSOPTIONS_UNKNOWN] = "Onbekend";
translations[OPTION_SPIKELUERCONNECTORSOPTIONS_YES] = "Ja";
translations[OPTION_PETSORANIMALSOPTIONS_NO] = "Nee";
translations[OPTION_PETSORANIMALSOPTIONS_UNKNOWN] = "Onbekend";
translations[OPTION_PETSORANIMALSOPTIONS_YES] = "Ja";
translations[OPTION_MINICAPTWISTEDOPTIONS_NO] = "Nee";
translations[OPTION_MINICAPTWISTEDOPTIONS_UNKNOWN] = "Onbekend";
translations[OPTION_MINICAPTWISTEDOPTIONS_YES] = "Ja";
translations[OPTION_TRANSFERSETOPTIONS_NO] = "Nee";
translations[OPTION_TRANSFERSETOPTIONS_UNKNOWN] = "Onbekend";
translations[OPTION_TRANSFERSETOPTIONS_YES] = "Ja";
translations[OPTION_RESIDUETHREADSOPTIONS_NO] = "Nee";
translations[OPTION_RESIDUETHREADSOPTIONS_UNKNOWN] = "Onbekend";
translations[OPTION_DAMAGECAUSELEAKOPTIONS_NO] = "Nee";
translations[OPTION_DAMAGECAUSELEAKOPTIONS_UNKNOWN] = "Onbekend";
translations[OPTION_DAMAGECAUSELEAKOPTIONS_YES] = "Ja";
translations[OPTION_SHIPPINGCARTONOPENOPTIONS_NO] = "Nee";
translations[OPTION_SHIPPINGCARTONOPENOPTIONS_UNKNOWN] = "Onbekend";
translations[OPTION_SHIPPINGCARTONOPENOPTIONS_YES] = "Ja";
translations[OPTION_ADAPTERDEVICEOPTIONS_NO] = "Nee";
translations[OPTION_ADAPTERDEVICEOPTIONS_UNKNOWN] = "Onbekend";
translations[OPTION_ADAPTERDEVICEOPTIONS_YES] = "Ja";
translations[OPTION_SQUEEZINGSOLUTIONOPTIONSS_NO] = "Nee";
translations[OPTION_SQUEEZINGSOLUTIONOPTIONSS_UNKNOWN] = "Onbekend";
translations[OPTION_SQUEEZINGSOLUTIONOPTIONSS_YES] = "Ja";
translations[OPTION_FORTHMOTIONOPTIONS_NO] = "Nee";
translations[OPTION_FORTHMOTIONOPTIONS_UNKNOWN] = "Onbekend";
translations[OPTION_FORTHMOTIONOPTIONS_YES] = "Ja";
translations[OPTION_ALARMNOFLOWOPTIONS_NO] = "Nee";
translations[OPTION_ALARMNOFLOWOPTIONS_UNKNOWN] = "Onbekend";
translations[OPTION_ALARMNOFLOWOPTIONS_YES] = "Ja";
translations[OPTION_DISCOLORATIONMARKINGSOPTIONS_NO] = "Nee";
translations[OPTION_DISCOLORATIONMARKINGSOPTIONS_UNKNOWN] = "Onbekend";
translations[OPTION_DISCOLORATIONMARKINGSOPTIONS_YES] = "Ja";
translations[OPTION_BROKENACTIVATEDOPTIONS_NO] = "Nee";
translations[OPTION_BROKENACTIVATEDOPTIONS_UNKNOWN] = "Onbekend";
translations[OPTION_BROKENACTIVATEDOPTIONS_YES] = "Ja";
translations[OPTION_vaporizerSightGlassOptions_NO] = "Nee";
translations[OPTION_vaporizerSightGlassOptions_UNKNOWN] = "Onbekend";
translations[OPTION_vaporizerSightGlassOptions_YES] = "Ja";
translations[OPTION_PRODUCTHEATOPTIONS_NO] = "Nee";
translations[OPTION_PRODUCTHEATOPTIONS_UNKNOWN] = "Onbekend";
translations[OPTION_PRODUCTHEATOPTIONS_YES] = "Ja";
translations[OPTION_DAMAGEPRIORACTIVATIONOPTIONS_NO] = "Nee";
translations[OPTION_DAMAGEPRIORACTIVATIONOPTIONS_UNKNOWN] = "Onbekend";
translations[OPTION_DAMAGEPRIORACTIVATIONOPTIONS_YES] = "Ja";
translations[OPTION_LEAKOBSERVEDOPTIONS_NO] = "Nee";
translations[OPTION_LEAKOBSERVEDOPTIONS_UNKNOWN] = "Onbekend";
translations[OPTION_LEAKOBSERVEDOPTIONS_YES] = "Ja";
translations[OPTION_EMBEDDEDINTHEPRODUCTOPTIONS_NO] = "Nee";
translations[OPTION_EMBEDDEDINTHEPRODUCTOPTIONS_UNKNOWN] = "Onbekend";
translations[OPTION_EMBEDDEDINTHEPRODUCTOPTIONS_YES] = "Ja";
translations[OPTION_WASSOLUTIONADDEDPRODUCTOPTIONS_NO] = "Nee";
translations[OPTION_WASSOLUTIONADDEDPRODUCTOPTIONS_UNKNOWN] = "Onbekend";
translations[OPTION_WASSOLUTIONADDEDPRODUCTOPTIONS_YES] = "Ja";
translations[OPTION_CLOUDINESSGOAWAYOPTIONS_NO] = "Nee";
translations[OPTION_CLOUDINESSGOAWAYOPTIONS_UNKNOWN] = "Onbekend";
translations[OPTION_CLOUDINESSGOAWAYOPTIONS_YES] = "Ja";
translations[OPTION_AGITATEUNITOPTIONS_NO] = "Nee";
translations[OPTION_AGITATEUNITOPTIONS_UNKNOWN] = "Onbekend";
translations[OPTION_AGITATEUNITOPTIONS_YES] = "Ja";
translations[OPTION_PRECIPITATEDISSOLVEOPTIONS_NO] = "Nee";
translations[OPTION_PRECIPITATEDISSOLVEOPTIONS_UNKNOWN] = "Onbekend";
translations[OPTION_PRECIPITATEDISSOLVEOPTIONS_YES] = "Ja";
translations[OPTION_TEMPERATURELOGSFREEZEROPTIONS_NO] = "Nee";
translations[OPTION_TEMPERATURELOGSFREEZEROPTIONS_UNKNOWN] = "Onbekend";
translations[OPTION_TEMPERATURELOGSFREEZEROPTIONS_YES] = "Ja";
translations[OPTION_STORAGEUNITCALIBRATEDOPTIONSS_NO] = "Nee";
translations[OPTION_STORAGEUNITCALIBRATEDOPTIONSS_UNKNOWN] = "Onbekend";
translations[OPTION_STORAGEUNITCALIBRATEDOPTIONSS_YES] = "Ja";
translations[OPTION_RECENTPRESCRIPTIONOPTIONS_NO] = "Nee";
translations[OPTION_RECENTPRESCRIPTIONOPTIONS_UNKNOWN] = "Onbekend";
translations[OPTION_RECENTPRESCRIPTIONOPTIONS_YES] = "Ja";
translations[OPTION_EXPIREDPRODUCTOPTIONS_NO] = "Nee";
translations[OPTION_EXPIREDPRODUCTOPTIONS_UNKNOWN] = "Onbekend";
translations[OPTION_EXPIREDPRODUCTOPTIONS_YES] = "Ja";
translations[OPTION_ABNORMALITIESDAMAGEOPTIONS_NO] = "Nee";
translations[OPTION_ABNORMALITIESDAMAGEOPTIONS_UNKNOWN] = "Onbekend";
translations[OPTION_ABNORMALITIESDAMAGEOPTIONS_YES] = "Ja";
translations[OPTION_OVERPOUCHPOUCHSCANNINGOPTIONS_NO] = "Nee";
translations[OPTION_OVERPOUCHPOUCHSCANNINGOPTIONS_UNKNOWN] = "Onbekend";
translations[OPTION_OVERPOUCHPOUCHSCANNINGOPTIONS_YES] = "Ja";
translations[OPTION_LABELSSAMEINFORMATIONOPTIONS_NO] = "Nee";
translations[OPTION_LABELSSAMEINFORMATIONOPTIONS_UNKNOWN] = "Onbekend";
translations[OPTION_LABELSSAMEINFORMATIONOPTIONS_YES] = "Ja";
translations[OPTION_BARCODESCANNEROPTIONS_NO] = "Nee";
translations[OPTION_BARCODESCANNEROPTIONS_UNKNOWN] = "Onbekend";
translations[OPTION_BARCODESCANNEROPTIONS_YES] = "Ja";
translations[OPTION_FRANGIBLEOBSERVEDOPTIONS_NO] = "Nee";
translations[OPTION_FRANGIBLEOBSERVEDOPTIONS_UNKNOWN] = "Onbekend";
translations[OPTION_FRANGIBLEOBSERVEDOPTIONS_YES] = "Ja";
translations[OPTION_FRANGIBLEDAMAGEDEFECTOPTIONS_NO] = "Nee";
translations[OPTION_FRANGIBLEDAMAGEDEFECTOPTIONS_UNKNOWN] = "Onbekend";
translations[OPTION_FRANGIBLEDAMAGEDEFECTOPTIONS_YES] = "Ja";
translations[OPTION_FRANGIBLEBROKENOPTIONS_NO] = "Nee";
translations[OPTION_FRANGIBLEBROKENOPTIONS_UNKNOWN] = "Onbekend";
translations[OPTION_FRANGIBLEBROKENOPTIONS_YES] = "Ja";
translations[OPTION_MOISTURECLEAROPTIONS_UNKNOWN] = "Onbekend";
translations[OPTION_MOISTURECLEAROPTIONS_YES] = "Ja";
translations[OPTION_DIFFICULTYSPIKINGOPTIONS_NO] = "Nee";
translations[OPTION_DIFFICULTYSPIKINGOPTIONS_UNKNOWN] = "Onbekend";
translations[OPTION_DIFFICULTYSPIKINGOPTIONS_YES] = "Ja";
translations[OPTION_WASFRANGIBLEDAMAGEOPTIONS_NO] = "Nee";
translations[OPTION_WASFRANGIBLEDAMAGEOPTIONS_UNKNOWN] = "Onbekend";
translations[OPTION_WASFRANGIBLEDAMAGEOPTIONS_YES] = "Ja";
translations[OPTION_PRESSURECUFFOPTIONS_NO] = "Nee";
translations[OPTION_PRESSURECUFFOPTIONS_UNKNOWN] = "Onbekend";
translations[OPTION_PRESSURECUFFOPTIONS_YES] = "Ja";
translations[OPTION_LIQUIDSPILLEDOPTIONS_UNKNOWN] = "Onbekend";
translations[OPTION_BOTTLEINTOVAPORIZEROPTIONS_NO] = "Nee";
translations[OPTION_BOTTLEINTOVAPORIZEROPTIONS_UNKNOWN] = "Onbekend";
translations[OPTION_BOTTLEINTOVAPORIZEROPTIONS_YES] = "Ja";
translations[OPTION_REMOVEDFROMPACKAGEOPTIONS_NO] = "Nee";
translations[OPTION_REMOVEDFROMPACKAGEOPTIONS_UNKNOWN] = "Onbekend";
translations[OPTION_REMOVEDFROMPACKAGEOPTIONS_YES] = "Ja";
translations[OPTION_ADDINGMEDICATIONOPTIONS_NO] = "Nee";
translations[OPTION_ADDINGMEDICATIONOPTIONS_UNKNOWN] = "Onbekend";
translations[OPTION_ADDINGMEDICATIONOPTIONS_YES] = "Ja";
translations[OPTION_PATIENTCONNECTEDPRODUCTOPTIONS_NO] = "Nee";
translations[OPTION_PATIENTCONNECTEDPRODUCTOPTIONS_UNKNOWN] = "Onbekend";
translations[OPTION_PATIENTCONNECTEDPRODUCTOPTIONS_YES] = "Ja";
translations[OPTION_WASPRODUCTREPLACEDOPTIONS_NO] = "Nee";
translations[OPTION_WASPRODUCTREPLACEDOPTIONS_UNKNOWN] = "Onbekend";
translations[OPTION_WASPRODUCTREPLACEDOPTIONS_YES] = "Ja";
translations[OPTION_WASPOWERINJECTOROPTIONS_NO] = "Nee";
translations[OPTION_WASPOWERINJECTOROPTIONS_UNKNOWN] = "Onbekend";
translations[OPTION_WASPOWERINJECTOROPTIONS_YES] = "Ja";
translations[OPTION_INJECTIONSITEOPENINGOPTIONS_NO] = "Nee";
translations[OPTION_INJECTIONSITEOPENINGOPTIONS_UNKNOWN] = "Onbekend";
translations[OPTION_INJECTIONSITEOPENINGOPTIONS_YES] = "Ja";
translations[OPTION_INJECTIONSITEOPENINGOPTIONS_OTHER] = "Overig (Vrije Tekst)";
translations[OPTION_VISIBLEIRREGULARITIESOPTIONS_NO] = "Nee";
translations[OPTION_VISIBLEIRREGULARITIESOPTIONS_UNKNOWN] = "Onbekend";
translations[OPTION_EVENTUALLYESTABLISHEDOPTIONS_NO] = "Nee";
translations[OPTION_EVENTUALLYESTABLISHEDOPTIONS_UNKNOWN] = "Onbekend";
translations[OPTION_EVENTUALLYESTABLISHEDOPTIONS_YES] = "Ja";
translations[OPTION_TOOLUSEDASSISTOPTIONS_NO] = "Nee";
translations[OPTION_TOOLUSEDASSISTOPTIONS_UNKNOWN] = "Onbekend";
translations[OPTION_SECUREPRIORUSEOPTIONS_NO] = "Nee";
translations[OPTION_SECUREPRIORUSEOPTIONS_UNKNOWN] = "Onbekend";
translations[OPTION_SECUREPRIORUSEOPTIONS_YES] = "Ja";
translations[OPTION_PRIORDISCONNECTINGOPTIONS_NO] = "Nee";
translations[OPTION_PRIORDISCONNECTINGOPTIONS_UNKNOWN] = "Onbekend";
translations[OPTION_PRIORDISCONNECTINGOPTIONS_YES] = "Ja";
translations[OPTION_FLOWPREVIOUSLYSEENOPTIONS_NO] = "Nee";
translations[OPTION_FLOWPREVIOUSLYSEENOPTIONS_UNKNOWN] = "Onbekend";
translations[OPTION_FLOWPREVIOUSLYSEENOPTIONS_YES] = "Ja";
translations[OPTION_YSITECONNECTEDOPTIONS_UNKNOWN] = "Onbekend";
translations[OPTION_COMPONENTSETREPLACEDOPTIONS_NO] = "Nee";
translations[OPTION_COMPONENTSETREPLACEDOPTIONS_UNKNOWN] = "Onbekend";
translations[OPTION_COMPONENTSETREPLACEDOPTIONS_YES] = "Ja";
translations[OPTION_WITHPUMPOPTIONS_NO] = "Nee";
translations[OPTION_WITHPUMPOPTIONS_UNKNOWN] = "Onbekend";
translations[OPTION_CLAMPFAILOPTIONS_NO] = "Nee";
translations[OPTION_CLAMPFAILOPTIONS_UNKNOWN] = "Onbekend";
translations[OPTION_CLAMPFAILOPTIONS_YES] = "Ja";
translations[OPTION_ISSUESOBSERVEDCLAMPOPTIONS_NO] = "Nee";
translations[OPTION_ISSUESOBSERVEDCLAMPOPTIONS_UNKNOWN] = "Onbekend";
translations[OPTION_WASMATERIALEMBEDDEDOPTIONS_NO] = "Nee";
translations[OPTION_WASMATERIALEMBEDDEDOPTIONS_UNKNOWN] = "Onbekend";
translations[OPTION_WASMATERIALEMBEDDEDOPTIONS_YES] = "Ja";
translations[OPTION_APPEARPRODUCTMATERIALOPTIONS_NO] = "Nee";
translations[OPTION_APPEARPRODUCTMATERIALOPTIONS_UNKNOWN] = "Onbekend";
translations[OPTION_APPEARPRODUCTMATERIALOPTIONS_YES] = "Ja";
translations[OPTION_SHIPPINGCARTONDAMAGEDOPTIONS_NO] = "Nee";
translations[OPTION_SHIPPINGCARTONDAMAGEDOPTIONS_UNKNOWN] = "Onbekend";
translations[OPTION_SHIPPINGCARTONDAMAGEDOPTIONS_YES] = "Ja";
translations[OPTION_GELPACKSOPTIONS_NO] = "Nee";
translations[OPTION_GELPACKSOPTIONS_YES] = "Ja";
translations[OPTION_EXPIREDPRODUCTUSEOPTIONS_NO] = "Nee";
translations[OPTION_EXPIREDPRODUCTUSEOPTIONS_UNKNOWN] = "Onbekend";
translations[OPTION_EXPIREDPRODUCTUSEOPTIONS_YES] = "Ja";
translations[OPTION_ALARMOPTIONS_NO] = "Nee";
translations[OPTION_ALARMOPTIONS_UNKNOWN] = "Onbekend";
translations[OPTION_CLEANINGSOLUTIONSOPTIONS_NO] = "Nee";
translations[OPTION_CLEANINGSOLUTIONSOPTIONS_UNKNOWN] = "Onbekend";
translations[OPTION_CLEANINGSOLUTIONSOPTIONS_YES] = "Ja";
translations[OPTION_DIFFICULTINTWISTCLAMPOPTIONS_NO] = "Nee";
translations[OPTION_DIFFICULTINTWISTCLAMPOPTIONS_UNKNOWN] = "Onbekend";
translations[OPTION_TRANSFERREPLACEDOPTIONS_NO] = "Nee";
translations[OPTION_TRANSFERREPLACEDOPTIONS_UNKNOWN] = "Onbekend";
translations[OPTION_TRANSFERREPLACEDOPTIONS_YES] = "Ja";
translations[OPTION_FULLYTIGHTENEDOPTIONS_NO] = "Nee";
translations[OPTION_FULLYTIGHTENEDOPTIONS_UNKNOWN] = "Onbekend";
translations[OPTION_FULLYTIGHTENEDOPTIONS_YES] = "Ja";
translations[OPTION_ANYCOMPONENTDAMAGEDOPTIONSS_NO] = "Nee";
translations[OPTION_ANYCOMPONENTDAMAGEDOPTIONSS_UNKNOWN] = "Onbekend";
translations[OPTION_ISSUERESULTLEAKOPTIONS_NO] = "Nee";
translations[OPTION_ISSUERESULTLEAKOPTIONS_UNKNOWN] = "Onbekend";
translations[OPTION_ISSUERESULTLEAKOPTIONS_YES] = "Ja";
translations[OPTION_ISSUERESULTLEAKOPTIONS_OTHER] = "Overig (Vrije Tekst)";
translations[OPTION_SAMPLESAVAILABLEFOREVALUATIONOPTIONS_NO] = "Nee";
translations[OPTION_SAMPLESAVAILABLEFOREVALUATIONOPTIONS_YES] = "Ja";
translations[OPTION_EXPLICITLYREQUESTOPTIONS_NO] = "Nee";
translations[OPTION_EXPLICITLYREQUESTOPTIONS_UNKNOWN] = "Onbekend";
translations[OPTION_EXPLICITLYREQUESTOPTIONS_YES] = "Ja";
translations[OPTION_WEREPATIENTUSINGPRODUCTOPTIONS_NO] = "Nee";
translations[OPTION_WEREPATIENTUSINGPRODUCTOPTIONS_UNKNOWN] = "Onbekend";
translations[OPTION_WEREPATIENTUSINGPRODUCTOPTIONS_YES] = "Ja";
translations[OPTION_PATIENINVOLVEMENTOPTIONS_ASKED_UNKNOWN] = "Gevraagd maar Onbekend";
translations[OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_ASKED_UNKNOWN] = "Gevraagd maar Onbekend";
translations[OPTION_CHAMBERDISCOLOREDOPTIONS_UNKNOWN] = "Onbekend";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_UNKNOWN] = "Onbekend";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_NO] = "Nee";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_UNKNOWN] = "UNK";
translations[OPTION_SCENARIOSLEAKOPTIONS_UNKNOWN] = "Onbekend";
translations[OPTION_SCENARIOSLEAKOPTIONS_NONE_OF_THE_ABOVE] = "Geen van de bovenstaande";
translations[OPTION_MOISTURECLEAROPTIONS_NO_DESCRIBE_THE_COLOR] = "Nee - beschrijf de kleur (vrije tekst)";
translations[OPTION_EMBEDDEDPLASTICOPTIONS_UNKNOWN] = "Onbekend";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_UNKNOWN] = "Onbekend";
translations[OPTION_TOOLUSEDASSISTOPTIONS_YES_SPECIFY_THE_TOOL] = "Ja - Geef het gebruikte gereedschap op (Vrije tekst)";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_SEPARATION] = "Afscheiding";
translations[OPTION_HANGERUSEDOPTIONS_UNKNOWN] = "Onbekend";
translations[OPTION_HANGERUSEDOPTIONS_NONE] = "Geen";
translations[OPTION_BAGLOWEROPTIONS_UNKNOWN] = "Onbekend";
translations[OPTION_ISSUESOBSERVEDCLAMPOPTIONS_YES_OTHER] = "Ja - Overig (Vrije Tekst)";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNKNOWN] = "Onbekend";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_NO] = "Nee";
translations[OPTION_WEIGHTUNITOPTIONS_KILOGRAM] = "Kilogram";
translations[OPTION_WEIGHTUNITOPTIONS_POUND] = "Pond";
translations[OPTION_INFUSATESOLUTIONOPTIONS_NO] = "Nee";
translations[OPTION_INFUSATESOLUTIONOPTIONS_UNKNOWN] = "Onbekend";
translations[PLEASE_ENTER_THE_VALUE] = "Voer de waarde in";
translations[PLEASE_SELECT_THE_VALUE] = "Selecteer waarde alsjeblieft";
translations[PLEASE_SELECT_THE_DATE] = "Selecteer de datum";
translations[PLEASE_CHOOSE_THE_VALUE] = "Kies de waarde";
translations[OPTION_MEDIAAVAILABILITYOPTIONS_UNKNOWN] = "Onbekend";
translations[OPTION_COUNTRYOPTIONS_GREAT_BRITAIN] = "GROOT-BRITTANNIË";
translations[OPTION_COUNTRYOPTIONS_KOSOVO] = "KOSOVO";
translations[OPTION_COUNTRYOPTIONS_NORTHERN_IRELAND] = "NOORD-IERLAND";
translations[OPTION_COUNTRYOPTIONS_AFGHANISTAN] = "AFGHANISTAN";
translations[OPTION_COUNTRYOPTIONS_ÅLAND_ISLANDS] = "ÅLAND EILANDEN";
translations[OPTION_COUNTRYOPTIONS_ALBANIA] = "ALBANIË";
translations[OPTION_COUNTRYOPTIONS_ALGERIA] = "ALGERIJE";
translations[OPTION_COUNTRYOPTIONS_AMERICAN_SAMOA] = "AMERIKAANS-SAMOA";
translations[OPTION_COUNTRYOPTIONS_ANDORRA] = "ANDORRA";
translations[OPTION_COUNTRYOPTIONS_ANGOLA] = "ANGOLA";
translations[OPTION_COUNTRYOPTIONS_ANGUILLA] = "ANGUILLA";
translations[OPTION_COUNTRYOPTIONS_ANTARCTICA] = "ANTARCTICA";
translations[OPTION_COUNTRYOPTIONS_ANTIGUA_AND_BARBUDA] = "ANTIGUA EN BARBUDA";
translations[OPTION_COUNTRYOPTIONS_ARGENTINA] = "ARGENTINIË";
translations[OPTION_COUNTRYOPTIONS_ARMENIA] = "ARMENIË";
translations[OPTION_COUNTRYOPTIONS_ARUBA] = "ARUBA";
translations[OPTION_COUNTRYOPTIONS_AUSTRALIA] = "AUSTRALIË";
translations[OPTION_COUNTRYOPTIONS_AUSTRIA] = "OOSTENRIJK";
translations[OPTION_COUNTRYOPTIONS_AZERBAIJAN] = "AZERBEIDZJAN";
translations[OPTION_COUNTRYOPTIONS_BAHAMAS] = "BAHAMAS";
translations[OPTION_COUNTRYOPTIONS_BAHRAIN] = "BAHREIN";
translations[OPTION_COUNTRYOPTIONS_BANGLADESH] = "BANGLADESH";
translations[OPTION_COUNTRYOPTIONS_BARBADOS] = "BARBADOS";
translations[OPTION_COUNTRYOPTIONS_BELARUS] = "WIT-RUSLAND";
translations[OPTION_COUNTRYOPTIONS_BELGIUM] = "BELGIË";
translations[OPTION_COUNTRYOPTIONS_BELIZE] = "BELIZE";
translations[OPTION_COUNTRYOPTIONS_BENIN] = "BENIN";
translations[OPTION_COUNTRYOPTIONS_BERMUDA] = "BERMUDA";
translations[OPTION_COUNTRYOPTIONS_BHUTAN] = "BHUTAN";
translations[OPTION_COUNTRYOPTIONS_BOLIVIA] = "BOLIVIA";
translations[OPTION_COUNTRYOPTIONS_BOSNIA_AND_HERZEGOVINA] = "BOSNIË-HERZEGOVINA";
translations[OPTION_COUNTRYOPTIONS_BOTSWANA] = "BOTSWANA";
translations[OPTION_COUNTRYOPTIONS_BOUVET_ISLAND] = "BOUVET EILAND";
translations[OPTION_COUNTRYOPTIONS_BRAZIL] = "BRAZILIË";
translations[OPTION_COUNTRYOPTIONS_BRITISH_INDIAN_OCEAN_TERRITORY] = "BRITS TERRITORIUM IN DE INDISCHE OCEAAN";
translations[OPTION_COUNTRYOPTIONS_BRUNEI_DARUSSALAM] = "BRUNEI DARUSSALAM";
translations[OPTION_COUNTRYOPTIONS_BULGARIA] = "BULGARIJE";
translations[OPTION_COUNTRYOPTIONS_BURKINA_FASO] = "BURKINA FASO";
translations[OPTION_COUNTRYOPTIONS_BURUNDI] = "BURUNDI";
translations[OPTION_COUNTRYOPTIONS_CAMBODIA] = "CAMBODJA";
translations[OPTION_COUNTRYOPTIONS_CAMEROON] = "KAMEROEN";
translations[OPTION_COUNTRYOPTIONS_CANADA] = "CANADA";
translations[OPTION_COUNTRYOPTIONS_CAPE_VERDE] = "KAAPVERDIË";
translations[OPTION_COUNTRYOPTIONS_CAYMAN_ISLANDS] = "CAYMANEILANDEN";
translations[OPTION_COUNTRYOPTIONS_CENTRAL_AFRICAN_REPUBLIC] = "CENTRAAL-AFRIKAANSE REPUBLIEK";
translations[OPTION_COUNTRYOPTIONS_CHAD] = "TSJAAD";
translations[OPTION_COUNTRYOPTIONS_CHILE] = "CHILI";
translations[OPTION_COUNTRYOPTIONS_CHINA] = "CHINA";
translations[OPTION_COUNTRYOPTIONS_CHRISTMAS_ISLAND] = "CHRISTMASEILAND";
translations[OPTION_COUNTRYOPTIONS_COCOS_KEELING_ISLANDS] = "COCOSEILANDEN";
translations[OPTION_COUNTRYOPTIONS_COLOMBIA] = "COLOMBIA";
translations[OPTION_COUNTRYOPTIONS_COMOROS] = "COMOREN";
translations[OPTION_COUNTRYOPTIONS_CONGO] = "CONGO";
translations[OPTION_COUNTRYOPTIONS_CONGO_THE_DEMOCRATIC_REPUBLIC_OF_THE] = "CONGO, DE DEMOCRATISCHE REPUBLIEK VAN DE";
translations[OPTION_COUNTRYOPTIONS_COOK_ISLANDS] = "COOKEILANDEN";
translations[OPTION_COUNTRYOPTIONS_COSTA_RICA] = "COSTA RICA";
translations[OPTION_COUNTRYOPTIONS_CÔTE_DIVOIRE_IVORY_COAST] = "IVOORKUST";
translations[OPTION_COUNTRYOPTIONS_CROATIA] = "KROATIË";
translations[OPTION_COUNTRYOPTIONS_CUBA] = "CUBA";
translations[OPTION_COUNTRYOPTIONS_CYPRUS] = "CYPRUS";
translations[OPTION_COUNTRYOPTIONS_CZECH_REPUBLIC] = "TSJECHISCHE REPUBLIEK";
translations[OPTION_COUNTRYOPTIONS_DENMARK] = "DENEMARKEN";
translations[OPTION_COUNTRYOPTIONS_DJIBOUTI] = "DJIBOUTI";
translations[OPTION_COUNTRYOPTIONS_DOMINICA] = "DOMINICA";
translations[OPTION_COUNTRYOPTIONS_DOMINICAN_REPUBLIC] = "DOMINICAANSE REPUBLIEK";
translations[OPTION_COUNTRYOPTIONS_ECUADOR] = "ECUADOR";
translations[OPTION_COUNTRYOPTIONS_EGYPT] = "EGYPTE";
translations[OPTION_COUNTRYOPTIONS_EL_SALVADOR] = "EL SALVADOR";
translations[OPTION_COUNTRYOPTIONS_EQUATORIAL_GUINEA] = "EQUATORIAAL-GUINEA";
translations[OPTION_COUNTRYOPTIONS_ERITREA] = "ERITREA";
translations[OPTION_COUNTRYOPTIONS_ESTONIA] = "ESTLAND";
translations[OPTION_COUNTRYOPTIONS_ETHIOPIA] = "ETHIOPIË";
translations[OPTION_COUNTRYOPTIONS_FALKLAND_ISLANDS_MALVINAS] = "FALKLANDEILANDEN (MALVINAS)";
translations[OPTION_COUNTRYOPTIONS_FAROE_ISLANDS] = "FAERÖEREILANDEN";
translations[OPTION_COUNTRYOPTIONS_FIJI] = "FIJI";
translations[OPTION_COUNTRYOPTIONS_FINLAND] = "FINLAND";
translations[OPTION_COUNTRYOPTIONS_FRANCE] = "FRANKRIJK";
translations[OPTION_COUNTRYOPTIONS_FRENCH_GUIANA] = "FRANS-GUYANA";
translations[OPTION_COUNTRYOPTIONS_FRENCH_POLYNESIA] = "FRANS-POLYNESIË";
translations[OPTION_COUNTRYOPTIONS_FRENCH_SOUTHERN_TERRITORIES] = "FRANSE ZUIDELIJKE GEBIEDEN";
translations[OPTION_COUNTRYOPTIONS_GABON] = "GABON";
translations[OPTION_COUNTRYOPTIONS_GAMBIA] = "GAMBIA";
translations[OPTION_COUNTRYOPTIONS_GEORGIA] = "GEORGIË";
translations[OPTION_COUNTRYOPTIONS_GERMANY] = "DUITSLAND";
translations[OPTION_COUNTRYOPTIONS_GHANA] = "GHANA";
translations[OPTION_COUNTRYOPTIONS_GIBRALTAR] = "GIBRALTAR";
translations[OPTION_COUNTRYOPTIONS_GREECE] = "GRIEKENLAND";
translations[OPTION_COUNTRYOPTIONS_GREENLAND] = "GROENLAND";
translations[OPTION_COUNTRYOPTIONS_GRENADA] = "GRENADA";
translations[OPTION_COUNTRYOPTIONS_GUADELOUPE] = "GUADELOUPE";
translations[OPTION_COUNTRYOPTIONS_GUAM] = "GUAM";
translations[OPTION_COUNTRYOPTIONS_GUATEMALA] = "GUATEMALA";
translations[OPTION_COUNTRYOPTIONS_GUERNSEY] = "GUERNSEY";
translations[OPTION_COUNTRYOPTIONS_GUINEA] = "GUINEE";
translations[OPTION_COUNTRYOPTIONS_GUINEA_BISSAU] = "GUINEE-BISSAU";
translations[OPTION_COUNTRYOPTIONS_GUYANA] = "GUYANA";
translations[OPTION_COUNTRYOPTIONS_HAITI] = "HAÏTI";
translations[OPTION_COUNTRYOPTIONS_HEARD_ISLAND_AND_MCDONALD_ISLANDS] = "HEARD ISLAND EN MCDONALD EILANDEN";
translations[OPTION_COUNTRYOPTIONS_HOLY_SEE_VATICAN_CITY_STATE] = "HEILIGE STOEL (VATICAANSTAD)";
translations[OPTION_COUNTRYOPTIONS_HONDURAS] = "HONDURAS";
translations[OPTION_COUNTRYOPTIONS_HONG_KONG] = "HONGKONG";
translations[OPTION_COUNTRYOPTIONS_HUNGARY] = "HONGARIJE";
translations[OPTION_COUNTRYOPTIONS_ICELAND] = "IJSLAND";
translations[OPTION_COUNTRYOPTIONS_INDIA] = "INDIA";
translations[OPTION_COUNTRYOPTIONS_INDONESIA] = "INDONESISCH";
translations[OPTION_COUNTRYOPTIONS_IRAN_ISLAMIC_REPUBLIC_OF] = "IRAN, ISLAMITISCHE REPUBLIEK";
translations[OPTION_COUNTRYOPTIONS_IRAQ] = "IRAK";
translations[OPTION_COUNTRYOPTIONS_IRELAND] = "IERLAND";
translations[OPTION_COUNTRYOPTIONS_ISLE_OF_MAN] = "EILAND MAN";
translations[OPTION_COUNTRYOPTIONS_ISRAEL] = "ISRAËL";
translations[OPTION_COUNTRYOPTIONS_ITALY] = "ITALIË";
translations[OPTION_COUNTRYOPTIONS_JAMAICA] = "JAMAICA";
translations[OPTION_COUNTRYOPTIONS_JAPAN] = "JAPAN";
translations[OPTION_COUNTRYOPTIONS_JERSEY] = "JERSEY";
translations[OPTION_COUNTRYOPTIONS_JORDAN] = "JORDANIË";
translations[OPTION_COUNTRYOPTIONS_KAZAKHSTAN] = "KAZACHSTAN";
translations[OPTION_COUNTRYOPTIONS_KENYA] = "KENIA";
translations[OPTION_COUNTRYOPTIONS_KIRIBATI] = "KIRIBATI";
translations[OPTION_COUNTRYOPTIONS_KOREA_DEMOCRATIC_PEOPLES_REPUBLIC_OF] = "KOREA, DEMOCRATISCHE VOLKSREPUBLIEK KOREA";
translations[OPTION_COUNTRYOPTIONS_KOREA_REPUBLIC_OF] = "KOREA, REPUBLIEK";
translations[OPTION_COUNTRYOPTIONS_KUWAIT] = "KOEWEIT";
translations[OPTION_COUNTRYOPTIONS_KYRGYZSTAN] = "KIRGIZIË";
translations[OPTION_COUNTRYOPTIONS_LAO_PEOPLES_DEMOCRATIC_REPUBLIC] = "DEMOCRATISCHE VOLKSREPUBLIEK LAOS";
translations[OPTION_COUNTRYOPTIONS_LATVIA] = "LETLAND";
translations[OPTION_COUNTRYOPTIONS_LEBANON] = "LIBANON";
translations[OPTION_COUNTRYOPTIONS_LESOTHO] = "LESOTHO";
translations[OPTION_COUNTRYOPTIONS_LIBERIA] = "LIBERIA";
translations[OPTION_COUNTRYOPTIONS_LIBYAN_ARAB_JAMAHIRIYA] = "LIBISCH-ARABISCHE JAMAHIRIYA";
translations[OPTION_COUNTRYOPTIONS_LIECHTENSTEIN] = "LIECHTENSTEIN";
translations[OPTION_COUNTRYOPTIONS_LITHUANIA] = "LITOUWEN";
translations[OPTION_COUNTRYOPTIONS_LUXEMBOURG] = "LUXEMBURG";
translations[OPTION_COUNTRYOPTIONS_MACAO] = "MACAO";
translations[OPTION_COUNTRYOPTIONS_MACEDONIA_THE_FORMER_YUGOSLAV_REPUBLIC_OF] = "MACEDONIË, DE VOORMALIGE JOEGOSLAVISCHE REPUBLIEK";
translations[OPTION_COUNTRYOPTIONS_MADAGASCAR] = "MADAGASKAR";
translations[OPTION_COUNTRYOPTIONS_MALAWI] = "MALAWI";
translations[OPTION_COUNTRYOPTIONS_MALAYSIA] = "MALEISIË";
translations[OPTION_COUNTRYOPTIONS_MALDIVES] = "MALDIVEN";
translations[OPTION_COUNTRYOPTIONS_MALI] = "MALI";
translations[OPTION_COUNTRYOPTIONS_MALTA] = "MALTA";
translations[OPTION_COUNTRYOPTIONS_MARSHALL_ISLANDS] = "MARSHALLEILANDEN";
translations[OPTION_COUNTRYOPTIONS_MARTINIQUE] = "MARTINIQUE";
translations[OPTION_COUNTRYOPTIONS_MAURITANIA] = "MAURITANIË";
translations[OPTION_COUNTRYOPTIONS_MAURITIUS] = "MAURITIUS";
translations[OPTION_COUNTRYOPTIONS_MAYOTTE] = "MAYOTTE";
translations[OPTION_COUNTRYOPTIONS_MEXICO] = "MEXICO";
translations[OPTION_COUNTRYOPTIONS_MICRONESIA_FEDERATED_STATES_OF] = "MICRONESIË, FEDERALE STATEN VAN";
translations[OPTION_COUNTRYOPTIONS_MOLDOVA] = "MOLDAVIË";
translations[OPTION_COUNTRYOPTIONS_MONACO] = "MONACO";
translations[OPTION_COUNTRYOPTIONS_MONGOLIA] = "MONGOLIË";
translations[OPTION_COUNTRYOPTIONS_MONTENEGRO] = "MONTENEGRO";
translations[OPTION_COUNTRYOPTIONS_MONTSERRAT] = "MONTSERRAT";
translations[OPTION_COUNTRYOPTIONS_MOROCCO] = "MAROKKO";
translations[OPTION_COUNTRYOPTIONS_MOZAMBIQUE] = "MOZAMBIQUE";
translations[OPTION_COUNTRYOPTIONS_MYANMAR] = "MYANMAR";
translations[OPTION_COUNTRYOPTIONS_NAMIBIA] = "NAMIBIË";
translations[OPTION_COUNTRYOPTIONS_NAURU] = "NAURU";
translations[OPTION_COUNTRYOPTIONS_NEPAL] = "NEPAL";
translations[OPTION_COUNTRYOPTIONS_NETHERLANDS] = "NEDERLAND";
translations[OPTION_COUNTRYOPTIONS_NEW_CALEDONIA] = "NIEUW-CALEDONIË";
translations[OPTION_COUNTRYOPTIONS_NEW_ZEALAND] = "NIEUW-ZEELAND";
translations[OPTION_COUNTRYOPTIONS_NICARAGUA] = "NICARAGUA";
translations[OPTION_COUNTRYOPTIONS_NIGER] = "NIGER";
translations[OPTION_COUNTRYOPTIONS_NIGERIA] = "NIGERIA";
translations[OPTION_COUNTRYOPTIONS_NIUE] = "NIUE";
translations[OPTION_COUNTRYOPTIONS_NORFOLK_ISLAND] = "NORFOLK";
translations[OPTION_COUNTRYOPTIONS_NORTHERN_MARIANA_ISLANDS] = "NOORDELIJKE MARIANEN";
translations[OPTION_COUNTRYOPTIONS_NORWAY] = "NOORWEGEN";
translations[OPTION_COUNTRYOPTIONS_OMAN] = "OMAN";
translations[OPTION_COUNTRYOPTIONS_PAKISTAN] = "PAKISTAN";
translations[OPTION_COUNTRYOPTIONS_PALAU] = "PALAU";
translations[OPTION_COUNTRYOPTIONS_PALESTINIAN_TERRITORY_OCCUPIED] = "PALESTIJNSE GEBIEDEN, BEZET";
translations[OPTION_COUNTRYOPTIONS_PANAMA] = "PANAMA";
translations[OPTION_COUNTRYOPTIONS_PAPUA_NEW_GUINEA] = "PAPOEA-NIEUW-GUINEA";
translations[OPTION_COUNTRYOPTIONS_PARAGUAY] = "PARAGUAY";
translations[OPTION_COUNTRYOPTIONS_PERU] = "PERU";
translations[OPTION_COUNTRYOPTIONS_PHILIPPINES] = "FILIPIJNEN";
translations[OPTION_COUNTRYOPTIONS_PITCAIRN] = "PITCAIRN";
translations[OPTION_COUNTRYOPTIONS_POLAND] = "POLEN";
translations[OPTION_COUNTRYOPTIONS_PORTUGAL] = "PORTUGAL";
translations[OPTION_COUNTRYOPTIONS_PUERTO_RICO] = "PUERTO RICO";
translations[OPTION_COUNTRYOPTIONS_QATAR] = "QATAR";
translations[OPTION_COUNTRYOPTIONS_RÉUNION] = "RÉUNION";
translations[OPTION_COUNTRYOPTIONS_ROMANIA] = "ROEMENIË";
translations[OPTION_COUNTRYOPTIONS_RUSSIAN_FEDERATION] = "RUSLAND";
translations[OPTION_COUNTRYOPTIONS_RWANDA] = "RWANDA";
translations[OPTION_COUNTRYOPTIONS_SAINT_BARTHÉLEMY] = "SAINT-BARTHÉLEMY";
translations[OPTION_COUNTRYOPTIONS_SAINT_HELENA] = "SINT-HELENA";
translations[OPTION_COUNTRYOPTIONS_SAINT_KITTS_AND_NEVIS] = "SAINT KITTS EN NEVIS";
translations[OPTION_COUNTRYOPTIONS_SAINT_LUCIA] = "SAINT LUCIA";
translations[OPTION_COUNTRYOPTIONS_SAINT_MARTIN] = "SINT MAARTEN";
translations[OPTION_COUNTRYOPTIONS_SAINT_PIERRE_AND_MIQUELON] = "SAINT PIERRE EN MIQUELON";
translations[OPTION_COUNTRYOPTIONS_SAINT_VINCENT_AND_THE_GRENADINES] = "SAINT VINCENT EN DE GRENADINES";
translations[OPTION_COUNTRYOPTIONS_SAMOA] = "SAMOA";
translations[OPTION_COUNTRYOPTIONS_SAN_MARINO] = "SAN MARINO";
translations[OPTION_COUNTRYOPTIONS_SAO_TOME_AND_PRINCIPE] = "SAO TOMÉ EN PRINCIPE";
translations[OPTION_COUNTRYOPTIONS_SAUDI_ARABIA] = "SAUDI-ARABIË";
translations[OPTION_COUNTRYOPTIONS_SENEGAL] = "SENEGAL";
translations[OPTION_COUNTRYOPTIONS_SERBIA] = "SERVIË";
translations[OPTION_COUNTRYOPTIONS_SEYCHELLES] = "SEYCHELLEN";
translations[OPTION_COUNTRYOPTIONS_SIERRA_LEONE] = "SIERRA LEONE";
translations[OPTION_COUNTRYOPTIONS_SINGAPORE] = "SINGAPORE";
translations[OPTION_COUNTRYOPTIONS_SLOVAKIA] = "SLOWAKIJE";
translations[OPTION_COUNTRYOPTIONS_SLOVENIA] = "SLOVENIË";
translations[OPTION_COUNTRYOPTIONS_SOLOMON_ISLANDS] = "SALOMONSEILANDEN";
translations[OPTION_COUNTRYOPTIONS_SOMALIA] = "SOMALIË";
translations[OPTION_COUNTRYOPTIONS_SOUTH_AFRICA] = "ZUID-AFRIKA";
translations[OPTION_COUNTRYOPTIONS_SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS] = "ZUID-GEORGIË EN DE ZUIDELIJKE SANDWICHEILANDEN";
translations[OPTION_COUNTRYOPTIONS_SPAIN] = "SPANJE";
translations[OPTION_COUNTRYOPTIONS_SRI_LANKA] = "SRI LANKA";
translations[OPTION_COUNTRYOPTIONS_SUDAN] = "SOEDAN";
translations[OPTION_COUNTRYOPTIONS_SURINAME] = "SURINAME";
translations[OPTION_COUNTRYOPTIONS_SVALBARD_AND_JAN_MAYEN] = "SPITSBERGEN EN JAN MAYEN";
translations[OPTION_COUNTRYOPTIONS_SWAZILAND] = "SWAZILAND";
translations[OPTION_COUNTRYOPTIONS_SWEDEN] = "ZWEDEN";
translations[OPTION_COUNTRYOPTIONS_SWITZERLAND] = "ZWITSERLAND";
translations[OPTION_COUNTRYOPTIONS_SYRIAN_ARAB_REPUBLIC] = "SYRISCHE ARABISCHE REPUBLIEK";
translations[OPTION_COUNTRYOPTIONS_TAIWAN_ROC] = "TAIWAN, R.O.C.";
translations[OPTION_COUNTRYOPTIONS_TAJIKISTAN] = "TADZJIKISTAN";
translations[OPTION_COUNTRYOPTIONS_TANZANIA_UNITED_REPUBLIC_OF] = "TANZANIA, VERENIGDE REPUBLIEK";
translations[OPTION_COUNTRYOPTIONS_THAILAND] = "THAILAND";
translations[OPTION_COUNTRYOPTIONS_TIMOR_LESTE] = "OOST-TIMOR";
translations[OPTION_COUNTRYOPTIONS_TOGO] = "TOGO";
translations[OPTION_COUNTRYOPTIONS_TOKELAU] = "TOKELAU";
translations[OPTION_COUNTRYOPTIONS_TONGA] = "TONGA";
translations[OPTION_COUNTRYOPTIONS_TRINIDAD_AND_TOBAGO] = "TRINIDAD ENTOBAGO";
translations[OPTION_COUNTRYOPTIONS_TUNISIA] = "TUNESIË";
translations[OPTION_COUNTRYOPTIONS_TURKEY] = "TURKIJE";
translations[OPTION_COUNTRYOPTIONS_TURKMENISTAN] = "TURKMENISTAN";
translations[OPTION_COUNTRYOPTIONS_TURKS_AND_CAICOS_ISLANDS] = "TURKS- EN CAICOSEILANDEN";
translations[OPTION_COUNTRYOPTIONS_TUVALU] = "TUVALU";
translations[OPTION_COUNTRYOPTIONS_UGANDA] = "OEGANDA";
translations[OPTION_COUNTRYOPTIONS_UKRAINE] = "OEKRAÏNE";
translations[OPTION_COUNTRYOPTIONS_UNITED_ARAB_EMIRATES] = "VERENIGDE ARABISCHE EMIRATEN";
translations[OPTION_COUNTRYOPTIONS_UNITED_KINGDOM] = "VERENIGD KONINKRIJK";
translations[OPTION_COUNTRYOPTIONS_UNITED_STATES] = "VERENIGDE STATEN";
translations[OPTION_COUNTRYOPTIONS_UNITED_STATES_MINOR_OUTLYING_ISLANDS] = "KLEINE AFGELEGEN EILANDEN VAN DE VERENIGDE STATEN";
translations[OPTION_COUNTRYOPTIONS_URUGUAY] = "URUGUAY";
translations[OPTION_COUNTRYOPTIONS_UZBEKISTAN] = "OEZBEKISTAN";
translations[OPTION_COUNTRYOPTIONS_VANUATU] = "VANUATU";
translations[OPTION_COUNTRYOPTIONS_VENEZUELA] = "VENEZUELA";
translations[OPTION_COUNTRYOPTIONS_VIET_NAM] = "VIETNAM";
translations[OPTION_COUNTRYOPTIONS_VIRGIN_ISLANDS_BRITISH] = "MAAGDENEILANDEN, BRITS";
translations[OPTION_COUNTRYOPTIONS_VIRGIN_ISLANDS_US] = "MAAGDENEILANDEN, VS";
translations[OPTION_COUNTRYOPTIONS_WALLIS_AND_FUTUNA] = "WALLIS EN FUTUNA";
translations[OPTION_COUNTRYOPTIONS_WESTERN_SAHARA] = "WESTELIJKE SAHARA";
translations[OPTION_COUNTRYOPTIONS_YEMEN] = "JEMEN";
translations[OPTION_COUNTRYOPTIONS_ZAMBIA] = "ZAMBIA";
translations[OPTION_COUNTRYOPTIONS_ZIMBABWE] = "ZIMBABWE";
translations[OPTION_DOESTHEPARTICULATEMATTER_NO] = "Nee";
translations[OPTION_DOESTHEPARTICULATEMATTER_UNKNOWN] = "Onbekend";
translations[OPTION_DOESTHEPARTICULATEMATTER_YES] = "Ja";
translations[I_HAVE_READ_AND_UNDERSTAND_THE_LINKED_PRIVACY_NOTICE] = "Ik heb de gekoppelde privacyverklaring voor het Baxter Product Feedback Portal gelezen en begrepen.";
translations[PRODUCT_LOT] = "Product Lot nummer";
translations[SHIPPING_DISTRIBUTION_LABEL] = "Verzend-/distributielabel";
translations[CARTON_LABEL] = "Kartonnen etiket";
translations[INTERNAL_PRODUCT_LABEL] = "Intern productlabel";
translations[TITLE_PD_RENAL] = "PD Nier";
translations[TITLE_SOLUTIONS] = "Oplossingen";
translations[TITLE_ACCESS] = "Toegang";
translations[TITLE_ALL_OTHER_PRODUCT] = "Alle andere producten";
translations[REPORTED_PROBLEM] = "Probleem gemeld";
translations[LOGIN] = "Log in";
translations[SYSTEM_MENU] = "Systeemmenu";
translations[INITIATE_PRODUCT_FEEDBACK] = "Start Product Feedback";
translations[FEEDBACK_STATUS] = "Feedbackstatus";
translations[OKTACALLBACK] = "OkéTerugbellen";
translations[VALID_EMAIL] = "Voer een geldig e-mailadres in";
translations[VALID_NUMERIC] = "Gelieve een geheel getal in te geven.";
translations[PLEASE_UPLOAD_IMAGE] = "Upload afbeelding(en)";
translations[VALID_DATE] = "Selecteer een geldige datum alstublieft";
translations[QUANTITY] = "Aantal";
translations[EDIT] = "Bewerk";
translations[DELETE] = "Verwijderen";
translations[LOT_SERIAL_NO] = "Lot/Serie nr";
translations[LOT_NUMBER_NOT_FOUND] = "Lotnummer niet gevonden";
translations[SEARCHING_LOT_NUMBER] = "Lotnummer zoeken";
translations[PRODUCT_CODE_NOT_FOUND] = "Productcode niet gevonden";
translations[SEARCHING_PRODUCT_CODE] = "Productcode zoeken";
translations[FILE_OF_TYPES_ARE_NOT_ALLOWED] = "Bestandstypen (.asa, .asax, .bat, .cer, .cmd, .docm, .exe, .img, .iso, .js, .php, .php5, .pht, .phtml, .ps1, .py, .rar,  .scr, .shtml, .swf, .vbs, .xap, .xml, .xps) zijn niet toegestaan";
translations[THE_FILE_YOU_ARE_ATTEMPTING] = "Het bestand dat u probeert bij te voegen, overschrijdt de opslaglimiet. Comprimeer of voeg een ander bestand toe.";
translations[IMAGE_ICON] = "Klik op het afbeeldingspictogram om de optie te selecteren";
translations[LOGIN_TO_ACCOUNT] = "Log in op Account";
translations[SIGN_IN_TO_YOUR_ACCOUNT] = "Meld u aan bij uw account";
translations[BAXTER_EMAIL_ADDRESS] = "Baxter e-mailadres";
translations[PASSWORD] = "Wachtwoord";
translations[SIGN_IN] = "Log in";
translations[UNKNOWN] = "Onbekend";
translations[ASKED_UNKNOWN] = "Gevraagd maar Onbekend";
translations[DD_MMM_YYYY] = "DD-MMM-YYYY";
translations[DD] = "DD";
translations[MMM] = "MMM";
translations[YYYY] = "YYYY";
translations[SELECT_COUNTRY] = "Selecteer Land";
translations[CHINESE_SIMPLIFIED_CHINESE] = "Chinees (Vereenvoudigd Chinees)";
translations[DUTCH] = "Nederlands";
translations[ENGLISH] = "Engels";
translations[FRENCH] = "Frans";
translations[GERMAN] = "Duits";
translations[ITALIAN] = "Italiaans";
translations[JAPANESE] = "Japanees";
translations[KOREAN] = "Koreaans";
translations[MANDARIN_TRADITIONAL_CHINESE] = "Mandarijns (Traditioneel Chinees)";
translations[POLISH] = "Pools";
translations[PORTUGUESE] = "Portugees";
translations[SPANISH] = "Spaans";
translations[THAI] = "Thais";
translations[TURKISH] = "Turks";
translations[VIETNAMESE] = "Vietnamees";
translations[BROWSE] = "Bladeren";
translations[FEEDBACK_SUBMITTED] = "Feedback ingediend";
translations[YOUR_PRODUCT_EXPERIENCE_FEEDBACK] = "Uw feedback over de productervaring is verzonden. Bedankt voor de melding. U ontvangt een e-mail met een referentienummer.  Als leverancier van medische producten is klanttevredenheid en feedback over ons product essentieel voor ons doel om producten van de hoogste kwaliteit te leveren. Neem contact op  ";
translations[IF_YOU_HAVE_QUESTIONS_OR_ADDITIONAL_INFORMATION] = "als u vragen of aanvullende informatie heeft.";
translations[CLOSE] = "Dichtbij";
translations[PATIENT_AGE] = "Leeftijd van de patiënt";
translations[ENTER_AGE] = "Voer leeftijd in";
translations[PATIENT_DOB] = "Geboorte datum de patiënt";
translations[RELEVANT_ATTACHMENTS] = "Gelieve alle relevante bijlage/documentatie toe te voegen";
translations[BAXTER_ACCOUNT_CREDENTIALS] = "Voer uw Baxter accountgegevens in";
translations[GET_PRODUCT_DETAILS] = "Productdetails ophalen";
translations[USE_THE_DIAGRAM_ABOVE_FIGURE_2] = "Gebruik het bovenstaande diagram (figuur 2) om de locatie van het gemelde probleem te bepalen";
translations[FACILITY_ADDRESS] = "Adres van de Faciliteit";
translations[LABEL_ANOTHER_FACILITY_ADDRESS] = "Een ander faciliteit adres";
translations[CHOOSE_PRODUCT_CODE] = "Kies productcode voor het ingevoerde Lot-/serienummer";
translations[DECLINE] = "Weigeren";
translations[OPTION_COUNTRYOPTIONS_BONAIRE_SINT_EUSTATIUS_AND_SABA] = "BONAIRE, SINT EUSTATIUS EN SABA";
translations[OPTION_COUNTRYOPTIONS_CURAÇAO] = "CURACAO";
translations[OPTION_COUNTRYOPTIONS_SOUTH_SUDAN] = "ZUID SOEDAN";
translations[OPTION_COUNTRYOPTIONS_ESWATINI] = "ESWATINI";
translations[FORM_HELP_TEXT] = "geeft aan dat er helptekst beschikbaar is voor dit veld";
translations[YOUR_FIRST_NAME] = "Uw voornnaam";
translations[YOUR_LAST_NAME] = "Uw achternaam";
translations[MY_FIRST_NAME] = "Mijn voornaam";
translations[MY_LAST_NAME] = "Mijn achternaam";
translations[PATIENT_FIRST_NAME] = "Voornaam van de patiënt";
translations[PATIENT_LAST_NAME] = "Achternaam van de patiënt";
translations[REPORTER_FIRST_NAME] = "Voornaam verslaggever";
translations[REPORTER_LAST_NAME] = "Achternaam verslaggever";
translations[EMPLOYEE_FIRST_NAME] = "Voornaam werknemer";
translations[EMPLOYEE_LAST_NAME] = "Achternaam werknemer";
translations[END_USER_CUSTOMER_FIRST_NAME] = "Voornaam contactpersoon eindgebruiker/klant";
translations[END_USER_CUSTOMER_LAST_NAME] = "Achternaam contactpersoon eindgebruiker/klant";
translations[ADDITIONAL_CONTACT_FIRST_NAME] = "Aanvullende voornaam contactpersoon";
translations[ADDITIONAL_CONTACT_LAST_NAME] = "Aanvullende achternaam contactpersoon";
translations[COPYRIGHT] = "Auteursrecht ©";
translations[COPYRIGHT_BAXTER] = "Baxter";
translations[COPYRIGHT_VERSION] = "Alle rechten voorbehouden | Versie";
translations[ADD_ADDITIONAL_CONTACT] = "Extra contactpersoon toevoegen";
translations[CONTACT_ME] = "De klant wenst niet gecontacteerd te worden. Contacteer me voor eventuele aanvullende vragen.";
translations[DO_NOT_CONTACT] = "Contacteer me niet";
translations[END_USER_CUSTOMER_FACILITY_NAME] = "Naam eindgebruiker/klantfaciliteit";
translations[END_USER_CUSTOMER_PHONE] = "Telefoonnummer eindgebruiker/klantfaciliteit";
translations[END_USER_CUSTOMER_EMAIL] = "E-mailadres eindgebruiker/klant";
translations[END_USER_CUSTOMER_FACILITY_ADDRESS] = "Adres eindgebruiker/klantfaciliteit";
translations[SAME_AS_PATIENT_ADDRESS] = "Hetzelfde als Adres patiënt";
translations[SAME_AS_REPORTER_ADDRESS] = "Hetzelfde als adres van de Klant";
translations[SAME_AS_END_USER_CUSTOMER_ADDRESS] = "Hetzelfde als adres eindgebruiker/klantfaciliteit";
translations[USE_THE_DIAGRAM_ABOVE_FIGURE_3] = "Gebruik de bovenstaande diagram (figuur 3) om de locatie van het gemelde probleem te bepalen";
translations[CONTACT_US] = "Neem contact met ons op";
translations[LANDING_BRIEF_FOR_DEVICE] = "Neem voor reparaties, onderdelen, onderhoud of technische ondersteuning contact op met uw lokale technische ondersteuningsdienst.";
translations[PATIENT_SEX] = "Patiënt seks";
translations[OPTION_PATIENTGENDEROPTIONS_CISGENDER_CISGENDER_MAN_BOY] = "Cisgender man/jongen";
translations[OPTION_PATIENTGENDEROPTIONS_CISGENDER_CISGENDER_WOMAN_GIRL] = "Cisgender vrouw/meisje";
translations[OPTION_PATIENTGENDEROPTIONS_CISGENDER_TRANSGENDER_MAN_TRANS_MAN_FEMALE_TO_MALE_FTM] = "Transgender man/trans man/vrouw-naar-man";
translations[OPTION_PATIENTGENDEROPTIONS_CISGENDER_TRANSGENDER_WOMAN_TRANS_WOMAN_MALE_TO_FEMALE_MTF] = "Transgendervrouw/transvrouw/man-naar-vrouw";
translations[OPTION_PATIENTGENDEROPTIONS_CISGENDER_OTHER_GENDER_CATEGORY_PLEASE_SPECIFY] = "Andere geslachtscategorie; gelieve te specificeren";
translations[OPTION_PATIENTGENDEROPTIONS_CISGENDER_DECLINE_TO_ANSWER] = "Weigeren te antwoorden";
translations[ATTENTION_NEEDED] = "!!! DRINGENDE AANDACHT NODIG: Uw inzending voor het Product Feedback Portal is MISLUKT!";
translations[SUBMIT_ERR_MSG] = "Om opnieuw in te dienen, klikt u op OK en vervolgens op Verzenden of, stuurt u uw klacht per e-mail naar (@@@).";
translations[SUBMIT_RETRY_MSG] = "Als u opnieuw een aanvraag hebt ingediend, controleer dan of u een bevestigingsmail hebt ontvangen in uw e-mailbox van het Product Feedback Portal. Als er geen bevestigingsmail is ontvangen, is de indiening niet gelukt en MOET u uw klacht e-mailen naar (@@@).";
translations[OK] = "OK";

export default lang;